{
    "recordWorkflow": {
        "title": "Record a Workflow",
        "description": "Show Cephable how you do a task — narrate out loud as you click through it — and it becomes a reusable skill.",
        "cardDescription": "Record yourself doing a task to teach Cephable how to do it.",
        "goalLabel": "Recording description",
        "goalPlaceholder": "What are you about to demonstrate? (optional)",
        "start": "Start Recording",
        "recording": "Recording your workflow",
        "stepCount": "{{count}} steps",
        "stopAndCreate": "Stop & Create Skill",
        "creating": "Turning your recording into a skill…",
        "permissionNeeded": "Cephable needs Accessibility / Input Monitoring permission to record what you do. Grant it in System Settings, then start again.",
        "noMic": "Microphone unavailable — recording your actions without narration.",
        "startError": "Could not start recording.",
        "noSteps": "No actions were captured to turn into a skill.",
        "stopReminder": "Keep going as long as you need. When the task is done, come back here and press Stop & Create Skill.",
        "callout": {
            "title": "Teach Cephable one of your tasks",
            "description": "Do a task once while Cephable watches and narrate what you are doing. It turns into a skill you can run any time.",
            "action": "Show me how",
            "dismiss": "Not now",
            "badge": "Try it",
            "compactDescription": "Do a task once while Cephable watches and it becomes a skill you can run any time.",
            "compactAction": "Record a workflow"
        },
        "coach": {
            "title": "Before you record",
            "progress": "Tip {{current}} of {{total}}",
            "ready": "I'm ready",
            "skip": "Skip the tips",
            "reopen": "How this works",
            "steps": {
                "pickTask": {
                    "title": "Pick one real task",
                    "body": "Choose something you actually do, and plan to run it start to finish in one sitting. A short, complete task teaches far more than a long, half-finished one.",
                    "example": "This is how I file my weekly expense report — open it, fill it in, submit it."
                },
                "narrate": {
                    "title": "Talk the whole way through",
                    "body": "Say what you are doing and why, out loud, the way you would if a new coworker were watching over your shoulder. Your narration is what Cephable turns into the steps.",
                    "example": "Now I'm opening the invoice in Outlook so I can find the PO number."
                },
                "goSlow": {
                    "title": "Click deliberately, one thing at a time",
                    "body": "Wait for each page or app to finish loading before the next click, and name what you are clicking. Skip anything private — passwords and card numbers do not belong in a skill.",
                    "example": "I'm clicking Approve in the top right, and waiting for the confirmation to appear."
                },
                "explainRules": {
                    "title": "Say the rules out loud",
                    "body": "Call out anything that changes from run to run and what you would do differently, so the skill can handle more than just today.",
                    "example": "If there's no PO number, I skip the spreadsheet and email the vendor instead."
                },
                "comeBack": {
                    "title": "Come back and press Stop",
                    "body": "Cephable keeps recording until you say so. When the task is done, return to this panel and press Stop & Create Skill. If it hears nothing and sees no clicks for a minute, it will stop for you.",
                    "example": "That's the whole thing — done."
                }
            }
        },
        "idle": {
            "title": "Still recording",
            "body": "No clicks and nothing said for a while. If you have finished the task, press Stop & Create Skill.",
            "countdown": "Stopping automatically in {{seconds}}s.",
            "keepGoing": "I'm still working",
            "autoStopped": "Recording stopped on its own after a minute of quiet."
        },
        "teachAction": "Teach Cephable a workflow"
    },
    "availableToInstall": "Available to install",
    "deviceCommandThrottled": {
        "macroLength": "This connection does not allow long macros. Your macro has been shortened automatically.",
        "commandCount": "This connection limits how fast you can send commands. Please wait and try again soon.",
        "incompatibleActions": "This control contains actions that can't be used together and was not sent."
    },
    "logo": "Cephable logo",
    "appControlsPanel": {
        "searchPlaceholder": "Search commands...",
        "searchLabel": "Search commands",
        "favorites": {
            "title": "Favorites",
            "description": "Favorites are controls that you use often. You can mark a command as a favorite by clicking the star icon next to it."
        },
        "globalCommands": "Global",
        "noCommandsFound": "No commands found",
        "prefixCommandToast": "This is a prefix command — say or type the prefix followed by the phrase to trigger it."
    },
    "add": "Add",
    "all": "All",
    "edit": "Edit",
    "create": "Create",
    "delete": "Delete",
    "previous": "Previous",
    "next": "Next",
    "collapse": "Collapse",
    "sidebar": {
        "collapse": "Collapse sidebar",
        "expand": "Expand sidebar"
    },
    "search": "Search",
    "loading": "Loading...",
    "reload": "Reload",
    "cancel": "Cancel",
    "copy": "Copy",
    "send": "Send",
    "save": "Save",
    "reset": "Reset",
    "deprecated": "Deprecated",
    "saveAndFinish": "Save and Finish",
    "saveAndContinue": "Save and Continue",
    "saved": "Saved",
    "saveError": "Error saving changes.",
    "done": "Done",
    "back": "Back",
    "noResults": "No results",
    "noResultsSearch": "No results found for your search.",
    "interrupted": "Interrupted",
    "play": "Play",
    "pause": "Pause",
    "resume": "Resume",
    "success": "Success",
    "continue": "Continue",
    "options": "Options",
    "share": "Share",
    "finish": "Finish",
    "error": "Error",
    "description": "Description",
    "expand": "Expand",
    "expandMenu": "Expand Menu",
    "finishEdit": "Finish Edit",
    "advancedOptions": "View Advanced Options",
    "authenticating": "Authenticating...",
    "skipToMain": "Skip to Main Content",
    "skip": "Skip",
    "close": "Close",
    "notFound": "Page Not Found",
    "notFoundDescription": "Oh noes! We have searched the sea and we can't find thee page!",
    "exitSetup": "Exit Setup",
    "experimental": "Experimental",
    "letGetStarted": "Let's get started!",
    "exploreInputControls": "Explore Input Controls",
    "when": "When I ...",
    "thenMacro": "Cephable will run...",
    "controls": "Controls",
    "welcome": "Welcome.",
    "beta": "beta",
    "macroEmpty": "There are no macros matching this criteria.",
    "you": "You",
    "step": "Step",
    "steps": "Steps",
    "learnMore": "Learn More",
    "dangerZone": "Danger Zone",
    "connected": "Connected",
    "notConnected": "Not Connected",
    "connectAndLearn": "Connect & Learn",
    "tryAgain": "Try Again",
    "by": "By: {{value}}",
    "noName": "- no name -",
    "details": "Details",
    "controlFeed": "Control Feed",
    "upgrade": "Upgrade",
    "purchase": "Purchase",
    "results": "Results",
    "explore": "Explore",
    "created": "Created: {{value}}",
    "updated": "Updated: {{value}}",
    "deleted": "Deleted: {{value}}",
    "expires": "Expires: {{value}}",
    "expired": "Expired: {{value}}",
    "used": "Used: {{value}}",
    "uses": "Uses: {{value}}",
    "generate": "Generate",
    "stop": "Stop",
    "on": "On",
    "off": "Off",
    "copied": "Copied",
    "clear": "Clear",
    "rewrite": "Rewrite",
    "translate": "Translate",
    "summarize": "Summarize",
    "inputMethod": "Input Method: ",
    "info": "More Information",
    "view": "View",
    "control": "Control",
    "automate": "Automate",
    "mobileApp": {
        "title": "Mobile App"
    },
    "dashboard": {
        "title": "Workspace"
    },
    "publicTag": "Public",
    "invalidNumber": "N/A",
    "wifi": {
        "disconnected": "Wi-Fi is disconnected.",
        "connected": "Wi-Fi is connected.",
        "description": "Connect to Wi-Fi to enable Cephable to work with your connections and software. You may have limited ability to use your current controls. "
    },
    "signalR": {
        "disconnected": "Syncing is disconnected.",
        "description": "There appears to be a problem with Cephable syncing. This will cause issues saving your settings or communicating with other connections.",
        "action": "Reconnect",
        "disconnectedDevice": "Unable to sync with {{name}}.",
        "disconnectedDeviceDescription": "There appears to be a problem with syncing either because of authentication or internet connectivity. You can not remotely send or receive data. You need to check both sides of the connection.",
        "connected": "Syncing is connected.",
        "connectedDescription": "Cephable is syncing properly and should be communicating with your connections and extensions as expected.",
        "swap": "Swap to local device connection",
        "unlinkedDevice": "Connection removed.",
        "unlinkedDeviceDescription": "This connection has been unlinked from your account.",
        "featureRestricted": "Create & Automate are unavailable for remote connections.",
        "featureRestrictedDescription": "This feature is not currently available for remote connections. Please switch to the local device connection to get all of the power to create and automate your work."
    },
    "billing": {
        "title": "Billing",
        "expires": "Next Billing: {{value}}",
        "description": "Manage your organization billing, seats, subscription upgrades, renewal, or cancellation.",
        "error": "Please contact your system administrator to manage your billing.",
        "view": "Manage Billing",
        "included": "Included with your {{licenseType}} license.",
        "mostPopular": "Most Popular",
        "upgrade": {
            "description": "Upgrade now and take your controls to the next level.",
            "longDescription": "Upgrade to a paid license to unlock all of the features of Cephable. From multiple devices, to advanced controls, to custom integrations, Cephable has everything you need to take you to the next level of productivity.",
            "action": "Upgrade Now",
            "compare": "Compare Plans",
            "error": "Error upgrading. Please try again later.",
            "requiredDetail": "A {{licenseType}} license is required for this feature. You can always upgrade or start a free trial in your Account Settings.",
            "enableTextGeneration": "Upgrade to generate, edit, and translate content using our Intelligent Tasks.",
            "enableAiWorkflows": "Upgrade to automate your desktop and browser tasks with AI Workflows.",
            "enableAiDictation": {
                "title": "Upgrade to Intelligent Dictation",
                "description": "Upgrade to unlock AI enhanced dictation. I can add punctuation, fix capitalization, and adapt to your style so your writing looks polished without extra effort."
            }
        },
        "isPlusAccess": {
            "short": "Plus",
            "title": "Plus",
            "titleLong": "Cephable Plus",
            "description": "Cephable Plus is for power users who want to push more with intelligent voice, intelligent dictation, 100's of app controls, and more.",
            "supportedFeatures": {
                "tag": "Everything in Basic, plus",
                "features": [
                    "Intelligent Voice Controls (Natural Language)",
                    "Intelligent Dictation (AI Enhanced)",
                    "Intelligent Tasks  (Generation, Translation, Rewriting)",
                    "100's of Pre-trained App Controls"
                ]
            }
        },
        "isEmployeeAccess": {
            "short": "Pro",
            "title": "Professional",
            "titleLong": "Cephable Professional",
            "description": "Cephable professional empowers users with more productivity power, extending the local, private AI to generative capabilities.",
            "supportedFeatures": {
                "tag": "Everything in Plus, plus",
                "features": [
                    "On-device AI Workflows",
                    "Enterprise organization management",
                    "Enterprise restrictions",
                    "Unlimited Device Installs",
                    "Unlimited Pre-trained App Controls"
                ]
            }
        },
        "personal": {
            "short": "Basic",
            "title": "Basic",
            "titleLong": "Cephable Basic",
            "description": "Cephable Basic is free forever and built to help you move faster, express yourself, and get stuff done—your way. Features included in basic are available to all users.",
            "upgrade": {
                "title": "Take your controls to the next level",
                "description": "Upgrade to Plus or Pro to unlock all of my features. More accuracy. More connections. More controls. More power to take your productivity to the next level.",
                "featureHeading": "Here's how I can help you:",
                "control": "I move you through apps and tools faster using your voice or quick actions — no broken flow. With Intelligent Voice we can just chat.",
                "create": "I rewrite, dictate, generate, and translate directly inside your apps — no copying, pasting, or screen switching needed.",
                "automate": "I run intelligent tasks and quick actions that speed up your workflow. From simple commands to complex macros, I can do the heavy lifting so you can focus on the work that matters.",
                "local": "All local AI. No cloud processing."
            }
        },
        "isDeveloperAccess": {
            "short": "SDK",
            "title": "SDK",
            "titleLong": "Cephable SDK",
            "description": "Cephable SDKs let you integrate powerful adaptive controls— voice, face, head, and more into your software with minimal lift and maximum payoff.",
            "supportedFeatures": {
                "tag": "Everything in Plus, plus",
                "features": [
                    "Windows and MacOS support",
                    "Lightweight, embeddable SDKs for offline voice, face, head, and quick action input",
                    "API/webhook support for custom output actions",
                    "Developer docs",
                    "Sample projects",
                    "Turn commands into document automation and navigation",
                    "Developer Portal for managing your projects, auth clients, device types, and more"
                ]
            }
        },
        "isStudentAccess": {
            "short": "Edu",
            "title": "Student",
            "titleLong": "Cephable Education",
            "description": "Cephable Education supports personalized learning and inclusive classrooms. Cephable works offline, runs on-device, and requires no third-party integrations.",
            "supportedFeatures": {
                "tag": "Everything in Plus, plus",
                "features": [
                    "Unlimited device installs",
                    "Unlimited pre-trained app controls",
                    "Unlimited sharing of custom app controls"
                ]
            }
        },
        "isResellerAccess": {
            "short": "Reseller",
            "title": "Reseller",
            "titleLong": "Cephable Reseller",
            "description": "Cephable Reseller is a paid license that allows you to create new organizations and assign license keys. This includes using Cephable with your own software suite and improving your user experience."
        },
        "viewProducts": "View Products",
        "subscription": {
            "options": "Subscription Options",
            "monthly": "Pay Monthly",
            "billedMonthly": "/month",
            "yearly": "Pay Yearly",
            "billedYearly": "/year"
        }
    },
    "organization": {
        "title": "Organization",
        "titlePlural": "Organizations",
        "titleLong": "Cephable Professional for Organizations",
        "description": "Organizations are groups of users who can collaborate on projects and share resources. You can manage your team, team profiles, billing and more here.",
        "viewOrganization": "View Organization",
        "orgName": "Organization Name",
        "orgCustomBillingUrl": {
            "title": "Custom Billing URL",
            "description": "This is a custom URL that will be used to redirect the user to your (the reseller's) billing system. Should begin with 'https://' or 'mailTo:'"
        },
        "create": "Create New Organization",
        "managed": {
            "title": "Managed Organization",
            "titleShort": "Managed",
            "titlePlural": "Managed Organizations",
            "description": "Managed organizations are organizations that are managed by a Cephable Reseller. Resellers can manage your team, team profiles, billing and more here.",
            "error": "Error loading managed organizations.",
            "empty": {
                "title": "No managed organizations found.",
                "description": "It doesn't look like there are managed organizations matching this criteria. Or your license keys have not been activated yet."
            }
        },
        "settings": {
            "title": "Organization Settings",
            "description": "Manage your organization billing, name, description, and resources.",
            "view": "View Settings",
            "general": {
                "title": "General"
            },
            "resources": {
                "edit": "Edit Resources",
                "description": "Use the Markdown editor on the left to update and format helpful resources for all members of the organization. As you type, the preview on the right will show how your content will appear to users. You can add headings, lists, links, and other formatting elements using Markdown syntax. Changes will be visible to members once saved."
            },
            "other": {
                "title": "Other Settings",
                "description": "Manage your organization billing, name, description, and resources."
            },
            "managed": {
                "title": "Managed by Cephable",
                "description": "These controls are set by Cephable for your organization. They are shown here so you can confirm the current values, and cannot be changed from the portal.",
                "email": {
                    "title": "Cephable email delivery",
                    "allowedDescription": "Cephable may send email to members of this organization, such as invitations, verification and password resets.",
                    "blockedDescription": "Cephable sends no email to members of this organization. Invitations, verification, password resets, magic links, onboarding and product emails are all suppressed."
                },
                "scim": {
                    "title": "Automatic member provisioning (SCIM)",
                    "description": "Your identity provider creates and removes members in this organization. Invites cannot be sent from the portal."
                },
                "lockedNote": "Only Cephable can change these settings. Contact your Cephable representative if a value needs to be updated."
            }
        },
        "governance": {
            "title": "Governance",
            "orgTitle": "{{value}} Governance",
            "description": "Set the guardrails that guide how your team can use the Cephable assistant.",
            "automation": {
                "title": "Automation rules",
                "description": "Control where Cephable can automate and provide instructions that shape its behavior for your organization.",
                "rulesTitle": "Rules",
                "create": "Create automation rule",
                "edit": "Edit automation rule",
                "created": "Automation rule created.",
                "updated": "Automation rule updated.",
                "deleted": "Automation rule deleted.",
                "loadError": "Unable to load automation rules.",
                "saveError": "Unable to save the automation rule.",
                "deleteError": "Unable to delete the automation rule.",
                "searchPlaceholder": "Search rules by app, website, prompt, or scope",
                "promptOnly": "Assistant instruction",
                "editorDescription": "Choose the rule type, optionally target an app or website, and add clear instructions for Cephable.",
                "validation": "Add an app or website, assistant instructions, or both.",
                "appOrDomain": {
                    "label": "App or website",
                    "helper": "Use a recognizable app name or domain, such as Slack, gmail.com, or github.com."
                },
                "prompt": {
                    "label": "Assistant instructions",
                    "helper": "Describe what Cephable should or should not do. Keep instructions specific and actionable."
                },
                "type": {
                    "label": "Rule type",
                    "block": "Block",
                    "allow": "Allow"
                },
                "scope": {
                    "organization": "Organization-wide",
                    "organizationDescription": "Apply this rule to every current and future member.",
                    "members": "Specific members",
                    "membersDescription": "Save the rule, then assign it only to the members who need it."
                },
                "assign": "Assign members",
                "delete": {
                    "title": "Delete automation rule?",
                    "description": "This permanently removes the rule and any member assignments using it."
                },
                "empty": {
                    "title": "No automation rules yet",
                    "description": "Create a rule to set your organization’s first assistant guardrail."
                },
                "guidance": {
                    "block": {
                        "title": "Restrict apps and websites",
                        "description": "Use a Block rule with an app name or domain to stop Cephable from interacting with it."
                    },
                    "prompt": {
                        "title": "Add assistant context",
                        "description": "Use assistant instructions to communicate policies, required checks, or safe ways of working."
                    },
                    "scope": {
                        "title": "Choose the right scope",
                        "description": "Apply shared guardrails organization-wide, or keep exceptions limited to selected members."
                    }
                },
                "assignment": {
                    "title": "Assign rule to a member",
                    "description": "Manage the member-specific assignment for {{value}}.",
                    "memberLabel": "Member",
                    "apply": "Apply rule",
                    "remove": "Remove rule",
                    "assigned": "This rule is assigned to the selected member.",
                    "notAssigned": "This rule is not assigned to the selected member.",
                    "applied": "Rule applied to member.",
                    "removed": "Rule removed from member.",
                    "loadError": "Unable to load organization members.",
                    "statusError": "Unable to load this member’s automation rules.",
                    "saveError": "Unable to update the member assignment."
                }
            },
            "tabs": {
                "automation": "Automation rules",
                "permissions": "Extension permissions",
                "skills": "Org skills",
                "connectors": "Org connectors",
                "usage": "Usage"
            },
            "extensions": {
                "permissions": {
                    "orgTitle": "Organization-wide policy",
                    "orgDescription": "Control what members can enable across skills and connectors. These apply to everyone unless a member has an override below.",
                    "saved": "Organization policy updated.",
                    "saveError": "Unable to update the organization policy.",
                    "askAdmin": "Please contact your organization admin to enable this.",
                    "installBlocked": "Unable to install.",
                    "createBlocked": "Unable to add personal {{type}}.",
                    "useBlocked": "This {{type}} is no longer available to you."
                },
                "orgFlags": {
                    "allowPublicSkills": {
                        "title": "Allow public skills",
                        "description": "Members may publish or enable public skills available in the Cephable marketplace."
                    },
                    "allowMemberManagedSkills": {
                        "title": "Allow personal skills",
                        "description": "Members may create and enable their own personal skills."
                    },
                    "allowPublicMcpServers": {
                        "title": "Allow public connectors",
                        "description": "Members may publish or enable public connectors available in the Cephable marketplace."
                    },
                    "allowMemberManagedMcpServers": {
                        "title": "Allow personal connectors",
                        "description": "Members may create and enable their own personal MCP connectors."
                    }
                },
                "members": {
                    "title": "Per-member overrides",
                    "description": "Grant an individual member the ability to share, manage, or use external skills and connectors.",
                    "memberLabel": "Member",
                    "saved": "Member permissions updated.",
                    "saveError": "Unable to update member permissions.",
                    "loadError": "Unable to load organization members.",
                    "adminNote": "This member is an organization admin and already has every extension permission."
                },
                "memberFlags": {
                    "canShareSkillsWithOrganization": {
                        "title": "Share skills with the organization",
                        "description": "Publish personal skills so other members can enable them."
                    },
                    "canManageOrganizationSkills": {
                        "title": "Manage organization skills",
                        "description": "Create, edit, and remove skills shared with the organization."
                    },
                    "canUseExternalSkills": {
                        "title": "Use external skills",
                        "description": "Enable public or personal skills even when the organization restricts them."
                    },
                    "canShareMcpServersWithOrganization": {
                        "title": "Share connectors with the organization",
                        "description": "Publish personal connectors so other members can enable them."
                    },
                    "canManageOrganizationMcpServers": {
                        "title": "Manage organization connectors",
                        "description": "Create, edit, and remove connectors shared with the organization."
                    },
                    "canUseExternalMcpServers": {
                        "title": "Use external connectors",
                        "description": "Enable public or personal connectors even when the organization restricts them."
                    }
                },
                "skills": {
                    "title": "Organization skills",
                    "description": "Pre-configure skills for your organization. Members can discover and enable these from their apps.",
                    "create": "Create skill",
                    "edit": "Edit skill"
                },
                "connectors": {
                    "title": "Organization connectors",
                    "description": "Pre-configure MCP connectors for your organization. Members supply their own credentials on their device when they enable one.",
                    "create": "Add connector",
                    "edit": "Edit connector"
                },
                "sort": {
                    "label": "Sort by",
                    "recent": "Most recent",
                    "rating": "Highest rated",
                    "votes": "Most upvoted",
                    "installs": "Most installed"
                },
                "list": {
                    "loadError": "Unable to load the list.",
                    "emptyTitle": "Nothing here yet",
                    "emptyDescription": "Create one to make it available to your organization’s members."
                },
                "stats": {
                    "rating": "Average rating",
                    "installs": "Members using this",
                    "votes": "Vote score",
                    "comments": "Comments"
                },
                "feedback": {
                    "open": "Ratings & comments",
                    "description": "Ratings and comments are shared within your organization.",
                    "yourRating": "Your rating",
                    "upvote": "Upvote",
                    "downvote": "Downvote",
                    "comments": "Comments",
                    "commentPlaceholder": "Share how this works for your team…",
                    "replyPlaceholder": "Write a reply…",
                    "noComments": "No comments yet. Start the conversation.",
                    "member": "Member",
                    "deleted": "This comment was deleted.",
                    "reply": "Reply",
                    "loadError": "Unable to load comments.",
                    "rateError": "Unable to save your rating.",
                    "commentError": "Unable to post your comment.",
                    "deleteError": "Unable to delete the comment."
                },
                "usage": {
                    "description": "See which members have enabled each org skill and connector.",
                    "skillsTitle": "Skill usage",
                    "connectorsTitle": "Connector usage",
                    "empty": "No members have enabled anything in this category yet.",
                    "installCount": "{{count}} member(s)",
                    "accountWide": "All devices",
                    "perDevice": "Single device",
                    "unnamed": "Untitled",
                    "loadError": "Unable to load usage."
                }
            }
        },
        "menu": {
            "title": "Organization Menu",
            "view": "View Menu",
            "expand": "Expand Menu"
        },
        "update": "Your organization has been updated! Refreshing the app.",
        "noAccess": {
            "title": "Access denied.",
            "description": "Your permissions have recently changed and you no longer have access to this feature. If you believe this is an error, please contact your organization administrator."
        },
        "noOrg": {
            "title": "No associated license.",
            "description": "You are not currently associated with a license or developer group. The portal is limited to users with a paid Cephable License. To unlock the full potential of Cephable start a risk free trial."
        },
        "error": "Error loading Organization. Please try again later.",
        "member": {
            "title": "Member",
            "titlePlural": "Members",
            "orgTitle": "{{value}} Members",
            "me": "My Membership",
            "aboutMe": "About Me",
            "description": "Members are users who are part of your organization. They can be assigned to different roles and have access to different parts of the organization.",
            "edit": "Edit Members",
            "removed": "You have been removed from a team.",
            "removedDescription": "You have been removed from the team. You can no longer access the organization. If you believe this is an error, please contact your organization admin.",
            "updated": "Success, {{value}}'s membership has been updated.",
            "error": "Error updating {{value}}'s membership.",
            "delete": "Success, {{value}} has been removed.",
            "deleteError": "Error removing {{value}}.",
            "loadError": "Error loading organization members.",
            "deleteConfirmation": {
                "title": "Are you sure you want to remove this member?",
                "description": "Once you remove this member, they will no longer have access to the organization. You can always re-invite them later.",
                "confirm": "Yes, remove member"
            },
            "viewAll": {
                "title": "View All Members",
                "description": "View all members of your organization and manage their roles and permissions."
            },
            "seats": {
                "title": "Member Seats",
                "description": "Every member in your organization counts as a seat. The type of permissions they have can be changed by the organization admin.",
                "stats": "seats out of {{value}}",
                "max": "Max seats",
                "maxSeatValue": "Max seats: {{value}}",
                "current": "Current Seats",
                "limit": {
                    "title": "Maximum Seats Reached",
                    "description": "Your current plan has reached its limit of {{ maxSeats }} available seats. You are unable to invite additional members. Please contact your administrator to upgrade the plan or manage your seat allocation."
                },
                "updateLimit": {
                    "title": "Upgrade Your Plan to Add More Seats",
                    "description": "Your current plan has reached the maximum number of seats: {{ maxSeats }}. Upgrade now to unlock additional seats and ensure your team can continue to grow seamlessly.",
                    "action": "Upgrade Plan"
                }
            },
            "emailExists": "Email already exists in the organization. Please enter a different email address."
        },
        "invite": {
            "title": "Invite",
            "titlePlural": "Invites",
            "orgTitle": "{{ value }} Invites",
            "description": "Invites are sent to users to join your organization. You can invite users to join your organization and assign them to different roles.",
            "edit": "Add a Member",
            "view": "View All Invites",
            "viewDescription": "See all current invites that have not been accepted.",
            "new": "Invite a Member",
            "editDescription": "Create a new invite for a user to join your organization.",
            "emailRequired": "Email is required",
            "emailInvalid": "Email is invalid. Please enter a valid email address.",
            "emailExists": "Email already has an organization invite. Please enter a different email address.",
            "emailPlaceholder": "Enter email address",
            "expiration": "Expires ",
            "delete": "Delete Invite",
            "confirm": "Are you sure you want to remove this invitation?",
            "confirmLong": "Once you delete this invite, the user will no longer be able to join the organization. You can always re-invite them later.",
            "accept": "Accept Invite",
            "stat": "active invitations",
            "error": "Error loading invites.",
            "noInvites": {
                "title": "No invites.",
                "description": "It looks like there are no active invites for your organization."
            },
            "acceptSuccess": {
                "title": "Welcome to the team.",
                "description": "You have successfully joined the organization. ",
                "action": "View your new organization"
            },
            "acceptError": {
                "title": "Oops. Looks like there is a problem.",
                "description": "There was an error joining the organization. Please try again later. If the issue persists, please reach out to your organization admin. ",
                "action": "Back to the homepage"
            },
            "send": {
                "title": "Send Invite",
                "success": "Invite to {{value}} sent.",
                "error": "Error sending invite to {{value}}."
            },
            "scimManaged": {
                "title": "Members are managed in your identity provider",
                "description": "This organization uses automatic provisioning (SCIM), so membership is controlled by your internal identity system. Add or remove people there and the change syncs to Cephable automatically — invites cannot be sent from the portal."
            }
        },
        "role": {
            "title": "Role",
            "titlePlural": "Roles",
            "description": "Roles are the different levels of access that a user can have in your organization. You can assign different roles to users to control what they can do."
        },
        "isAdmin": {
            "title": "Admin",
            "description": "Admins have full access to the organization and can manage all aspects of the organization.",
            "conflict": "This member is an Admin. You do not have permission to edit their roles."
        },
        "canViewMembers": {
            "title": "View Members",
            "description": "Users with this permission can view all members of the organization."
        },
        "canInviteMembers": {
            "title": "Invite Members",
            "description": "Users with this permission can invite new members to the organization and manage existing invites."
        },
        "canChangeMemberPermissions": {
            "title": "Change Member Roles",
            "description": "Users with this permission can change the role of other members in the organization."
        },
        "canRemoveMembers": {
            "title": "Remove Members",
            "titleSingle": "Remove Member",
            "action": "Remove",
            "description": "Users with this permission can remove other members from the organization.",
            "confirm": "Are you sure you want to remove this member from the organization?",
            "confirmLong": "Once you remove this member, they will no longer have access to the organization. You can always re-invite them later."
        },
        "canCreateAuthClients": {
            "title": "Create Projects",
            "description": "Users with this permission can create new auth clients and projects for the organization."
        },
        "canViewAuthClients": {
            "title": "View Projects",
            "description": "Users with this permission can view auth clients and projects for the organization."
        },
        "canManageBilling": {
            "title": "Manage Billing",
            "description": "Users with this permission can manage the billing settings for the organization.",
            "error": "You do not have permission to manage billing for this organization."
        },
        "canManageChildOrganizations": {
            "title": "Manage Child Organizations",
            "description": "Users with this permission can create and manage child organizations as an admin."
        },
        "canAccessOrganizationProfiles": {
            "title": "View Organization App Controls",
            "description": "Users with this permission can view the organization app controls associated with this organization."
        },
        "canEditOrganizationProfiles": {
            "title": "Manage Organization App Controls",
            "description": "Users with this permission can create, edit, and delete organization app controls associated with this organization."
        },
        "canManageGlobalAutomationRules": {
            "title": "Manage Governance",
            "description": "Users with this permission can manage organization automation rules and member assignments."
        },
        "canViewAnalytics": {
            "title": "View Analytics",
            "description": "Users with this permission can view the metrics and analytics for the organization."
        },
        "metrics": {
            "title": "Metrics",
            "description": "Metrics are data points that help you understand how your organization is using Cephable.",
            "view": "View Metrics",
            "orgTitle": "{{ value }} Metrics",
            "manage": {
                "title": "Performance Metrics",
                "description": "Download or clear the performance metrics collected during model inference."
            },
            "download": {
                "button": "Download Metrics",
                "success": "Metrics file has been saved to your Downloads folder.",
                "error": "Failed to download metrics file.",
                "noFile": "No metrics file found. Try running the model first."
            },
            "clear": {
                "button": "Clear Metrics",
                "success": "Metrics have been cleared.",
                "error": "Failed to clear metrics file.",
                "confirm": {
                    "title": "Clear Performance Metrics",
                    "description": "Are you sure you want to clear all recorded performance metrics? This action cannot be undone.",
                    "cancel": "Cancel",
                    "confirm": "Clear Metrics"
                }
            },
            "lineChart": {
                "title": "Average Concurrent Connections",
                "description": "This chart shows the average concurrent connections for the organization and project data over time.",
                "max": "Max Connections: {{maxConnections}}",
                "project": "Project Total",
                "org": "Organization Total"
            }
        },
        "profiles": {
            "titleShort": "App Controls",
            "title": "Organization App Controls",
            "description": "Organization App Controls are shared profiles for distributing app controls across your organization or to share with your integration users. ",
            "view": "View Organization App Controls",
            "editDescription": "Edit organization app controls to customize settings.",
            "empty": "No organization app controls found. Create one to get started.",
            "error": "Error loading organization app controls."
        },
        "projects": {
            "title": "Projects",
            "description": "Use Projects to manage secure access, configure device interactions, and streamline how your apps send and receive commands across various platforms.",
            "name": "App Name",
            "view": "View Projects",
            "error": "Error loading projects.",
            "orgTitle": "{{ value }} Projects",
            "stats": {
                "title": "Project Stats",
                "connections": "Total Connections",
                "all": {
                    "title": "All Project Metrics",
                    "description": "Aggregated metrics for all projects associated with {{ orgName }}"
                },
                "card": "projects out of {{value}}",
                "users": "total users since {{date}}",
                "avgUsers": "monthly avg users.",
                "concurrent": {
                    "title": "Average Concurrent Connections Last {{days}} days",
                    "label": "Avg Concurrent",
                    "max": "Max Connections",
                    "overage": "Overage",
                    "description": "Concurrent connections are the number of users connected to your project at the same time. This metric helps you understand how many users are using your app simultaneously."
                }
            },
            "projectType": {
                "title": "Project Type",
                "description": "Project Types are used to categorize your projects and help us choose the right SDKs for you."
            },
            "accessDenied": {
                "generic": "You do not have access to this project.",
                "title": "Access Denied.",
                "description": "You do not have access to view, create, edit or delete projects. Please reach out to your administrator for access."
            },
            "upgrade": {
                "title": "Upgrade to Cephable SDK",
                "description": "Cephable can be integrated directly into your app, game, or service using our SDK’s. Projects are not currently available with your account. If you think there is a mistake, please reach out to support@cephable.com.",
                "shortDescription": "Projects are not currently available with your account. Reach out to upgrade."
            },
            "limit": {
                "title": "Want more projects?",
                "error": "Project limit reached.",
                "description": "You have reached the maximum number of projects for your organization. Please reach out to your administrator to upgrade your account."
            },
            "create": {
                "title": "Create Project",
                "titleLong": "Let’s get started.",
                "first": {
                    "title": "Get started with your project.",
                    "description": "It looks like you haven't created a project yet. Client keys and devices are essential for securing communication between your applications and our services. With a client key, you’ll be able to integrate voice and head motion controls into your apps quickly and securely."
                },
                "details": {
                    "title": "Project Details",
                    "description": "Create a new project to manage your application’s authorization, device capabilities, and SDK integrations. Follow the steps below to set up secure, customizable interactions for your users."
                }
            },
            "sdk": {
                "title": "Download the SDK",
                "description": "Get access to our powerful SDK developed to make adaptive controls easy. ",
                "select": {
                    "title": "Select SDK",
                    "description": "Select the SDK you’d like to use for this project. Our SDKs enable seamless integration of adaptive voice and head motion controls across different platforms."
                }
            },
            "clients": {
                "title": "Authorization Clients",
                "configure": "Configure Authorization Client",
                "description": "Authorization Clients manage secure access for your applications. Define an authorization client to authenticate users and control interactions with your application.",
                "settings": "Authorization Settings",
                "create": "Create Authorization Client",
                "max": "Max Projects: {{value}}"
            },
            "secret": {
                "title": "Client Secret",
                "created": "Your client secret has been created.",
                "description": "Your client secret will only be shown once. Copy it now and store it in a safe secure location. <br> <br> Only use this for your own development. Do not share it with third party services or applications.",
                "copy": "Copy Secret",
                "rotate": {
                    "title": "Rotate Client Secret",
                    "description": "WARNING: This action will revoke your existing client secret and create a new client secret. This will require you to update all of your existing usage through out your apps. This action can not be reversed.",
                    "error": "Error rotating secret. Please try again later."
                }
            },
            "key": {
                "title": "Client Key",
                "view": "View Client Key",
                "copy": "Copy Key",
                "delete": {
                    "title": "Delete Client Key",
                    "description": "WARNING: This action will remove your existing client key and all related settings.This action can not be reversed.",
                    "error": "Error deleting your client key.",
                    "success": "You're project has been deleted. "
                }
            },
            "tokenRedirect": {
                "title": "Token Redirect URLs",
                "description": "Token Redirect URLs are the endpoints where access tokens are sent after authentication is complete. These URLs allow your application to securely receive tokens needed to access user data and services."
            },
            "authRedirect": {
                "title": "Authorization Code Redirect URLs",
                "description": "The AuthCode Redirect URL is the endpoint where authorization codes are sent after a user grants permission to your application. This URL is essential in OAuth flows, as it ensures the secure transmission of the authorization code from the authorization server to your app, allowing you to request access tokens on behalf of the user."
            },
            "originHost": {
                "title": "Origin Host",
                "description": "The URL that will serve as the primary source for request and data during API interactions."
            },
            "scopes": {
                "title": "Scopes",
                "configure": "Define Scopes",
                "titleLong": "API Permission Scopes",
                "manage": "Manage Authorization Scopes",
                "description": "Scopes define the permissions that this authorization client will have. Set scopes to limit access to specific data and functionality, ensuring users only get the access they need."
            },
            "type": {
                "title": "Implementation Type"
            },
            "deviceScopes": {
                "title": "Associated Device Types",
                "titles": "Associated Device Types",
                "titleLong": "Allowed Device Types",
                "configure": "Configure Allowable Device Types",
                "descriptionShort": "Define which type of devices can access this project.",
                "description": "Device Type defines the permissions and access levels that a device has within your application. By assigning specific devices types, you can control the actions and data that each device can access, ensuring that your application remains secure and compliant with your privacy policies.",
                "action": "Add new device type"
            },
            "deviceType": {
                "title": "Device Types",
                "description": "A DeviceType defines a category of devices, detailing their input/output capabilities and supported features (e.g., voice, gesture, controller types). It ensures that only authorized devices can interact with an application.",
                "action": "Create Device Type",
                "name": "Device Type Name",
                "descriptionLong": "Device Type Description",
                "id": "Device Type Id",
                "features": {
                    "title": "Supports Features",
                    "description": "Define the input and outputs that your app supports. This helps us optimize user experience across Cephable.",
                    "supportsVoiceInput": "Voice Input",
                    "supportsPhysicalInput": "Physical Input",
                    "supportsKeyboardOutput": "Keyboard Output",
                    "supportsPlayStationControllerOutput": "PlayStation Controller",
                    "supportsFaceInput": "Face Input",
                    "supportsGestureInput": "Gesture Input",
                    "supportsXboxControllerOutput": "Xbox Controller",
                    "supportsDigitalExtensions": "Digital Extensions",
                    "supportsPhysicalExtensions": "Physical Extensions",
                    "supportsNintendoControllerOutput": "Nintendo Controller",
                    "supportsGenericControllerOutput": "Generic Controller Output"
                },
                "canAutoStart": {
                    "title": "Supports Automatic Control Starts",
                    "description": "[canAutoStart] if enabled, SDK’s will check the user settings and attempt to immediately start camera, or microphone controls after user login."
                },
                "isSupported": {
                    "title": "Active",
                    "description": "[isSupported]  If disabled, Cephable will no longer send, receive or  acknowledge any user devices associated with this. Equivalent to deprecated."
                },
                "throttleRules": {
                    "title": "Command Throttle Rules",
                    "description": "Configure throttle rules to control command flow and input restrictions for this device type.",
                    "disableVoiceInput": "Disable Voice Input",
                    "disableHotkeyInput": "Disable Hotkey Input",
                    "disableCameraInput": "Disable Camera Input",
                    "disableMultiInputs": "Disable Multiple Inputs",
                    "maximumCommandsPerSecond": "Maximum Commands Per Second",
                    "maximumCommandsPerMinute": "Maximum Commands Per Minute",
                    "maximumMacroLength": "Maximum Macro Length",
                    "jitter": {
                        "title": "Timing Jitter",
                        "description": "Add random variation to hold and pause durations to create more natural input patterns.",
                        "holdTimeJitterMin": "Hold Time Jitter Min (ms)",
                        "holdTimeJitterMax": "Hold Time Jitter Max (ms)",
                        "pauseTimeJitterMin": "Pause Time Jitter Min (ms)",
                        "pauseTimeJitterMax": "Pause Time Jitter Max (ms)"
                    },
                    "incompatibleActions": {
                        "title": "Incompatible Action Groups",
                        "description": "Define groups of actions that cannot coexist in the same macro.",
                        "addGroup": "Add Group",
                        "removeGroup": "Remove Group",
                        "addAction": "Add Action",
                        "removeAction": "Remove Action",
                        "reason": "Reason",
                        "reasonPlaceholder": "Why these actions are incompatible",
                        "eventType": "Event Type",
                        "key": "Key",
                        "customActionId": "Custom Action ID",
                        "emptyGroup": "No actions in this group. Add at least two actions."
                    },
                    "requiredPause": {
                        "title": "Required Pause Between Actions",
                        "description": "Define pairs of actions that require a minimum pause between them in the same macro.",
                        "addRule": "Add Rule",
                        "removeRule": "Remove Rule",
                        "actionA": "Action A",
                        "actionB": "Action B",
                        "minimumPause": "Minimum Pause (ms)",
                        "bidirectional": "Bidirectional",
                        "bidirectionalHelp": "When enabled, the pause is required in both directions (A→B and B→A)."
                    },
                    "macroStepRules": {
                        "title": "Macro Step Rules",
                        "holdTimeJitterMin": "Hold Jitter Min (ms)",
                        "holdTimeJitterMax": "Hold Jitter Max (ms)"
                    }
                },
                "locale": {
                    "title": "Default Language",
                    "description": "[defaultLocale] The default locale for this device type. This will be used as the default language for the device.",
                    "support": "Supports Languages",
                    "warn": "** It looks like you have Custom Controls set up. Please make sure that you have updated the custom controls for the associated languages.**",
                    "name": "{{lang}} - Device Type Name",
                    "langDescription": "{{lang}} - Description"
                },
                "customControls": {
                    "title": "Custom Controls",
                    "description": "Custom Controls are an advanced option for allowing users to manually set up and edit app controls associated with this device. If you are wanting users to control your device from Cephable directly, then you must register your device controls here. Please see Cephable API for complete details on the options.",
                    "object": "{{lang}} - Custom Controls Object",
                    "addControl": "Add Control",
                    "empty": "No custom controls yet. Use \"Add Control\" to create your first one.",
                    "untitled": "Untitled control",
                    "controlId": "Control ID",
                    "controlIdHelp": "Unique identifier for this control. Set it before saving — it cannot be changed afterward.",
                    "fallback": "Fallback",
                    "controlName": "Control Name",
                    "controlDescription": "Control Description",
                    "defaultCommandsLabel": "Default Voice Commands",
                    "defaultCommandsHelp": "These are the default voice triggers users see for this control in the current language.",
                    "sharedAcrossLanguages": "Shared across all languages",
                    "sharedAcrossLanguagesHelp": "Editing these fields updates the value for every language at once.",
                    "iconUrl": "Icon URL",
                    "contextGroupName": "Context Group",
                    "isProfileControl": "Profile Control",
                    "isPrefixVoiceCommand": "Prefix Voice Command",
                    "allowWhenDictating": "Allow When Dictating",
                    "allowsHold": "Allows Hold",
                    "isDeprecated": "Deprecated",
                    "requiresEmployeeAccess": "Requires Employee Access",
                    "requiresStudentAccess": "Requires Student Access",
                    "requiresGenericLicense": "Requires Generic License",
                    "requiresPlusAccess": "Requires Plus Access",
                    "allIncomplete": "All locales have incomplete custom controls. Please complete at least one locale before saving.",
                    "savedWithIncomplete": "Saved. Incomplete custom control locales not saved: {{incompleteLocales}}"
                },
                "success": {
                    "title": "Success!",
                    "description": "You have created a new Device Type. {{name}} You can now update your authorization client device scope as needed."
                }
            }
        },
        "troubleshooting": {
            "title": "Troubleshooting",
            "editorDescription": "[Optional] This is a section that is visible to all users via the connection details page in both the Cephable mobile and desktop apps.",
            "description": "If you are experiencing issues with Cephable, try the steps below to resolve common problems."
        },
        "onboarding": {
            "title": "Onboarding",
            "editorDescription": "[Optional] Onboarding is displayed to users when this device type is added to their account. This is a great place to provide instructions on how to set up and use the device type with your application."
        },
        "documents": "Documents",
        "completionStatus": {
            "title": "Completion Status",
            "error": "",
            "complete": "Complete.",
            "incomplete": "Incomplete."
        },
        "metadata": {
            "title": "Metadata",
            "urlError": "URL must start with http:// or https://",
            "metatitle": {
                "label": "Meta Title",
                "placeholder": "Enter a short title"
            },
            "shortDescription": {
                "label": "Short Description",
                "placeholder": "Enter a brief preview description (max 150 characters)"
            },
            "externalLink": {
                "label": "External Link URL",
                "placeholder": "https://example.com/device-info",
                "description": "A direct link to an external website or resource that provides more information about setting up this device for the first time. If you use this we will not use the client listing markdown."
            },
            "iconUrl": {
                "label": "Device Icon URL",
                "placeholder": "https://example.com/device-icon.png",
                "description": "A direct link to an image that represents this device type. This icon will be displayed in the Cephable app and on device listings."
            },
            "darkModeIconUrl": {
                "label": "Dark Mode Device Icon URL",
                "placeholder": "https://example.com/device-icon-dark.png",
                "description": "A direct link to an image that represents this device type in dark mode. This icon will be displayed in the Cephable app and on device listings when the user has dark mode enabled."
            },
            "editorDescription": "When your device is chosen to be featured in the Cephable app as an extension or connection, we use this information to display to users setting up new connections."
        },
        "client-listing": {
            "title": "Client Listing",
            "editorDescription": "Detailed instructions for new users to set up new connections with this device type. This markdown content will be displayed in the Cephable app when users are adding a new connection."
        },
        "new": {
            "details": "Organization Details",
            "name": {
                "label": "Organization Name",
                "placeholder": "Enter the name of your organization"
            },
            "description": {
                "label": "Organization Description",
                "placeholder": "What are your goals with using Cephable Professional?"
            }
        },
        "expired": {
            "title": "Your Cephable License has Expired",
            "titlePlural": "Your Cephable Licenses have Expired",
            "user": "It looks like your Cephable License has expired, so you've been downgraded to the free Cephable Basic. To renew, please contact your organization administrator.",
            "admin": "It looks like your Cephable License has expired, so you've been downgraded to the free Cephable Basic. Please renew your license to continue using advanced features beyond Cephable Basic.",
            "multiple": "It looks like your Cephable Licenses have expired, so you've been downgraded to the free Cephable Basic. Please renew at least one of your licenses to continue using advanced features beyond Cephable Basic.",
            "banner": "It looks like your Cephable License has expired, so you've been downgraded to the free Cephable Basic. By renewing, gain access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.",
            "dialog": {
                "title": "Select an Organization",
                "description": "You have multiple organizations associated with your account. Please select the organization you would like to renew."
            }
        },
        "upgrade": {
            "existing": {
                "title": "You are part of an existing license.",
                "description": "Please upgrade by clicking `{{action}}` on the side menu."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "Generative AI Disabled",
                "description": "Your organization has disabled access to Generative AI features. Please contact your organization administrator for more information."
            },
            "isRemoteControlDisabled": {
                "title": "Cross Device Syncing Disabled",
                "description": "Your organization has disabled access to syncing, you will not be able to use our companion app or control external devices. Please contact your organization administrator for more information."
            }
        }
    },
    "developer": {
        "title": "Developer",
        "titleLong": "Developer Resources",
        "description": "Cephable can be integrated directly into your app, game, or service using our SDK’s.",
        "sdk": {
            "title": "Explore Our SDKs",
            "description": "We provide first-class SDKs designed to seamlessly integrate voice recognition and adaptive controls into your applications. Our tools are crafted to enhance user interaction through intuitive controls and to foster accessibility, ensuring that your software can be operated more effectively by all users.",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "Web",
                "description": "Integrate voice and adaptive controls directly into your web applications.",
                "action": "Get NPM Package"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Windows Applications",
                "description": "Leverage the power of .NET to create applications with our WPF and WinUI3 SDKs.",
                "actionCore": "Get Core Package",
                "actionWpf": "Get WPF Package"
            },
            "android": {
                "title": "Android",
                "subtitle": "Mobile Devices",
                "description": "Android applications designed to facilitate  voice and head motion capabilities.",
                "action": "Get Android SDK"
            },
            "docs": {
                "title": "Documentation",
                "description": "Explore detailed documentation, sample projects, and guides to start building with Cephable",
                "action": "View Docs"
            },
            "more": {
                "title": "More",
                "description": "Not finding what you need? Reach out and we can help you.",
                "action": "Request a SDK"
            }
        },
        "demo": {
            "title": "Demos",
            "samples": "Docs and Samples",
            "titleLong": "Experience Our SDKs in Action",
            "description": "Discover the power of our voice and head motion control technologies through our sample applications. From interactive games to dynamic web and mobile apps, each example demonstrates the versatility and effectiveness of our SDKs. Explore these examples to gain insights and inspiration for integrating enhanced accessibility and immersive experiences into your own projects.",
            "game": {
                "title": "2048 Game",
                "subtitle": "Web",
                "description": "Elevate traditional gameplay with adaptive voice and head motion controls.",
                "action": "Play the Game"
            },
            "other": {
                "title": "Other Demos",
                "description": "Experience firsthand how Cephable can your enhance your application, game or device.",
                "action": "View More Demos"
            },
            "web": {
                "title": "Web SDK Samples",
                "subtitle": "Web",
                "description": "Straightforward integration of all our core functionality into web applications.",
                "action": "Experience the SDK"
            },
            "unity": {
                "title": "Unity",
                "subtitle": "Game Development",
                "description": "See how adaptive controls can be leveraged in gaming to provide a more engaging UX.",
                "action": "Get the Sample"
            },
            "docs": {
                "title": "Developer Docs and Samples",
                "description": "Explore detailed documentation, sample projects, and guides to start building with Cephable",
                "action": "View Docs"
            }
        },
        "other": {
            "title": "Other Resources",
            "description": "Not finding what you need in our SDK’s try working directly with out API’s or reach out the community for help, inspiration and support.",
            "api": {
                "title": "API",
                "description": "Our API’s allow you to interact with Cephable directly. You can use our API’s to create custom integrations."
            },
            "support": {
                "title": "Support",
                "description": "Not finding what you need? Reach out to our community via Discord.",
                "action": "Join Discord"
            }
        }
    },
    "customControls": {
        "title": "Global & Device Controls",
        "warn": "Microphone has not been started. You must start your microphone to use global and device controls.",
        "descriptionShort": "Global and device controls are always-available actions designed to work across any software. Global controls—like 'Stop Camera'—are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls.",
        "description": "Global and device controls are always-available actions designed to work across any software. Global controls—like 'Stop Camera'—are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls. These controls are currently accessed as voice controls, however in the future we will add support for other inputs.",
        "prefixDisclaimer": " This is a prefix control; it will listen to the words after the command and then search against the following phrase to find matches.",
        "allowPausedDisclaimer": " This control will work even when the microphone is paused.",
        "noDevice": "This step uses a custom extension that you haven't configured for your account. Add the extension to unlock this step.",
        "resetControls": {
            "title": "Reset Controls",
            "description": "Your voice language has changed since the last time you updated your controls. Note: This will reset your controls to match {{language}}, and you may lose any custom commands. Are you sure you want to reset?",
            "confirm": "Yes, reset controls",
            "error": "There was an error resetting your controls. Please try again later."
        },
        "conflictIndicators": {
            "warn": "Warning: ",
            "title": "Input configuration conflicts detected",
            "description": "Some of the inputs for your global & device controls you are using are also used in one or more of your app controls. This may cause conflicts when using Cephable. When this occurs we will always give preference to the app control over the global or device control.",
            "item": "The input <strong> {{value}} </strong> is used in your app controls: ",
            "globalControls": "Global Control Configuration Conflicts",
            "deviceControls": "Device Control Configuration Conflicts",
            "globalDescription": "The following global controls have conflicting inputs with your app controls.",
            "deviceDescription": "The following device controls have conflicting inputs with your app controls.",
            "usedInput": " is used as an input for "
        },
        "globalControls": {
            "title": "Global Controls",
            "description": "Global controls are controls that are always available no matter what app controls or device you are using. Some even work when your microphone or camera controls are paused.",
            "empty": "You have no global controls yet. Click below to create one.",
            "edit": "Edit Global Controls"
        },
        "deviceControls": {
            "title": "Device Controls",
            "description": "Device controls are tied to the specific device or connection you're using. They’re available without needing to add them to your app controls and are especially useful for features or events that are only supported on certain devices.",
            "empty": "You have no device controls yet. Click below to create one.",
            "edit": "Edit Device Controls",
            "controls": {
                "cephable-open-app": {
                    "success": "Open app: {{value}}",
                    "error": "Unable to find app: {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["close"],
                    "name": "Close App By Name",
                    "description": "Use this command with voice controls to close an app on your computer by name.",
                    "success": "Close app: {{value}}",
                    "error": "Unable to find app: {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimize"],
                    "name": "Minimize the current app in focus.",
                    "description": "Use this command with voice controls to minimize the current app in focus.",
                    "success": "Minimize focused app success!",
                    "error": "Error minimizing focused app."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["maximize"],
                    "name": "Maximize the current app in focus.",
                    "description": "Use this command with voice controls to maximize the current app in focus.",
                    "success": "Maximize focused app success!",
                    "error": "Error minimizing focused app."
                },
                "cephable-close-focused-app": {
                    "commands": ["close current"],
                    "name": "Close the current app in focus.",
                    "description": "Use this command with voice controls to close the current app in focus.",
                    "success": "Close current app success!",
                    "error": "Error closing current app."
                },
                "cephable-generate-text": {
                    "commands": ["generate"],
                    "name": "Generate text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to generate some related text."
                },
                "cephable-rewrite-text": {
                    "commands": ["rewrite"],
                    "name": "Rewrite text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to rewrite your current highlighted text."
                },
                "cephable-summarize-text": {
                    "commands": ["summarize"],
                    "name": "Summarize text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to summarize your current highlighted text."
                },
                "cephable-translate-text": {
                    "commands": ["translate"],
                    "name": "Translate text by providing the prompt following this command.",
                    "description": "Use this command with voice controls followed by your prompt to translate your current highlighted text."
                },
                "cephable-stop-generate-text": {
                    "commands": ["stop generate", "stop generation", "cancel generate", "cancel generation"],
                    "name": "Stop generating text.",
                    "description": "Use this command with voice controls to stop generating text"
                },
                "cephable-open-panel": {
                    "commands": ["show panel"],
                    "name": "Open the Cephable panel",
                    "description": "Use this command with voice controls to open the Cephable panel."
                },
                "cephable-close-panel": {
                    "commands": ["hide panel"],
                    "name": "Hide the Cephable panel",
                    "description": "Use this command with voice controls to hide or minimize the Cephable panel."
                },
                "cephable-click-by-name": {
                    "commands": ["tap", "hit", "navigate to", "go to"],
                    "name": "Tap Element By Name",
                    "description": "Tap something on the page by name, such as \"tap save\" to click a button named \"save\". This is the same as voice mouse, clicking things with voice commands instead of using a mouse."
                },
                "cephable-automate": {
                    "commands": ["automate", "try to", "have cephable", "do a workflow to", "work on"],
                    "name": "Run an AI Workflow by describing a task after this command.",
                    "description": "Use this command with voice controls followed by a task, such as \"automate sending an email to my team\", and Cephable will carry it out as an AI Workflow."
                },
                "cephable-paste-background-entry": {
                    "commands": [
                        "paste recent entry",
                        "paste last entry",
                        "paste last dictation",
                        "paste background content"
                    ],
                    "name": "Paste the most recent background content.",
                    "description": "Use this command to paste the newest content stored in the background into the app in focus."
                }
            }
        },
        "changeProfile": {
            "success": "Change app controls: {{value}}",
            "error": "Unable to find app controls: '{{value}}'"
        }
    },
    "notifications": {
        "title": "Notifications",
        "center": "Notification Center",
        "empty": "You have no notifications at this time. Check back another time.",
        "seen": "Seen",
        "markAsRead": "Mark as Read",
        "view": "View All {{value}} Notifications"
    },
    "unsaved": {
        "title": "You have unsaved changes.",
        "description": "You have unsaved changes. Are you sure you want to leave this page?",
        "cancel": "Exit without saving",
        "confirm": "Save and Exit"
    },
    "login": {
        "welcome": "Welcome to Cephable!",
        "subtitle": "Control your technology on <strong>your</strong> terms.",
        "description": "Control. Create. Automate. Cephable — your personal AI for fast commands, in-context drafting, and hands-off workflows. No cloud processing. Just seamless assistance that moves with you.",
        "create": "Create Account",
        "signIn": "Sign In",
        "loading": "Redirecting to sign in...",
        "error": "There was an error signing you in. Please sign in again.",
        "existingAccount": "Already have an account?"
    },
    "home": {
        "title": "Home",
        "startControls": "Turn it on!",
        "manage": "Configure",
        "profileGenerate": {
            "title": "Oops. Looks like you don't have any app controls yet.",
            "description": "In order for Cephable to control your computer, we need to know what you want to control. You can create app controls from scratch or have us help you create one using our control generator."
        }
    },
    "workspace": {
        "title": "Workspace",
        "badge": "On-device · private",
        "badgeRemote": "Remote device · secure",
        "subtitle": "Your AI assistant runs entirely on this device. Start controls, create, automate, or just chat.",
        "subtitleRemote": "Everything you’d click or type, at your command.",
        "control": {
            "title": "Control",
            "description": "Voice commands, keyboard shortcuts, and quick action buttons — working across every app on your device.",
            "voice": {
                "title": "Voice controls",
                "description": "Hands-free commands"
            },
            "dictation": {
                "title": "Dictation",
                "description": "Speak to type"
            },
            "camera": {
                "title": "Camera controls",
                "description": "Face and head gestures"
            },
            "quickActions": {
                "title": "Quick actions",
                "description": "One-tap shortcuts"
            },
            "computerUse": {
                "title": "Computer use",
                "description": "Let the assistant act"
            }
        },
        "browser": {
            "openButton": "Open Browser",
            "windowTitle": "Cephable Browser",
            "newTab": "New tab",
            "reload": "Reload",
            "forward": "Forward",
            "openExternal": "Open in default browser",
            "showWindow": "Show hidden browser",
            "addressPlaceholder": "Search Google or type a URL",
            "clearData": {
                "description": "Clear the Cephable browser's history, cookies, cached data, and saved logins. This signs you out of every site in the Cephable browser.",
                "button": "Clear browser data",
                "cleared": "Browser data cleared.",
                "error": "Could not clear browser data.",
                "confirmTitle": "Clear browser data?",
                "confirmMessage": "Sign out of everything in the Cephable browser?",
                "confirmDetail": "This permanently clears history, cookies, cached data, and saved logins for the Cephable browser. This can't be undone.",
                "confirm": "Clear data",
                "cancel": "Cancel"
            },
            "context": {
                "newTab": "New tab",
                "reload": "Reload",
                "duplicate": "Duplicate tab",
                "close": "Close tab",
                "closeOthers": "Close other tabs",
                "closeRight": "Close tabs to the right",
                "back": "Back",
                "forward": "Forward",
                "openLinkNewTab": "Open link in new tab",
                "openLinkExternal": "Open link in default browser",
                "openExternal": "Open in default browser",
                "openAllExternal": "Open all tabs in default browser"
            },
            "home": {
                "tabTitle": "Home",
                "title": "The Cephable Browser",
                "tagline": "A separate browser Cephable can drive for you.",
                "description": "This is where Cephable automates web tasks on your behalf. It runs independently from your everyday browser, so your normal tabs, logins, and browsing stay untouched while automations run here — even in the background.",
                "searchPlaceholder": "Search Google or type a URL to get started",
                "go": "Go",
                "features": {
                    "separate": {
                        "title": "Runs on its own",
                        "description": "Kept separate from your default browser so automations never disrupt your personal browsing."
                    },
                    "automate": {
                        "title": "Built for automation",
                        "description": "Cephable can open pages, fill forms, and gather information here, hands-free."
                    },
                    "handoff": {
                        "title": "Hand off anytime",
                        "description": "Open any page in your default browser whenever you want to take over."
                    }
                }
            }
        },
        "history": {
            "title": "Recent AI history",
            "description": "Your latest intelligent tasks and automations.",
            "viewAll": "View all history",
            "empty": "Your recent AI tasks and automations will appear here."
        },
        "scheduledTasks": {
            "title": "Scheduled tasks",
            "description": "Automations set to run at a time you choose — on this device.",
            "viewAll": "View all scheduled",
            "empty": "Schedule a prompt from the panel and it will show up here."
        },
        "create": {
            "title": "Create",
            "description": "Draft, rewrite, reformat, and translate — right inside the app you’re working in using copied and highlighted text.",
            "contextRow": {
                "highlightedText": "Highlight / clipboard text",
                "output": "Typing In: ",
                "input": "Uses: ",
                "background": "Background",
                "currentapp": "Current app"
            },
            "items": {
                "draftEmail": "Draft an email",
                "writeDocument": "Write a document",
                "summarizeNotes": "Summarize into notes",
                "polishWriting": "Polish my writing",
                "translateText": "Translate text",
                "socialPost": "Write a social post",
                "cd_brief": "Draft a creative brief",
                "cd_caption": "Write a caption & alt text",
                "ar_insights": "Summarize findings into insights",
                "ar_exec": "Write an executive summary",
                "cc_followup": "Draft a follow-up email",
                "cc_meetingNotes": "Turn notes into meeting minutes",
                "bd_commit": "Write a commit message",
                "bd_review": "Summarize a code review",
                "gp_bio": "Write a stream bio",
                "gp_recap": "Recap last night's session",
                "lt_lesson": "Outline a lesson plan",
                "lt_studyNotes": "Summarize into study notes",
                "mo_agenda": "Draft a meeting agenda",
                "mo_update": "Write a project update",
                "aa_simplify": "Simplify to plain language",
                "aa_describe": "Describe an image in words"
            },
            "prompts": {
                "draftEmail": "Draft a clear, professional email about this. ",
                "writeDocument": "Write a document about this. ",
                "summarizeNotes": "Summarize this into concise, well-organized bullet-point notes.",
                "polishWriting": "Rewrite this to be clearer and more polished while keeping my meaning and tone.",
                "socialPost": "Write a short, engaging social post about this. ",
                "cd_brief": "Draft a creative brief for this project. ",
                "ar_insights": "Summarize the key findings and insights from this data.",
                "ar_exec": "Write a concise executive summary for this. ",
                "cc_followup": "Draft a follow-up email about this. ",
                "cc_meetingNotes": "Turn these notes into clear meeting minutes with action items.",
                "bd_commit": "Write a clear commit message for these changes: ",
                "bd_review": "Summarize this code review into key points and required changes.",
                "gp_bio": "Write a punchy bio for my stream/profile.",
                "lt_lesson": "Outline a lesson plan on this. ",
                "lt_studyNotes": "Summarize this material into study notes I can review.",
                "mo_agenda": "Draft a meeting agenda covering this.",
                "mo_update": "Write a project status update for stakeholders based on this. ",
                "aa_simplify": "Rewrite this in plain, easy-to-read language."
            }
        },
        "automate": {
            "title": "Automate",
            "description": "Describe a job in plain language and Cephable carries it out across your apps, your files, even your command line.",
            "items": {
                "summarizeSend": "Summarize & email",
                "researchDoc": "Research & write a doc",
                "organizeFiles": "Organize my files",
                "cleanUp": "Clean up a folder",
                "wordDoc": "Build a Word doc",
                "triage": "Triage my inbox",
                "cd_exportAssets": "Rename & file assets",
                "cd_moodboard": "Collect references",
                "ar_summarizeSend": "Summarize & email",
                "ar_analyzeData": "Analyze a spreadsheet",
                "ar_deck": "Build a deck from data",
                "cc_triage": "Triage & draft replies",
                "cc_summarizeEmail": "Summarize into an email",
                "cc_recap": "Recap & send to team",
                "cc_socialPost": "Post from a link",
                "bd_buildTest": "Build & test a project",
                "bd_cleanup": "Suggest code cleanups",
                "bd_scaffold": "Scaffold a project",
                "gp_schedule": "Plan a stream schedule",
                "lt_studyMaterial": "Make study materials",
                "lt_accommodation": "Make accessible notes",
                "lt_handout": "Compile a handout",
                "lt_research": "Research & compare",
                "mo_meetingActions": "Turn notes into actions",
                "mo_organizeFiles": "Organize my files",
                "mo_cleanup": "Clean up Downloads",
                "aa_translate": "Translate a document"
            },
            "prompts": {
                "summarizeSend": "Summarize the contents of <folder> and email it to <team email>.",
                "researchDoc": "Research the trends in <folder or document> and write up what you find in a new document.",
                "organizeFiles": "Copy the files from <source folder> into <destination folder>.",
                "cleanUp": "Remove all the <file type, e.g. screenshots> from my <folder>.",
                "wordDoc": "Use <article or notes> to create a Microsoft Word document that <does what>.",
                "triage": "Go through my inbox and tell me what needs my attention, then draft replies where one is needed.",
                "cd_exportAssets": "Rename the design assets in <folder> using this scheme — <naming scheme> — and sort them into folders.",
                "cd_moodboard": "Find references for <idea> online and gather them into a document.",
                "ar_summarizeSend": "Summarize the contents of <folder> and email it to <team email>.",
                "ar_analyzeData": "Analyze <spreadsheet> and find <what to look for, e.g. key losses>.",
                "ar_deck": "Turn the findings in <document or folder> into a PowerPoint that highlights <key points>.",
                "cc_triage": "Read my inbox and draft replies to anything that needs one.",
                "cc_summarizeEmail": "Draft an email summarizing <article or document> and point out the key technical details.",
                "cc_recap": "Write a recap of <meeting notes> and email it to <team email>.",
                "cc_socialPost": "Read <article or website> and write a <platform, e.g. Discord>-friendly post about it, then save it to a new note.",
                "bd_buildTest": "Review the code in <project folder>, build it, and run the tests. If anything fails, check the git history and tell me what likely broke it.",
                "bd_cleanup": "Look at the code in <project folder> and tell me how to make it cleaner.",
                "bd_scaffold": "Scaffold a new <project type> project in <folder> with the starter files it needs.",
                "gp_schedule": "Plan a streaming schedule for <time period> covering <games or activities>.",
                "lt_studyMaterial": "Use <article or notes> to create a Word document for <grade level> students with <reflection questions or a study guide>.",
                "lt_accommodation": "Create a Word document of lecture notes on <topic> formatted for a student with <accommodation>.",
                "lt_handout": "Compile the readings in <folder> into a single handout document.",
                "lt_research": "Find <topic, e.g. books on neurodiversity> online and create a document summarizing each so I can compare.",
                "mo_meetingActions": "Read <meeting notes>: what's left to do, who's responsible, and what needs more research? Break it into files organized in a folder.",
                "mo_organizeFiles": "Copy the files from <source folder> into <destination folder>.",
                "mo_cleanup": "Remove all the <file type, e.g. installers> from my Downloads folder.",
                "aa_translate": "Translate <document> into <language> and save it to <folder>."
            }
        },
        "suggestions": {
            "viewMore": "View more",
            "viewMoreTooltip": "Browse every suggested prompt",
            "dialogTitle": "All suggestions",
            "dialogDescription": "Pick a starting point. It drops into the composer so you can edit it before running.",
            "rotationLabel": "Suggested prompts",
            "empty": "No suggestions available."
        }
    },
    "wizard": {
        "title": "Generate App Controls",
        "titleLong": "Generate New App Controls",
        "description": "Cephable will then use this information to generate controls for you to review and try!",
        "includeDefaultKeysQuestion": "Include default voice commands for keys and mouse clicks?",
        "try": "Try Control Generator",
        "placeholder": "Make sure the voice commands are short.\n\nI want to be able to say \"forward\" to go to the next slide in the presentation\n\nI want to use head movement for moving the cursor and voice controls for editing shortcuts\n\nAdd quick action buttons for all my character movement and abilities.",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Code, etc.",
        "noOptionsText": "Begin typing to find an app you want to control",
        "generate": "Generate Controls",
        "complete": {
            "title": "Alright, we're done!",
            "description": "Click the button below to view the controls we generated. You'll be able to manually edit, add to, or remove any aspects to perfect it for yourself.",
            "viewControls": "See my controls"
        },
        "error": {
            "emptyInput": "Please select at least one input method",
            "emptyApp": "Please enter at least one app name",
            "generatingProfile": "Error generating app controls"
        },
        "loading": {
            "title": "We're putting together all the pieces",
            "description": "This can take up to about a minute. Don't leave this page or go back or it will stop generating."
        },
        "selectedTips": {
            "title": "Tip #{{count}}",
            "previous": "Previous Tip",
            "next": "Next Tip",
            "one": "Did you know you can use Cephable on one device to control another? Download Cephable to your mobile, tablet or even another computer and choose the connection you want to control (perhaps this one). Your personal and input profiles are consistent across them all! Just make sure Cephable is running on your device and connections.",
            "two": "You can control the sensitivity of your inputs in the \"Expression Control Settings\" section of the main panel. This let's you further refine the ways Cephable interprets inputs specific to you. And Cephable get's better over time as it works with you!",
            "three": "After we set this up you still have complete control over the configuration. We're giving you a baseline but at any point you can change the mapping between what you do and what it does on the computer.",
            "four": "You can print out your controls to have a physical copy as you use Cephable. We know this is all new and takes some getting used to. Practice makes better!"
        },
        "steps": {
            "one": "Step 1. Type the name of an app you want to control.",
            "two": "Step 2. Confirm the input controls you want to use:",
            "three": "Step 3. (optional) ",
            "threeContinued": "Describe any specific actions you'd like to have setup for commands you commonly use or have a strong preference for. Please use plain english like the ones below"
        }
    },
    "profile": {
        "title": "App Controls",
        "titlePlural": "App Controls",
        "titlePreview": "Controls Preview",
        "previous": "Previous App Controls",
        "manage": "Manage App Controls",
        "view": "View Controls",
        "edit": "Edit App Controls",
        "add": "Add App Controls",
        "create": "Create App Controls",
        "customize": "Customize App Controls",
        "warn": "Camera or microphone must be started to use your app controls.",
        "descriptionShort": "Discover the different ways Cephable helps you control your devices and software.",
        "description": "App controls are a set of controls that you can use to control your device or connection. You can create multiple app controls and switch between them whenever you'd like.",
        "name": "App Name",
        "nameQuestion": "What do you want to call these app controls?",
        "newName": "New App Controls",
        "search": "Search App Controls by Name",
        "searchLong": "Search App Controls by Name or Description",
        "keyboardAndMouse": "Keyboard and Mouse",
        "genericController": "Gamepad Controller",
        "keyboardMouseAndController": "Keyboard, Mouse, and Controller",
        "permissionError": "You do not have permission to use these app controls.",
        "custom": "{{name}} (Custom)",
        "set": {
            "title": "It doesn't look like you have app controls set yet.",
            "description": "App Controls are how Cephable knows what to listen for and what actions to take. You can swap control app controls whenever you'd like from the homepage or by going to your connection settings.",
            "cta": "Set App Controls",
            "empty": {
                "auto": "Switch to another app to see controls",
                "select": "Select a control to begin",
                "none": "No app controls found"
            }
        },
        "summary": {
            "title": "App Controls Summary",
            "descriptionLong": "Here are the details of these app controls. You can search controls, actions, and more to see what you can do with these app controls.",
            "description": "Get a summary of these app controls including what controls there are, customizations, details, and more.",
            "view": "View App Controls Summary",
            "filter": "Filter by Input Type",
            "placeholder": "Search control names..."
        },
        "copy": {
            "title": "Copy App Controls",
            "duplicate": "Duplicate App Controls",
            "question": "Create a copy?",
            "description": "Want to create a new copy of these app controls? This will open a new window with these app controls copied but it won't be added to your account until you save it.",
            "confirm": "Yes, create a copy",
            "profileSuffix": "{{name}} (copy)"
        },
        "new": {
            "title": "Create New App Controls",
            "description": "Craft controls from the ground up or let cutting-edge AI generate personalized controls, empowering you to navigate apps and software effortlessly using your voice, head, and face gestures.",
            "note": "Recommended for advanced users.",
            "scratch": "Create from Scratch"
        },
        "advancedOptions": "Advanced Control Options",
        "delete": {
            "title": "Delete App Controls",
            "titleLong": "Delete these app controls",
            "description": "You can delete these app controls by clicking 'Delete App Controls'.",
            "confirm": "Are you sure you want to delete these app controls",
            "confirmLong": "Once you delete these app controls, you won't be able to return to it. Are you sure you want to delete these app controls?",
            "confirmButton": "Yes, delete these app controls"
        },
        "current": "Current Controls",
        "loading": "Loading controls...",
        "null": "You have no app controls yet. Click below to create one.",
        "nullButton": "Create your first app controls",
        "preview": "Preview",
        "features": "Features",
        "byline_public": "By: Cephable Team",
        "byline_shared": "Shared by: Cephable Community",
        "share": {
            "title": "Share App Controls",
            "previewTitle": "Shared App Controls Preview",
            "description": "Share these app controls with others so they can get a copy and personalize from there!",
            "descriptionLong": "Share these app controls with others so they can get a copy and personalize from there! Choose how you want to share, then create a link to send to others.",
            "add": "Create a Share Link",
            "confirm": "Share this url",
            "link": "Share Link",
            "copy": "Copy Link",
            "copied": "Copied!",
            "usage": "Usage Amount",
            "created": "Created {{value}}",
            "expiration": {
                "title": "Expiration",
                "once": "Only allow one use",
                "unlimited": "Allow unlimited usage",
                "no": "No expiration",
                "date": "Expiration Date",
                "dateDescription": "Expire at a specific date"
            },
            "manage": "Manage previous share links",
            "empty": "No shares have been created for these app controls."
        },
        "swap": {
            "title": "Swap Controls",
            "titleLong": "Swap your App Controls",
            "descriptionShort": "Use different app controls to match the program or software you are using.",
            "description": "You can swap between different app controls to match the program or software you are using."
        },
        "autoProfileSwitching": {
            "title": "Automatic Control Switching",
            "description": "Automatic control switching allows Cephable to adapt to your workflow seamlessly. When turned on, Cephable will contextually adjust your app controls based on the program or software you're using. If turned off, you can manually switch app controls using the 'Swap Controls' button or using global commands.",
            "alerts": {
                "disabled": "Automatic Control Switching is turned off.",
                "temporarilyDisabled": "Automatic Control Switching is temporarily turned off.",
                "enabled": "Automatic Control Switching is turned on.",
                "error": "Error saving automatic control switching preferences"
            },
            "associatedPrograms": {
                "add": "Add a New Associated Program",
                "description": {
                    "personal": "Choose the software or programs you want to connect to these controls. This supports Automatic Control Switching, where Cephable will automatically switch these app controls to match the current program you are using.",
                    "short": "Choose the software or programs you want to connect to these controls."
                },
                "edit": "Edit Associated Programs",
                "noOptionsText": "Begin typing to find associated programs",
                "profileLabel": "App Controls: ",
                "remove": "Remove Associated Program",
                "title": "Associated Programs",
                "when": "Cephable will automatically switch my app controls to {{profileName}} when I use...",
                "emptySearch": "There are no programs associated with these controls.",
                "error": "Error saving associated programs. Please try again later.",
                "emptyError": "Empty Associated Program detected, please remove before continuing."
            },
            "commandOverlay": {
                "command": "Switching App Controls: {{value}}"
            }
        },
        "error": {
            "noMatch": "No app controls match your search.",
            "save": "Error saving app controls. Please try again.",
            "conflicts": "Error saving app controls due to conflicts.",
            "load": "Error loading app controls.",
            "add": "Error adding app controls.",
            "delete": "Error deleting app controls.",
            "audioEventsWithEmptyCommands": "You have missing controls in your talk back. Check your talk back controls to make sure you fill it out completely.",
            "device": "Invalid app control for this connection. Please try a different one."
        },
        "conflictIndicators": {
            "errorTitle": "Error saving app controls due to conflicts",
            "warningTitle": "App controls saved with warnings",
            "subtitle": "The app controls you created has some configurations that may conflict.",
            "profileNameErrors": "App Controls name conflict",
            "emptyControlsMapped": "Empty input names",
            "emptyControlsMappedDescription": "Please add a voice command, facial expression, head tilt, or other command to your input.",
            "emptyKeybindingControlsMapped": "Empty input names for keybindings",
            "emptyKeybindingControlsMappedDescription": "Please add a voice command, facial expression, head tilt, or other command to your input for keybindings.",
            "duplicateNameTitle": "Duplicate App Controls name",
            "duplicateNameDescription": "You have a existing app controls with the same name. Please change the name before continuing.",
            "emptyNameTitle": "Empty app controls name",
            "emptyNameDescription": "The app controls must have a name for it. ie Game 1, Spotify, Word, etc.",
            "macrosReleaseKeysMissingTitle": "Outputs with unreleased keys",
            "macrosReleaseKeysMissingDescription": "Please add a release key or stop all step to prevent keys from getting stuck.",
            "duplicateInputCommandMacroTitle": "Identical control inputs",
            "duplicateCommandsDescription": "Please remove or change the duplicate input commands.",
            "duplicateInputCommandBindingsTitle": "Identical control inputs for keybindings",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} with {{commandOrEventType}}",
            "duplicateMacroNames": "Duplicate Control Names",
            "duplicateMacroNamesDescription": "Please remove or change one of your identical control names.",
            "warningIgnore": "Ignore",
            "warningDoNotShowAgain": "Do not show warnings again",
            "macrosVoiceCommandConflictWithDictationTitle": "Control voice commands same as dictation key words",
            "keybindingsVoiceCommandConflictWithDictationTitle": "Keybindings voice commands same as dictation key words",
            "macrosVoiceCommandConflictWithDictationDescription": "Your voice inputs will trigger dictation and voice commands.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "Your voice inputs will trigger dictation and key presses.",
            "macrosVoiceCommandConflictWithGenerationTitle": "Control voice commands same as generation key words",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "Keybindings voice commands same as generation key words",
            "macrosVoiceCommandConflictWithGenerationDescription": "Your voice inputs will trigger generation and voice commands.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "Your voice inputs will trigger generation and key presses.",
            "duplicateAssociatedProgramNames": "Duplicate associated program names",
            "duplicateAssociatedProgramNamesDescription": "Please remove or change one of your identical associated programs.",
            "emptyEvent": {
                "title": "Missing Steps",
                "description": "There are missing steps in your controls. This could lead to Cephable not doing an action when you give a command."
            },
            "warningDetails": "View all conflicts"
        },
        "success": {
            "save": "App controls saved.",
            "add": "App controls added.",
            "delete": "App controls deleted.",
            "share": "Share link created and copied to clipboard",
            "shareDelete": "Share link deleted.",
            "generate": "App controls generated."
        },
        "warning": "App controls saved with warnings"
    },
    "macros": {
        "title": "Control",
        "titlePlural": "Controls",
        "description": "Controls contain an input (action that you do like tilt your head) and steps that Cephable will do after that input action has been recorded. You can use controls to create a combination of steps that are triggered by a single input.",
        "new": "Create a New Control",
        "newDescription": "Create a new control to combine multiple steps and inputs.",
        "add": "Add Control",
        "create": "Create a Control",
        "name": {
            "title": "Control Name",
            "question": "What do you want to call this control?",
            "description": "Give your control a name so you can easily find it later.",
            "placeholder": "action this control is doing like \"jump\" or \"zoom in\""
        },
        "empty": "You have no controls yet. Click below to create one.",
        "copySuffix": "{{name}}_copy"
    },
    "event": {
        "title": "Step",
        "titlePlural": "Steps",
        "previewSummaryPlural": "{{first}} and {{total}} more events",
        "add": "Add Step",
        "stepType": "Step Type",
        "select": "Select the type of step you want to add.",
        "question": "What type of actions do you want Cephable to perform?",
        "setup": "Configure your Step",
        "description": "Steps are the actions that Cephable will do after the input has been triggered. You can add multiple steps to a control to create a combination of actions.",
        "expand": "Expand to see the rest of the steps",
        "stepUp": "Move Step Up",
        "stepDown": "Move Step Down",
        "stepCopy": "Copy Step",
        "stepRemove": "Remove Step",
        "insertStep": "Insert Step Below",
        "showOptions": "Show Options",
        "hideOptions": "Hide Options",
        "hold": "Hold time (in milliseconds)",
        "error": "You must configure your step.",
        "multiple": "Multiple Steps",
        "deviceTypeCustomAction": {
            "title": "Custom Device Action"
        },
        "keyPress": {
            "title": "Press Key or Button ",
            "short": "Press",
            "fieldSet": "Keys or Button to Press",
            "label": "Key or Button",
            "holdTime": "Hold key time (in milliseconds)",
            "description": "Press a keyboard key without using the keyboard.",
            "longDescription": "This function simulates the pressing of a key on your keyboard. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \"press\" a key virtually.",
            "example": "Say \"Enter\" to send an email without physically pressing the Enter key.",
            "timing": "Key Press Timing",
            "tap": "Tap",
            "tapLong": "Tap Button",
            "latch": "Latch",
            "latchLong": "Hold until released",
            "hold": "Hold",
            "holdLong": "Hold for amount of time",
            "toggle": "Toggle",
            "toggleLong": "Toggle action",
            "release": "Release",
            "releaseLong": "Release action",
            "latchLabel": "Hold <strong> {{value}} </strong> until released",
            "tapLabel": "Tap <strong> {{value}} </strong>",
            "pressLabel": "Press <strong> {{value}} </strong> for <strong> {{time}} </strong> milliseconds",
            "remove": "Remove Key Press",
            "add": "Add Key/Button to Press"
        },
        "keyRelease": {
            "title": "Release Key or Button",
            "short": "Release",
            "selected": "Selected Keys to Release",
            "description": "Let go of a keyboard key you've pressed and held.",
            "longDescription": "This function simulates the release of a key on your keyboard. It should be used in conjunction with a key press that is held indefinitely. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \"release\" a key virtually.",
            "example": "Say 'Stop' after saying 'Toggle Run' to stop running.",
            "label": "Release <strong> {{value}} </strong>",
            "add": "Add Key/Button to Release",
            "remove": "Remove Key Release"
        },
        "keyToggle": {
            "title": "Toggle Key or Button",
            "short": "Toggle",
            "selected": "Selected Keys to Toggle",
            "description": "Turn a keyboard key on or off like a light switch with a single control.",
            "longDescription": "This turns a key's function on or off, like a switch. It's useful for keys that you want to hold for an indeterminate amount of time. You can use this to keep the same action for both key press and key release or stop.",
            "example": "Say 'Toggle Run' to start running. Say 'Toggle Run' to stop running.",
            "label": "Toggle <strong> {{value}} </strong>",
            "add": "Add Key/Button to Toggle",
            "remove": "Remove Key Toggle"
        },
        "pause": {
            "title": "Pause",
            "description": "Add a brief delay between actions.",
            "longDescription": "This function allows you to insert a brief delay between actions, which is essential in situations where one action must fully complete before the next begins. For example, if you're using a command to make text bold in a document, you might first need to open a context menu. The Pause function gives enough time for the context menu to open and become active before proceeding to the next step, ensuring smooth and error-free operation.",
            "example": "Imagine you're editing a document using voice commands. You say \"Format text,\" which opens a context menu. Then, after a brief pause to allow the menu to fully appear, you say \"Bold\" to apply bold formatting to the selected text. The Pause function ensures the context menu is ready to receive your next command.",
            "label": "Pause for <strong> {{value}} </strong> milliseconds"
        },
        "type": {
            "title": "Type",
            "field": "Phrase to Type",
            "placeholder": "typed phrase",
            "question": "What text do you want to type?",
            "description": "Write out text like using a keyboard.",
            "longDescription": "This mimics typing a string of text, similar to typing on a keyboard. It's ideal for entering longer text without needing to press each key. If you want to dynamically enter text, you can use the Dictation function instead.",
            "example": "Say \"Name\" to type \"Hello, my name is Ellen Ripley.\" in a chat window.",
            "label": "Type <strong> {{value}} </strong>"
        },
        "mouseMove": {
            "title": "Move the Mouse",
            "description": "Move the pointer on the screen.",
            "longDescription": "Move your screen's cursor or pointer without a physical mouse. This is particularly helpful for users with limited hand mobility. This is useful for fine control of mouse movement that is needed in some games. If you want to simulate all mouse movement using your head movement, you can try the 'Head Movement for Mouse Control' in the camera settings.",
            "example": "Say \"Move Mouse Right\" to move the cursor to the right 100px.",
            "moveX": "Mouse Move Left/Right Pixels",
            "numberMoveX": "Number of pixels to Move Left/Right",
            "moveY": "Mouse Move Up/Down Pixels",
            "numberMoveY": "Number of pixels to Move Up/Down",
            "label": "Move the mouse <strong> {{value}} </strong>",
            "command": "Mouse Move: {{command}}",
            "commandLabel": "Mouse Move",
            "startCommand": "Mouse Move Start",
            "stopCommand": "Mouse Move Stop"
        },
        "joystickMove": {
            "title": "Move Joysticks",
            "description": "Use a joystick to move things on the screen.",
            "longDescription": "This function simulates the movement of a joystick. For instance, if you have difficulty using a physical joystick, you can use a voice command or another input method to move a joystick virtually.",
            "example": "Say \"Move Joystick Left\" to move the joystick to the left 100px.",
            "prefix": "Move the left joystick",
            "left": "Left Joystick",
            "leftX": "Left X",
            "leftY": "Left Y",
            "right": "Right Joystick",
            "rightX": "Right X",
            "rightY": "Right Y",
            "x": "X Axis Strength",
            "y": "Y Axis Strength",
            "moveXLabel": "Move X: {{value}}",
            "moveYLabel": "Move Y: {{value}}",
            "labelLeft": "Move the Left joystick ",
            "labelRight": "Move the Right joystick ",
            "latch": "Latch will hold the position until you release using a 'Stop All' command."
        },
        "playAudio": {
            "title": "Play Audio",
            "placeholder": "phrase of statement that Cephable will say",
            "description": "Play a sound, word, or phrase.",
            "longDescription": "This function enables users to convert typed phrases into spoken words. It's especially useful for individuals who may have difficulty speaking. By typing in a phrase, the PlayAudio feature will articulate the text aloud using synthesized speech. This can assist in communication or in situations where a user needs to relay information verbally but prefers or requires an alternative to using their own voice.",
            "example": "Smile to play the word \"Hello\".",
            "label": "Speak <strong>\"{{value}}\"</strong>"
        },
        "stopOutputs": {
            "title": "Stop All Outputs",
            "titleLong": "Stop all outputs (release all keys and buttons, stop all mouse movements, stop all typing)",
            "description": "Stop all ongoing actions like key press.",
            "longDescription": "Immediately stop all ongoing outputs or actions. This is a safety or convenience feature to halt any process. We will automatically do this for you when you close, or pause the camera or microphone controls.",
            "example": "Say \"Stop\" to stop all outputs.",
            "label": "Stop all outputs and release keys"
        },
        "custom": {
            "title": "Custom"
        },
        "options": {
            "moveUp": "Move Up",
            "moveDown": "Move Down",
            "moveLeft": "Move Left",
            "moveRight": "Move Right",
            "copyStep": "Copy Step",
            "removeStep": "Remove Step"
        },
        "directions": {
            "up": "Up",
            "down": "Down",
            "left": "Left",
            "right": "Right"
        }
    },
    "expression": {
        "title": "Face Expression",
        "titlePlural": "Face Expressions",
        "label": "Expression / Gesture",
        "description": "Elevate your digital experience with facial expressions. Use gestures like eyebrow raises, smiles, and other movements to seamlessly control your mouse pointer, perform actions, or customize your interactions.",
        "start": "Start Expression Controls",
        "startSmiling": {
            "title": "Start Smiling",
            "description": "If you start not smiling and then start to smile, this control will trigger. Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."
        },
        "stopSmiling": {
            "title": "Stop Smilling",
            "description": "If you are smiling and then stop smiling, this control will trigger.  Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."
        },
        "eyebrows": {
            "title": "Raise Eyebrows",
            "description": "If you raise both your eyebrows from your baseline resting position, this control will trigger."
        },
        "openMouth": {
            "title": "Open Mouth",
            "description": "If your mouth is closed (or if your baseline is slightly open), and you open your mouth more, this control will trigger.  Note: using this control in the same app controls as the smile control may cause conflicts."
        },
        "closeMouth": {
            "title": "Close Mouth",
            "description": "If your mouth is open and you close it entirely, this control will trigger. Note: using this control in the same app controls as the smile control may cause conflicts."
        }
    },
    "head": {
        "title": "Head Movement",
        "titlePlural": "Head Movements",
        "label": "Head / Body Movement",
        "question": "What type of movement do you want to use?",
        "description": "Control your device or connection with head movements like tilting, nodding, or turning. Using your device's camera, Cephable ensures a private and intuitive experience for enhanced control or mouse navigation.",
        "tilt": {
            "title": "Head Tilt",
            "description": "Tilt your head to the left or right for enhanced control or mouse navigation.",
            "left": {
                "title": "Tilt Head Left",
                "description": "If you are looking at the camera and tilt your head to your left, this control will trigger."
            },
            "right": {
                "title": "Tilt Head Right",
                "description": "If you are looking at the camera and tilt your head to your right, this control will trigger."
            },
            "back": {
                "title": "Tilt Head Back",
                "description": "If you are looking at the camera and tilt your head back and look up, this control will trigger."
            },
            "forward": {
                "title": "Tilt Head Forward",
                "description": "If you are looking at the camera and tilt your head forward and look down, this control will trigger."
            }
        },
        "turn": {
            "title": "Head Turn",
            "description": "Turn your head to the left or right for enhanced control or mouse navigation.",
            "left": {
                "title": "Turn Head Left",
                "description": "If you are looking at the camera and turn your head and look to your left, this control will trigger."
            },
            "right": {
                "title": "Turn Head Right",
                "description": "If you are looking at the camera and turn your head and look to your right, this control will trigger."
            }
        },
        "lean": {
            "title": "Head Lean",
            "description": "Lean your head to the left or right for enhanced control or mouse navigation.",
            "left": {
                "title": "Lean Head Left",
                "description": "If you are looking at the camera and lean left so your face is further left in the camera frame, this control will trigger."
            },
            "right": {
                "title": "Lean Head Right",
                "description": "If you are looking at the camera and lean right so your face is further right in the camera frame, this control will trigger."
            },
            "back": {
                "title": "Lean Head Back",
                "description": "If you are looking at the camera and lean back so your face is further from the camera, this control will trigger."
            },
            "forward": {
                "title": "Lean Head Forward",
                "description": "If you are looking at the camera and lean forward so your face is closer to the camera, this control will trigger."
            },
            "up": {
                "title": "Move Body Up",
                "description": "If you are looking at the camera and move your head up by stretching your neck or moving your whole body up, this control will trigger."
            },
            "down": {
                "title": "Move Body Down",
                "description": "If you are looking at the camera and move your head down by scrunching your neck, ducking, or lowering your whole body, this control will trigger."
            },
            "center": {
                "title": "Center your Head",
                "description": "If you are looking at the camera and move your head back to the center position matching baseline, this control will trigger."
            }
        }
    },
    "voice": {
        "title": "Voice Control",
        "titlePlural": "Voice Controls",
        "placeholder": "Voice or phrase Cephable will listen for",
        "question": "What statement or phrase do you want to say for this control?",
        "when": "When I say...",
        "say": "Say '{{value}}'",
        "description": "Starting the microphone unlocks intelligent and natural voice commands, empowering users to seamlessly interact with their computer across applications and software. Speak naturally to execute commands or dictate text, creating an effortless and intuitive experience.",
        "load": {
            "fail": {
                "title": "{{language}} Voice Controls Unavailable",
                "description": "Oh no! We couldn't load {{language}} for voice controls. Please check your internet connection and try again. Using English (US) until connection is restored."
            }
        }
    },
    "hotkey": {
        "title": "Quick Action Button",
        "titlePlural": "Quick Action Buttons",
        "titlePanel": "Quick Actions",
        "label": "Quick Action Button Display Name",
        "placeholder": "Name to display",
        "question": "What would you like to name this button?",
        "when": "When I tap...",
        "description": "Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. A single tap can run multiple steps or a single action.",
        "usagePrompt": "Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. You can add, remove, or edit the names from the main app control settings page.",
        "reorder": "You can rearrange the order using the move up and down buttons.",
        "emptySearch": "There are no quick actions matching this criteria.",
        "empty": "It looks like you don't currently have any quick actions.",
        "emptyLong": "No quick action buttons are configured in these app controls. Once you add quick action buttons or choose app controls with one, they'll appear here.",
        "emptyTitle": "No Quick Action Buttons",
        "edit": "Edit Quick Action Buttons",
        "tap": "Tap {{value}}",
        "copySuffix": "{{name}}_copy",
        "hotkeysOnly": "Custom Buttons",
        "allControls": "All App Controls",
        "show": "Show Quick Action Buttons",
        "deprecatedDialog": {
            "title": "Your app controls requires an update.",
            "description1": "It looks like you're using older app controls with quick action buttons. We've got some exciting updates in\n            store for you! We've revamped the system to make creating and editing quick action buttons a breeze, no\n            more diving into advanced settings.",
            "description2": "Just a quick update is all it takes—literally a second—and you'll be enjoying the seamless button\n            customization experience. Say goodbye to the extra steps and hello to a more user-friendly\n            interface. Ready to make the switch?",
            "confirm": "Let's do it!"
        },
        "demo": {
            "title": "Demo Quick Action Buttons",
            "description": "The demo area below will allow you to try quick action buttons. The demo is limited to specifically controlling this text area below.",
            "step1": "Turn On Quick Action Buttons",
            "step2": "Use the example prompts below to control the text block.",
            "command1": "Press button 1 to “Make text larger”",
            "command2": "Press button 2 to “bold text”",
            "command3": "",
            "continue": "Continue with Quick Action Buttons"
        },
        "example": {
            "title": "Examples of Quick Action Buttons ",
            "description": "These examples showcase the versatility of Quick Action Buttons in controlling your device or connection. They can be used to execute commands, navigate interfaces, or perform actions with a simple tap.",
            "command1": "Tap Pause",
            "example1": "Example “pause video”",
            "command2": "Tap Forward",
            "example2": "Example “zoom out”",
            "command3": "Tap Stop",
            "example3": "Example “close window”"
        }
    },
    "motion": {
        "title": "Motion Control",
        "titlePlural": "Motion Controls",
        "question": "What type of motion with a phone or tablet do you want to use?",
        "start": "Start Motion Controls",
        "settings": "Motion Settings",
        "descriptionShort": "Tilt, turn, or shake your connection to control Cephable.",
        "description": "Motion controls let you turn your phone or tablet movement in the Companion App into controls for your connection. Tilt or shake your phone in different directions to create new outputs.",
        "up": {
            "title": "Tilt Your Device Up",
            "description": "If your device is flat on a surface and you tilt it up to face you, this control will trigger."
        },
        "down": {
            "title": "Tilt Your Device Down",
            "description": "If your device is flat on a surface and you tilt it down to face away from you, this control will trigger."
        },
        "left": {
            "title": "Tilt Your Device Left",
            "description": "If your device is flat on a surface and you tilt it left to face toward the left, this control will trigger."
        },
        "right": {
            "title": "Tilt Your Device Right",
            "description": "If your device is flat on a surface and you tilt it right to face toward the right, this control will trigger."
        },
        "shake": {
            "title": "Shake Your Device",
            "description": "If you shake your device, this control will trigger."
        },
        "edit": {
            "title": "Edit Motion Settings",
            "description": "Change your motion control settings to adjust how much you need to move your phone while running to Companion App",
            "sensitivity": {
                "title": "Motion Control Sensitivity Settings",
                "description": "Sensitivity tells Cephable how far you need to tilt your device in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to tilt to trigger the control."
            },
            "tilt": {
                "title": "Tilt Sensitivity",
                "description": "These values determine how far you need to tilt your device up, down, left, and right for an input to be recognized."
            },
            "mouse": {
                "title": "Motion Controls for Mouse Movement",
                "description": "Determine if and how you want to use motion controls for moving your mouse instead of triggering controls",
                "enable": {
                    "title": "Enable Motion Controls for Mouse Movement",
                    "description": "If this is turned on, then some of your motion controls will be used to move your mouse instead of trigger controls.",
                    "option": "Use Motion Controls for Mouse Movement?"
                },
                "invert": {
                    "title": "Invert Mouse Movement",
                    "description": "For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.",
                    "x": "Invert X-axis Mouse Movement?",
                    "y": "Invert Y-axis Mouse Movement?"
                }
            }
        }
    },
    "keys": {
        "title": "Key or Button",
        "titlePlural": "Keys or Buttons",
        "label": "External Key / Button",
        "question": "What key or button do you want to press?",
        "edit": "Edit Keys and Buttons",
        "defaultOption": "Include default voice commands for keys and mouse clicks?",
        "description": "Keys and buttons allow you to map your different input controls to keyboard and controller button presses.",
        "then": "Cephable will press...",
        "empty": "There are no key controls matching this criteria.",
        "backspace": "Backspace",
        "delete": "Delete",
        "enter": "Enter",
        "space": "Space Bar",
        "tab": "Tab",
        "shift": "Shift",
        "ctrl": "Ctrl",
        "leftCtrl": "Left Ctrl",
        "rightCtrl": "Right Ctrl",
        "leftShift": "Left Shift",
        "rightShift": "Right Shift",
        "alt": "Alt",
        "leftAlt": "Left Alt",
        "escape": "Escape",
        "up": "Up Arrow",
        "down": "Down Arrow",
        "left": "Left Arrow",
        "right": "Right Arrow",
        "command": "Command",
        "caps": "Caps Lock",
        "reset": {
            "title": "Reset Keybindings",
            "confirm": "Reset all keybindings?",
            "confirmDescription": "Choose how you want to reset the keybindings. This action cannot be undone without saving.",
            "confirmButton": "Reset Keybindings",
            "defaultOption": "Reset to default values for the current language",
            "emptyOption": "Reset to empty (clear all commands)"
        }
    },
    "talkback": {
        "title": "Talkback",
        "question": "What do you want Cephable to say?",
        "description": "Setup controls that will have Cephable speak for you. You can assign controls to different phrases you want to be spoken.",
        "thenMacro": "then Cephable will say ...",
        "empty": "There are no talkback controls matching this criteria.",
        "deprecatedNotice": "Talkback is now integrated directly into the primary app controls. Your app controls has some older talkback events that need to be updated.",
        "add": "Add a New Talkback Control",
        "remove": "Remove Talkback Control",
        "edit": "Edit Talkback Controls"
    },
    "dictation": {
        "title": "Dictation",
        "question": "What phrase should trigger dictation mode?",
        "description": "Dictation lets you speak naturally and have your words typed while you talk. It's like having a personal assistant who types everything you say.",
        "thenMacro": "Cephable will...",
        "empty": "There are no dictation controls matching this criteria.",
        "type": "type",
        "edit": "Edit Dictation Phrases",
        "remove": "Remove Dictation Phrase",
        "add": "Add a New Dictation Phrase",
        "on": "Dictation",
        "off": "Commands",
        "onboarding": {
            "tourLabel": "Dictation",
            "learn": "Learn how to use dictation mode to convert your speech to text hands-free.",
            "welcome": {
                "title": "Dictation",
                "description": "Dictation lets you speak naturally and have your words typed while you talk. It's like having a personal assistant who types everything you say."
            },
            "microphone": {
                "title": "Turn on Your Microphone",
                "description": "First, turn on your microphone. Click the Microphone Toggle on the Cephable Panel."
            },
            "activate": {
                "title": "Start Dictation Mode",
                "description": "Voice starts in command mode. To start dictation, say \"Start dictation\" or click the Dictation button. Lets turn on dictation mode now."
            },
            "speaking": {
                "title": "Click a Document or Field and Start Speaking",
                "description": "Dictation will type out in real-time what you say. Click on a text field or document, then start speaking. For example, say: \"This is how to use dictation mode.\""
            },
            "pauseResume": {
                "title": "Pausing Dictation",
                "description": "Need a break without turning off dictation? Just say \"Pause dictation\". You can resume anytime with \"Start dictation.\" again. You can customize this further with your always on global and device controls."
            },
            "stop": {
                "title": "Stopping Dictation",
                "description": "Need to switch back to your app controls?  Just say \"Stop dictation\". This will stop dictation mode and return you to command mode. You can resume anytime with \"Start dictation.\" again."
            },
            "complete": {
                "title": "Congrats!",
                "description": "That's it! You can now dictate, pause, resume, and swap between dictation and command modes. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."
            }
        },
        "settings": {
            "title": "Dictation",
            "description": "How dictation starts and what happens to your words before they are typed."
        },
        "hold": {
            "enabled": {
                "option": "Hold to dictate",
                "description": "Hold the keys below, and nothing else, to start dictating. Let go to type what you said."
            },
            "keys": {
                "title": "Keys to hold",
                "description": "Pressing any other key while holding these cancels it, so your usual shortcuts keep working."
            },
            "duration": {
                "title": "Hold time",
                "description": "How long to hold the keys before dictation starts."
            },
            "transcribing": "Transcribing...",
            "aiRewriting": "AI rewriting...",
            "typing": "Typing...",
            "result": "{{words}} words in {{seconds}}s",
            "resultRewritten": "{{words}} words in {{seconds}}s, AI {{rewriteSeconds}}s",
            "permission": {
                "title": "Hold to dictate is waiting for permission",
                "description": "Grant Cephable access under System Settings > Privacy & Security > {{pane}}. Hold to dictate starts working as soon as you do."
            },
            "unavailable": "Hold to dictate could not start listening for the keys. Restart Cephable to try again."
        },
        "aiRewrite": {
            "option": "AI rewrite for long dictation",
            "description": "Before long dictation is typed, the on-device AI cleans up punctuation, filler words and corrections, and formats it for the app you are typing in. Short dictation is typed as you said it. Adds a short wait before typing."
        }
    },
    "suggestedPrompts": {
        "title": "Suggested Prompts",
        "description": "Customize suggested prompts that appear in AI tasks to help you get started quickly.",
        "edit": "Edit Suggested Prompts",
        "generate": "Generate Text",
        "rewrite": "Rewrite Text",
        "addGenerate": "Add a Generate Prompt",
        "addRewrite": "Add a Rewrite Prompt",
        "remove": "Remove Prompt",
        "generatePlaceholder": "Enter a prompt for text generation...",
        "rewritePlaceholder": "Enter a prompt for text rewriting...",
        "suggested": "Suggested prompts",
        "suggestedFor": "Suggested for {{profileName}}",
        "seeAll": "See all prompts",
        "showLess": "Show less",
        "allPrompts": "All Prompts",
        "customFor": "Custom prompts for {{profileName}}",
        "defaultPrompts": "Default prompts",
        "defaultGenerate": [
            "A professional email introducing our new product",
            "A meeting agenda for next week's team discussion",
            "A project proposal outline for a new initiative",
            "A formal business letter template",
            "A technical documentation section",
            "A user manual introduction",
            "A training document overview",
            "A policy document draft",
            "A follow-up email after a meeting",
            "A thank you message to a client",
            "A project status update email",
            "An invitation to a company event",
            "A reminder email for upcoming deadlines",
            "A welcome email for new team members",
            "An apology email for service interruption",
            "A newsletter introduction",
            "A brainstorming list for marketing campaigns",
            "Creative solutions for improving team productivity",
            "Ideas for a company retreat activities",
            "Concepts for a new mobile app feature",
            "Suggestions for improving customer experience",
            "Innovation ideas for our product development",
            "Content ideas for social media posts",
            "Workshop topics for professional development",
            "A function that validates user input",
            "A database query for user management",
            "Error handling code for API requests",
            "A configuration file template",
            "Comments explaining a complex algorithm",
            "Unit test cases for a new feature",
            "Documentation for API endpoints",
            "A script for automated deployment"
        ],
        "defaultRewrite": [
            "Make this text more concise and to the point",
            "Expand this summary with more detail",
            "Reformat this as a numbered list",
            "Convert this to bullet points",
            "Restructure this into clear paragraphs",
            "Make this text easier to scan quickly",
            "Organize this information hierarchically",
            "Format this as a step-by-step guide",
            "Make this message more professional and formal",
            "Rewrite this to sound more casual and friendly",
            "Adjust the tone to be more encouraging",
            "Make this sound more confident and assertive",
            "Soften the tone to be more diplomatic",
            "Add enthusiasm and energy to this text",
            "Make this more empathetic and understanding",
            "Rewrite with a more collaborative tone",
            "Simplify this for a general audience",
            "Make this explanation more technical and detailed",
            "Break down this complex concept into simpler terms",
            "Add more context and background information",
            "Summarize this into key takeaways",
            "Elaborate on the main points with examples",
            "Make this more accessible to beginners",
            "Condense this while keeping the essential information",
            "Improve the clarity and readability",
            "Make this more engaging and interesting",
            "Adjust for better grammar and flow",
            "Rewrite to emphasize the benefits"
        ],
        "defaultSummarize": [
            "Summarize in 3 bullet points",
            "Extract key decisions",
            "List the main action items",
            "Provide a one-sentence summary",
            "Highlight the most important facts",
            "Summarize for a non-technical audience",
            "Extract the key takeaways",
            "Summarize in 5 bullet points",
            "Identify the core problem and proposed solution",
            "List all conclusions and recommendations",
            "Provide an executive summary",
            "Summarize the timeline of events",
            "Extract all questions raised",
            "List the pros and cons mentioned",
            "Summarize the key arguments"
        ]
    },
    "face": {
        "title": "Face Expression",
        "titlePlural": "Face Expressions",
        "try": "Try Face Expression Controls",
        "question": "What type of face expression do you want to use?",
        "descriptionShort": "Use different face movements for enhanced controls.",
        "description": "Face expressions are part of Expression Controls. It lets you use different face movements for enhanced controls. You can use eyebrow movement, mouth movement, and more to create different outputs."
    },
    "other": {
        "title": "Other",
        "titlePlural": "Other Controls",
        "label": "Other Control",
        "placeholder": "other experimental command",
        "question": "What additional command would you like to use? These are typically for non-Cephable connections that don't fit into other categories. They may also function as voice commands when you speak the specified word or phrase. Note: These controls are experimental and may not be fully supported.",
        "description": "Other controls are experimental and may not be fully supported. They can be used for non-Cephable connections or as voice commands when you speak the specified word or phrase."
    },
    "support": {
        "title": "Support",
        "question": "Still not finding what you need?",
        "more": "Learn more at Cephable.com with step-by-step guides, tutorials, videos, and more.",
        "profiles": "Introduction to App Controls"
    },
    "community": {
        "title": "Join the Community",
        "description": "Get support, share ideas, or become a member of Cephable's communities.",
        "discord": "Discord Community",
        "facebook": "Facebook Group"
    },
    "resources": {
        "title": "Helpful Resources",
        "description": "Find answers to your questions about Cephable features and functions.",
        "guides": "Step by Step Guides"
    },
    "feedback": {
        "title": "Feedback",
        "description": "Tell us about your experience with Cephable.",
        "contact": "Contact Us",
        "feature": "Suggest a Feature",
        "bug": "Report an Issue"
    },
    "settings": {
        "title": "Settings",
        "advanced": {
            "title": "Advanced Settings",
            "description": "Click here to get advanced settings for your AI settings, app controls, connections, extensions, and more."
        },
        "orgTitle": "{{ value }} Settings",
        "general": "General App Settings",
        "description": "This is your canvas for tailoring-your experience by fine-tuning your controls.",
        "quick": "Here are contextual settings for the panel. Use this to fine tune your current experience."
    },
    "account": {
        "title": "Account",
        "menu": "User Menu",
        "settings": "Account Settings",
        "description": "Update key information to stay connected with Cephable.",
        "usernameLabel": "Username: ",
        "emailLabel": "Email: ",
        "delete": {
            "title": "Delete Account",
            "description": "You can permanently delete your account and remove all reference to your personal information. When you delete your account, your connections will be removed, and will no longer work or be registered to your account, your app controls and all settings will be lost. This process can not be undone.",
            "button": "Permanently Delete Account",
            "confirmation": "Are you sure you want to delete your account?",
            "note": "This action is irreversible.",
            "confirm": "Yes, delete my account"
        },
        "password": {
            "change": "Change Password",
            "description": "Update your password to keep your account secure.",
            "old": "Old Password",
            "current": "Your current password",
            "new": "New Password",
            "desired": "Your desired new password",
            "confirm": "Confirm New Password",
            "update": "Update Password"
        },
        "isEmailVerified": {
            "title": "Email is not verified.",
            "titleAlt": "Verify your email address",
            "description": "Your email is not verified. Please check your email for a verification link.",
            "descriptionLong": "Welcome to Cephable! A verification email has been sent to {{email}}. Please check your inbox or spam folder and click on the link. If you don't see it, you can resend the verification email.",
            "org": "Your email is not verified. It is required to access license details. Please check your email for a verification link.",
            "resend": "Resend Email",
            "success": "We have sent you a new verification email.",
            "error": "There was an error sending the verification email. Please try again later.",
            "appBlock": "You're almost there! A verification email has been sent to {{email}}. Please check your inbox and click the link to verify your email address. If you don't see it, check your spam folder."
        },
        "signout": {
            "title": "Sign Out",
            "description": "Once you sign out, this connection will be removed from your account and no longer be visible from the Companion App or other connections.",
            "question": "Are you sure you want to sign out?",
            "confirm": "Yes, sign out",
            "confirmDescription": "Signing you out and removing this connection",
            "warn": {
                "title": "You’re about to be signed out.",
                "description": "It looks like you’ve been inactive for a while. For security reasons, we’ll sign you out in XX seconds. If you’d like to stay logged in, click “Stay Logged In” below.",
                "confirm": "Stay Logged In",
                "cancel": "Sign Out Now"
            }
        },
        "marketing": {
            "title": "Email Preferences",
            "description": "Update your email preferences to receive updates and news from Cephable.",
            "marketing": "Marketing Emails",
            "optIn": "I would like to receive tutorials, tips, updates and newsletters to enhance my Cephable experience"
        },
        "error": {
            "save": "Error saving account settings.",
            "password": "Error updating password.",
            "signout": "Error signing out.",
            "old": "Old password is required.",
            "new": "New password is required.",
            "match": "Passwords do not match.",
            "marketing": "Error updating email preferences.",
            "userPreferences": "Error saving user preferences."
        },
        "success": {
            "save": "Account settings saved.",
            "password": "Password updated.",
            "marketing": "Email preferences updated.",
            "userPreferences": "User preferences updated."
        },
        "userPreferences": {
            "title": "User Preferences",
            "description": "Update your preferences to create the Cephable experience that works for you.",
            "warningOptOut": "Hide warnings when I save or update app controls",
            "enableMetrics": "Enable usage metrics output for performance testing. You will be able to download the logs.",
            "enableTranscribeTask": "Enable the experimental file transcriber task in the Cephable Panel",
            "enableGamepadSupport": "Enable gamepad support for local driver and Xbox controller emulation",
            "enableCameraControls": "Enable camera controls in the Cephable Panel",
            "enableWorkflowRecording": "Enable the Record a Workflow preview in Automate and AI Skills"
        },
        "communication": {
            "title": "Communication Preferences"
        },
        "name": {
            "title": "Display Name"
        },
        "email": {
            "title": "Email Address",
            "description": "Your registered email address"
        }
    },
    "license": {
        "titlePlural": "Licenses",
        "trial": {
            "title": {
                "single": "You've been upgraded to {{productName}} for free with {{days}} Days Remaining",
                "multiple": "{{organization}} is on a Free Trial with {{days}} Days Remaining"
            },
            "subtitle": "You can invite {{count}} colleagues to try Cephable with you. ",
            "noUsersSubtitle": "You have no trial users remaining. Upgrade to a paid license to add more users.",
            "upgrade": "By upgrading, maintain your access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.",
            "expired": {
                "user": "Your free upgrade to {{productName}} expires on {{date}}. To upgrade, please contact your organization administrator - {{admin}}.",
                "userLong": "It looks like your free upgrade to {{productName}} has expired. To upgrade, please contact your organization administrator - {{admin}}.",
                "admin": "Your free upgrade to {{productName}} expires on {{date}}.",
                "adminLong": "It looks like your free upgrade to {{productName}} has expired. You can upgrade your license to continue accessing advanced features not available in Cephable Basic."
            },
            "start": "Start a Free Trial"
        },
        "key": {
            "title": "License Key",
            "titlePlural": "License Keys",
            "details": "License Key Details",
            "description": "A License Key is a unique identifier used to grant access to Cephable Professional, Education, or Developer features.",
            "assigned": "Used on: {{date}}",
            "expires": "Expires on: {{date}}",
            "assign": "Assign Key to New Organization",
            "error": "Error loading license key.",
            "empty": {
                "title": "No License Keys found.",
                "description": "It doesn't look like there are license keys matching this criteria. Or you have not purchased a license key yet."
            },
            "product": {
                "title": "Purchase",
                "titleLong": "Purchase License Keys",
                "description": "Purchase a license key to unlock the full potential of Cephable. View the different plans and pricing options available.",
                "action": "Purchase Now",
                "empty": {
                    "title": "No Products Found.",
                    "description": "It looks like you don't have any products. Please reach out to our sales team or your representative to help resolve this."
                },
                "yearly": "Billed yearly",
                "years": "Billed every {{value}} years",
                "days": "Billed every {{value}} days",
                "Subscription": {
                    "title": "Subscription"
                },
                "MeteredConsumption": {
                    "title": "Metered Consumption"
                },
                "PayDown": {
                    "title": "Pay Down"
                },
                "OneTime": {
                    "title": "One Time"
                }
            }
        },
        "upgrade": {
            "professional": "Upgrade to Cephable Professional License",
            "generic": {
                "title": "Upgrade your Cephable Experience",
                "description": "The Cephable Platform offers different products for commercial use at work, school, or integrated into native solutions."
            },
            "fallback": {
                "title": "Error Loading Billing Portal",
                "description": "Unable to load the billing portal in app. Please click the button below to continue with the upgrade."
            }
        },
        "required": {
            "title": "Cephable Professional License is Required",
            "description": "It looks like you are using Cephable Basic which does not support the commercial use of Cephable. Please upgrade to a professional license to continue using the app."
        },
        "activate": {
            "question": "Already have a license key?",
            "button": "Activate",
            "title": "Activate License Key",
            "description": "Enter your license key to upgrade Cephable.",
            "descriptionLong": "Enter your license key to upgrade Cephable. If you don't have one, start a free trial or purchase a license.",
            "fieldLabel": "License Key",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "invalid": {
                "empty": {
                    "key": "Invalid key. Please make sure you have entered a value.",
                    "name": "Invalid Organization Name. Please make sure you have entered a value."
                },
                "key": "Invalid key. Please make sure you have entered the correct key."
            },
            "success": "Congrats. Your account has been upgraded to {{license}}!"
        },
        "welcome": {
            "title": "Welcome to {{license}}.",
            "description": "You have successfully joined {{organization}}. {{description}}"
        },
        "redirect": {
            "title": "Redirecting",
            "description": "You have been redirected to an external billing portal. This will open a new tab in your browser. If you are not redirected within a few seconds, please click the button below.",
            "error": "Billing Redirect Error",
            "external": "Redirected. Please check your browser."
        },
        "pro": {
            "tag": "Pro",
            "detail": "This is a Cephable Professional only feature",
            "requiredDetail": "A Cephable Professional License is required for this feature. You can upgrade or start a free trial in your Account Settings"
        }
    },
    "publicProfiles": {
        "toolbar": "Explore App Controls",
        "title": "Explore App Controls",
        "description": {
            "personal": "Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls from scratch.",
            "pro": "Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls through the control generator."
        },
        "offline": {
            "title": "Unable to Load Public App Controls",
            "description": "It looks like you are offline. You can still use your app controls, but you will not be able to load new public app controls.",
            "confirm": "Okay"
        },
        "announcement": "{{count}} New App Controls have been loaded",
        "team": "Cephable Team"
    },
    "device": {
        "title": "Connection",
        "titlePlural": "Connections",
        "titleShort": "Connect",
        "titleLong": "Connections & Extensions",
        "description": "Cephable supports multiple devices and connections. You can manage settings or select any of them all from here. You will always have this computer as your main connection. You can add more connections later.",
        "viewAll": "View All Connections",
        "new": "You have a new connection!",
        "newLong": "You have a new connection! To start using it, select it from the menu below.",
        "add": {
            "short": "Extend",
            "title": "Add a New Connection or Extension",
            "description": "Connections and extensions are additional ways you can enhance your Cephable experience. You can add new connections to connect to more devices, applications, or games. Take your Cephable experience to the next level by adding connections and extensions.",
            "action": "Add a New Connection",
            "notAvailable": "This connection or extension is not currently available to the public. This often occurs when working with user generated extensions. Please check back later.",
            "isNotPublic": "PREVIEW: This extension is in developer preview and may be incomplete. Developers should complete all steps before public release. Users can check back later for the full version."
        },
        "swap": {
            "titlePlural": "Swap Connections",
            "description": "Cephable supports multiple devices and connections. You can select any of them from here. This computer will always be your main connection. You can add more connections later."
        },
        "status": {
            "title": "Connection Status: ",
            "connected": {
                "application": "Connected Application",
                "connection": "Connected",
                "device": "Connected Device",
                "game": "Connected Game"
            },
            "disconnected": {
                "application": "Disconnected Application",
                "connection": "Disconnected",
                "device": "Disconnected Device",
                "game": "Disconnected Game"
            }
        },
        "control": {
            "button": "Control {{name}}",
            "generic": "Control Connection",
            "description": {
                "application": "Control this connected application using your voice, quick actions, head movements, and more. For instance, if you say 'Save' this will save on your running application.",
                "connection": "Control this connected connection using your voice, quick actions, head movements, and more. For instance, if you say 'Save' this will save on your running connection.",
                "device": "Control this connected device using your voice, quick actions, head movements, and more. For instance, if you say 'Open Spotify' this will open Spotify on running device.",
                "game": "Control this connected game using your voice, quick actions, head movements, and more. For instance, if you say 'Go' this will make the player move in running game."
            }
        },
        "running": "Running",
        "offline": "Offline",
        "otherDevices": "Other Output Connections",
        "currentStatus": "Current Status: ",
        "connectionStatus": "Connection Status: ",
        "profileStatus": "Current App Controls: ",
        "name": {
            "title": "Connection Name",
            "question": "What do you want to call this connection?",
            "description": "Give your connection a name so you can easily find it later.",
            "placeholder": "connection name",
            "edit": "Edit Connection Name"
        },
        "updates": {
            "title": "Connection Updates",
            "settings": "Connection Update Settings",
            "description": "Check for connection firmware updates and change auto-update settings",
            "edit": "Edit Update Settings",
            "check": {
                "title": "Check for Updates",
                "processing": "Checking for updates! It may take a few minutes and your connection may restart during updates.",
                "description": "Tap to check for updates for your connection. If there is an update available and your connection is active, it will start updating. Updates can take a few minutes."
            },
            "auto": {
                "title": "Automatically Update",
                "description": "With this setting turned on, your connection will automatically update whenever it is plugged in, connected to wi-fi, and an update is available. If this is off, you need to tap the update button to get the latest.",
                "option": "Use Auto-Update?"
            }
        },
        "delete": {
            "title": "Unlink {{name}}",
            "titleLong": "Unlink From Account",
            "description": "Unlinking disconnects Cephable from this computer or game and removes it from your account. You will no longer be able to connect to it, send commands, or update it. This can not be undone but you can create a new connection to the same computer or game if you want to use it again in the future.",
            "confirm": "Are you sure you want to unlink this connection?",
            "confirmLong": "Are you sure you want to deregister and reset this connection? You will no longer be able to connect to it, send commands, or update it. After this de-register and reset, anyone else can setup this connection from scratch.",
            "confirmButton": "Yes, remove this connection."
        },
        "manage": {
            "title": "Click to view and manage details for your connections.",
            "description": "",
            "name": "Customize your connection name for easier management."
        },
        "error": {
            "save": "Error saving connection.",
            "load": "Error loading connection.",
            "add": "Error adding connection.",
            "delete": "Error deleting connection.",
            "updates": "Error checking for updates.",
            "connection": "Connection is not established. Make sure it is connected before trying again.",
            "deleteLong": "We were unable to delete this connection from your account. If you log in again to this account, you may need to manually delete this connection in the connection settings."
        },
        "success": {
            "save": "Connection saved.",
            "add": "Connection added.",
            "delete": "Connection deleted."
        },
        "selectDevice": "Select device"
    },
    "appSettings": {
        "title": "General App Settings",
        "description": "These settings only apply to this app. If you want to change the settings of the Cephable app on another computer or mobile device, edit the settings in that app.",
        "autostart": {
            "title": "Automatically Start Cephable",
            "description": "With this setting turned on, the Cephable app will automatically start when you log in to your device. If you also have automatic voice and expression controls, those will also start right away.",
            "question": "Autostart Cephable App?"
        },
        "automationBrowser": {
            "title": "Automation Browser Visibility",
            "description": "When the AI agent uses the Cephable browser (web research, Google Docs/Sheets/Slides, Gmail, Drive), it normally runs hidden in the background so it doesn't interrupt you. Turn this on to watch it work.",
            "question": "Show the automation browser while the AI works?"
        },
        "aiNewFiles": {
            "title": "Folder for New AI Files",
            "description": "Choose where the AI agent saves new files by default, unless you tell it a specific location. If left as the default, new files are saved to a \"Cephable-Work\" folder in your home directory, which is created automatically the first time it is needed.",
            "selectButton": "Select Folder",
            "openButton": "Open Folder",
            "openError": "Couldn't open the folder. It may have been moved or deleted.",
            "clearButton": "Use Default Folder",
            "current": "New files are saved to: {{folder}}",
            "default": "New files are saved to the default \"Cephable-Work\" folder in your home directory."
        },
        "aiWorkspace": {
            "title": "AI Workspace Folder",
            "description": "Choose a folder the on-device AI agent uses for finding, reading, and editing files and for running commands. By default the agent can access your whole computer.",
            "selectButton": "Select Folder",
            "clearButton": "Use Entire Computer",
            "current": "Current workspace folder: ",
            "none": "No workspace folder selected. The AI agent can access your entire computer.",
            "restrictQuestion": "Restrict the AI agent to this folder only",
            "restrictDescription": "When enabled, the AI agent's file and command tools cannot read or change anything outside the selected folder."
        },
        "documentTemplates": {
            "title": "Document Templates",
            "description": "Choose a template file the AI agent starts from when it creates new documents. Leave a type on the Cephable default to apply built-in Cephable brand styling. Word, PowerPoint, and Excel each have their own template.",
            "word": "Word Template",
            "wordDescription": "Template the AI agent starts from for new Word documents (.docx).",
            "powerpoint": "PowerPoint Template",
            "powerpointDescription": "Template the AI agent starts from for new PowerPoint presentations (.pptx).",
            "excel": "Excel Template",
            "excelDescription": "Template the AI agent starts from for new Excel workbooks (.xlsx).",
            "selectButton": "Choose File",
            "clearButton": "Use Cephable Default",
            "current": "Template: ",
            "default": "Using the built-in Cephable default template with brand styling."
        },
        "overlay": {
            "title": "Command Feed",
            "description": "The command feed will show the different controls you use and what controls were sent to your computer. It is click-through but will always be on top of other windows. With this setting turned on, the Cephable app will show and will always be on top of other windows and applications.",
            "question": "Show Command Feed?"
        },
        "position": {
            "label": "Select Command Feed Position",
            "description": "Select where you want the command feed to appear on your screen.",
            "topLeft": "Top Left",
            "top": "Top Center",
            "topRight": "Top Right",
            "bottom": "Bottom Center",
            "bottomLeft": "Bottom Left",
            "bottomRight": "Bottom Right"
        },
        "panelAutoHide": {
            "title": "Auto-Hide Cephable Panel",
            "delay": "Delay before hiding",
            "denominator": " seconds",
            "time": "{{value}} seconds"
        },
        "transparent": {
            "title": "Command Feed Transparency",
            "description": "The determines the opacity of the text. The lower the value, the more see-through the feed will be."
        },
        "micPosition": {
            "title": "Microphone Input Window Position",
            "description": "Select where you want the microphone controls for voice and dictation to be positioned on your screen.",
            "label": "Select Microphone Input Window Position"
        },
        "cameraPosition": {
            "title": "Camera Input Window Position",
            "description": "Select where you want the camera controls for face and head movement to be positioned on your screen.",
            "label": "Select Camera Input Window Position"
        },
        "theme": {
            "title": "Theme",
            "description": "Choose a theme that suits your style.",
            "label": "Select a Theme",
            "light": "Light",
            "dark": "Dark",
            "system": "Use OS System settings"
        },
        "scale": {
            "description": "Adjust the text size across the app.",
            "label": "Text Size",
            "small": "Small",
            "large": "Large"
        },
        "panelScale": {
            "description": "Adjust the size of the collapsed panel button.",
            "label": "Panel Button Size"
        }
    },
    "shortcuts": {
        "title": "Global Shortcuts",
        "description": "Customize keyboard shortcuts for quick access to Cephable controls from anywhere on your system.",
        "info": "These shortcuts work globally and can be used even when Cephable is not the active window.",
        "shortcut": "Shortcut",
        "toggleMicrophone": "Toggle Microphone",
        "toggleDictation": "Toggle Dictation Mode",
        "toggleVoiceControl": "Toggle Voice Control Mode",
        "togglePanel": "Toggle Panel",
        "registrationFailed": "Some global shortcuts failed to register. They may be in use by another application:",
        "record": {
            "title": "Record Shortcut",
            "start": "Click to Record",
            "listening": "Press your desired key combination...",
            "pressKeys": "Press keys now"
        },
        "formatHint": "Select at least one modifier key ({{modifierKey}}, {{modifierKey2}}, Shift) and one other key."
    },
    "input": {
        "title": "Input",
        "titlePlural": "Input Controls",
        "explore": "Explore Input Controls",
        "descriptionShort": "Explore the various input controls Cephable utilizes to create a better digital experience for you.",
        "description": "Input controls are the different methods used to control your device. Such as your voice, head movement, face expressions, and additional connections. Explore the different input controls below to learn more.",
        "typeLabel": "Input Control Type",
        "toolTip": "This uses {{alt}}",
        "remove": "Remove Input Control",
        "filter": "Filter by Input Type",
        "select": "Select an Input",
        "question": "What type of input do you want to use?",
        "add": "Add Input",
        "addMore": "Add another input",
        "removeItem": "Remove item {{index}}",
        "item": "Item {{index}}: {{label}}",
        "duplicate": "Duplicate items are not allowed.",
        "maximum": "Maximum of {{maxItems}} items allowed."
    },
    "time": {
        "soon": "Coming Soon",
        "now": "Now",
        "today": "Today",
        "yesterday": "Yesterday",
        "minutesAgo": "{{count}} minute ago",
        "minutesAgo_plural": "{{count}} minutes ago",
        "daysAgo": "{{count}} days ago",
        "daysAgo_plural": "{{count}} days ago",
        "monthsAgo": "{{count}} month ago",
        "monthsAgo_plural": "{{count}} months ago",
        "yearsAgo": "{{count}} year ago",
        "yearsAgo_plural": "{{count}} years ago",
        "minutesAhead": "in {{count}} minutes",
        "todayAhead": "later today",
        "tomorrow": "tomorrow",
        "daysAhead": "in {{count}} days",
        "monthsAhead": "in {{count}} months",
        "yearsAhead": "in {{count}} years"
    },
    "peripherals": {
        "empty": "No Peripherals Detected",
        "switch": "Switch",
        "keyboard": "Keyboard",
        "gamepad": "Gamepad",
        "companionApp": "Companion App",
        "available": "Available to use",
        "error": "Check your settings."
    },
    "textGeneration": {
        "settings": "Text Generation Settings",
        "skipTyping": {
            "complete": "{{task}} completed and ready to be copied to your clipboard."
        },
        "edit": {
            "title": "Edit Text Generation Settings",
            "description": "Cephable's intelligent text generation feature allows you to use the \"generate\" device control to create text in any app. You can generate emails, paragraphs, messages, code, and more. It will generate the text wherever your cursor is as if you were typing it yourself. This feature uses on-device generative AI, which means your content never leaves your machine but that you should check content for accuracy. Use these settings to edit your preferences for how Cephable loads AI models on your device and how it generates text for you.",
            "autoStart": {
                "title": "Automatically Warm Up Text Generation",
                "description": "With this setting turned on, Cephable AI will automatically warm up the AI models used for Create or Automate tasks. Warming up the models will make them perform faster, but will consume more resources on your computer. Turning this setting off will save resources, but may make the tasks slower.",
                "option": "Auto warm up text-generation AI models?"
            },
            "enableTextGen": {
                "title": "Enable Intelligent Text Generation",
                "description": "With this setting turned on, Cephable AI can draft, rewrite, summarize, and translate content, or automate desktop actions across your apps.",
                "option": "Use Intelligent Text Generation?"
            },
            "modelSelection": {
                "title": "AI Model",
                "description": "Choose the AI model family and size that runs on this device. Larger models produce better results but use more resources. Download more than one to switch between them quickly.",
                "family": "Model Family",
                "size": "Model Size",
                "downloaded": "Downloaded",
                "downloading": "Downloading…",
                "download": "Download",
                "delete": "Delete download",
                "unavailable": "Not supported on this device",
                "notEnoughSpace": "Not enough space on device",
                "notEnoughSpaceDetail": "Needs {{required}} but only {{free}} is free on this device. Free up space and try again.",
                "requiresBetterDevice": "This model needs a more capable device to run.",
                "selectPrompt": "Select a model",
                "notDownloaded": "This model is selected but not downloaded yet. Click Download to use it.",
                "readyToUse": "Downloaded — ready to use",
                "noModels": "No compatible models are available for this device yet.",
                "offlineNoModels": "You're offline and no models are saved on this device yet. Connect to the internet to see and download available models.",
                "offlineDownloadUnavailable": "You're offline, so this model can't be downloaded. Connect to the internet to download it, or switch to a model you've already downloaded.",
                "deleteConfirm": {
                    "title": "Delete downloaded model?",
                    "description": "This frees up disk space. You can download it again later."
                },
                "license": {
                    "upgrade": "Requires a license upgrade",
                    "blockedNeedsDownload": "This model requires {{license}}. Download a lower model or upgrade to continue."
                },
                "fallback": {
                    "alert": "{{fallback}} is being used instead of {{preferred}}, which requires an upgrade.",
                    "active": "{{preferred}} requires {{license}}. {{fallback}} is being used instead until you pick a different model or upgrade."
                }
            },
            "enableHistory": {
                "title": "Enable Text Generation History",
                "description": "With this setting turned on, Cephable AI will use your text generation history to generate text with context of your previous action.",
                "option": "Use Text Generaton History?"
            },
            "prompt": {
                "title": "Additional Information for Text Generation",
                "description": "Enter additional details to be used with Cephable's AI to generate text. Use this field to enter preferences for your tone, style of writing, or any other details.",
                "field": "Additional prompt",
                "placeholder": "e.g. Use a friendly tone, write like a professional, be succint and to the point. When writing code, leave thoughtful comments but not too many, etc."
            },
            "terminate": {
                "title": "Clear AI Resources",
                "description": "Click to clear the resources used for Create or Automate tasks. This will free up resources on your computer, but may make these tasks slower the next time you use them.",
                "button": "Clear Resources",
                "success": "Clearing text generation resources.",
                "confirm": {
                    "title": "Clear AI Resources",
                    "description": "Are you sure you want to clear the resources used for Create or Automate tasks? This will free up resources on your computer, but may make these tasks slower the next time you use them.",
                    "confirm": "Yes, clear resources",
                    "cancel": "Cancel"
                }
            },
            "clearModelCache": {
                "title": "Clear AI Models Cache",
                "description": "This will free up storage on your computer and re-download the current selected model.",
                "button": "Clear and Re-download",
                "success": "Deleted local model files.",
                "error": "Error deleting local model files.",
                "confirm": {
                    "title": "Clear and Re-download AI Model Cache",
                    "description": "Are you sure you want to clear the AI model cache and delete the files from your system? The current selected model will be re-downloaded automatically.",
                    "confirm": "Yes, clear and re-download",
                    "cancel": "Cancel"
                }
            }
        },
        "prompt": {
            "systemPrompt": "Generate ONLY the requested text—no explanations, commentary, or fluff. No unprompted markdown or explanation. For code, output raw code only: no fences, no language tags, no explanation.",
            "appName": "You are currently generating text for {{appName}}.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}."
        },
        "summarizePrompt": {
            "systemPrompt": "Summarize the provided text concisely. It may be part of a larger document. Do not use markdown formatting or code fences. Output ONLY the summary—no preamble, labels, explanation, or commentary, and do not explain what you did.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}.",
            "summarizeInstructions": "Instructions: {{summarizeInstructions}}.",
            "userPrompt": "Summarize: {{userRequestText}}"
        },
        "rewritePrompt": {
            "systemPrompt": "Rewrite or reformat the provided text as instructed. If reformatting (e.g. lists, tables, structure changes), preserve the original words exactly. If rewriting (e.g. tone, style, length), preserve the meaning but not necessarily the words. This may be part of a larger document. Match the input's formatting: if the source text is already markdown or code, preserve it. Otherwise do not introduce markdown formatting (headings, bold, bullets, code fences) unless the instructions explicitly request a list, table, or similar structure. Output ONLY the result—no preamble, labels, headings, explanations, or commentary.",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}.",
            "rewriteInstructions": "Instructions: {{rewriteInstructions}}."
        },
        "translatePrompt": {
            "systemPrompt": "Translate the following text into {{language}}. Output ONLY the translated text. No explanations, no preamble, no markdown formatting, no code fences, no notes, no parenthetical remarks about the translation. Retain formatting. For code: translate comments and strings only, preserve syntax exactly. ",
            "userPreferences": "Respect these user preferences for how they want text generated: {{userPreferences}}.",
            "genericUserPrompt": "Translate: {{userRequestText}}"
        },
        "disabled": {
            "title": "Intelligent Tasks is Disabled",
            "description": "It looks like you have disabled intelligent tasks. Update to unlock text generation, rewriting, and more in your settings."
        }
    },
    "scheduledTasks": {
        "title": "Scheduled Tasks",
        "description": "Automations set to run at a time you choose. Everything stays on this device.",
        "hint": "Scheduled tasks run only while this app is running. If your PC is off or the app is closed at the scheduled time, the run is marked missed and you can run it later.",
        "new": "New scheduled task",
        "scheduleButton": "Schedule",
        "skippedBusy": "Skipped because another workflow was already running.",
        "create": {
            "title": "New scheduled task",
            "description": "Set up a prompt to run automatically on a schedule.",
            "saved": "Scheduled task created."
        },
        "composer": {
            "placeholder": "Describe what Cephable should do… Use / or @ to add skills and connectors."
        },
        "runHistory": {
            "title": "Run history",
            "viewRun": "View run",
            "noOutput": "No saved output",
            "resolution": {
                "ignored": "Ignored",
                "rerun": "Rerun",
                "rescheduled": "Rescheduled"
            }
        },
        "badge": {
            "scheduled": "Scheduled",
            "recurring": "Recurring"
        },
        "fromRun": {
            "scheduled": "This run is part of a scheduled task: {{name}}",
            "recurring": "This run is part of a recurring task: {{name}}",
            "view": "View scheduled task"
        },
        "search": {
            "placeholder": "Search scheduled tasks..."
        },
        "filter": {
            "label": "Filter",
            "all": "All",
            "enabled": "Active",
            "paused": "Paused",
            "missed": "Missed"
        },
        "empty": {
            "title": "No scheduled tasks yet",
            "description": "Schedule a prompt by right-clicking the send button in the panel while in Auto or Automate mode."
        },
        "pagination": {
            "range": "{{start}}–{{end}} of {{total}}"
        },
        "status": {
            "running": "Running",
            "success": "Succeeded",
            "failed": "Failed",
            "missed": "Missed",
            "paused": "Paused"
        },
        "summary": {
            "once": "Once on {{datetime}}",
            "everyOne": "Every {{unit}}",
            "everyN": "Every {{count}} {{unit}}",
            "onDays": "on {{days}}",
            "onDayOfMonth": "on day {{day}}",
            "atTime": "at {{time}}",
            "unit": {
                "minute": "minute",
                "minute_other": "minutes",
                "hour": "hour",
                "hour_other": "hours",
                "day": "day",
                "day_other": "days",
                "week": "week",
                "week_other": "weeks",
                "month": "month",
                "month_other": "months"
            }
        },
        "card": {
            "nextRun": "Next run",
            "viewLastRun": "View last successful run",
            "noSuccessfulRun": "No successful run yet",
            "runNow": "Run now",
            "pause": "Pause",
            "resume": "Resume",
            "enabledToggle": "Enable or pause this task"
        },
        "missed": {
            "runNow": "Run now",
            "reschedule": "Reschedule",
            "ignore": "Ignore"
        },
        "runNow": {
            "started": "Running \"{{name}}\" now.",
            "busy": "Another workflow is already running. Try again once it finishes."
        },
        "overlap": {
            "title": "Schedules overlap",
            "description": "This runs within 5 minutes of \"{{name}}\" ({{time}}). Only one automation runs at a time, so one will wait for the other to finish. Schedule it anyway?",
            "confirm": "Schedule anyway"
        },
        "delete": {
            "title": "Delete scheduled task?",
            "description": "This permanently removes the scheduled task. This can't be undone."
        },
        "editor": {
            "kindLabel": "Schedule type",
            "once": "One time",
            "recurring": "Recurring",
            "runAt": "Run at",
            "frequency": "Repeats",
            "every": "Every",
            "interval": "Interval",
            "units": "Units",
            "onDays": "On days",
            "dayOfMonth": "Day of month",
            "atTime": "At time",
            "startAt": "Starts",
            "endsOn": "Ends on"
        },
        "edit": {
            "title": "Edit scheduled task",
            "description": "Adjust the prompt and its schedule before it runs.",
            "name": "Name",
            "namePlaceholder": "Name this scheduled task",
            "prompt": "Prompt",
            "customContext": "Custom context",
            "contextNote": {
                "generic": "This task's context is resolved when it runs.",
                "highlighted": "This task uses the highlighted text in your active app at run time.",
                "clipboard": "This task uses your clipboard contents at run time.",
                "auto": "This task's context is resolved automatically when it runs."
            },
            "attachments": "Attached files & folders",
            "skills": "Skills",
            "connectors": "Connectors",
            "schedule": "Schedule",
            "goalRequired": "Enter a prompt for this task.",
            "saved": "Scheduled task saved.",
            "notFound": "This scheduled task no longer exists."
        },
        "schedulePrompt": {
            "menuItem": "Schedule this prompt…",
            "title": "Schedule this prompt",
            "prompt": "Prompt",
            "name": "Name (optional)",
            "namePlaceholder": "Name this scheduled task",
            "confirm": "Schedule",
            "goalRequired": "Enter a prompt to schedule.",
            "success": "Prompt scheduled.",
            "error": "Couldn't schedule this prompt."
        },
        "notify": {
            "runStarted": {
                "title": "Scheduled task running",
                "body": "\"{{name}}\" is running now."
            },
            "missed": {
                "title": "Missed scheduled task",
                "bodyOne": "\"{{name}}\" was missed while the app wasn't running.",
                "bodyMany": "{{count}} scheduled tasks were missed while the app wasn't running."
            }
        }
    },
    "aiHistory": {
        "title": "AI History",
        "description": "View, search, and manage your local AI conversation history.",
        "live": "Live",
        "empty": {
            "title": "No AI History Yet",
            "description": "Your AI conversation history will appear here after you use intelligent tasks."
        },
        "search": {
            "placeholder": "Search conversations..."
        },
        "pagination": {
            "range": "Showing {{start}}–{{end}} of {{total}}"
        },
        "retention": {
            "note": "Keeping your {{count}} most recent conversations. Favorites are always kept.",
            "label": "Keep"
        },
        "filter": {
            "label": "Filter by type",
            "all": "All types"
        },
        "favorites": {
            "title": "Favorites",
            "add": "Add to favorites",
            "remove": "Remove from favorites"
        },
        "select": {
            "selectOne": "Select conversation",
            "selected": "{{count}} selected",
            "deleteSelected": "Delete selected",
            "clear": "Clear",
            "deleteTitle": "Delete selected conversations",
            "deleteDescription": "Delete {{count}} selected conversation(s)? This cannot be undone."
        },
        "copy": {
            "label": "Copy",
            "success": "Copied to clipboard.",
            "error": "Failed to copy to clipboard."
        },
        "source": {
            "create": "Create",
            "automate": "Automate"
        },
        "workflow": {
            "plan": "Plan",
            "steps": "Steps",
            "files": "Files",
            "folders": "Folders",
            "interruptedNotice": "Your workflow was interrupted. Please try again."
        },
        "trace": {
            "thinking": "Thinking",
            "thought": "Thought",
            "toolCalls": "Tool calls",
            "action": "Action",
            "parameters": "Parameters",
            "result": "Result",
            "reply": "You replied",
            "sources": "Sources",
            "roles": {
                "tool": "Tool result"
            }
        },
        "task": {
            "instructions": "Instructions",
            "language": "Language",
            "types": {
                "generate": "Generate",
                "rewrite": "Rewrite",
                "translate": "Translate",
                "summarize": "Summarize"
            }
        },
        "session": {
            "messages": "messages",
            "deleteTitle": "Delete Conversation",
            "deleteDescription": "Are you sure you want to delete this conversation? This cannot be undone.",
            "deleteConfirm": "Delete",
            "deleteCancel": "Cancel"
        },
        "clear": {
            "title": "Clear AI History",
            "description": "Delete all locally stored AI conversation history from this device.",
            "confirm": {
                "title": "Clear AI History",
                "description": "Are you sure you want to clear all AI conversation history? This cannot be undone.",
                "confirm": "Clear All",
                "cancel": "Cancel"
            },
            "success": "AI history cleared successfully.",
            "error": "Failed to clear AI history."
        },
        "export": {
            "title": "Export",
            "description": "Export your AI conversation history to a JSONL file.",
            "success": "AI history exported successfully.",
            "error": "Failed to export AI history.",
            "session": {
                "title": "Export run",
                "success": "Run exported successfully.",
                "error": "Failed to export this run."
            }
        },
        "keychain": {
            "continue": "Continue",
            "title": "Protect AI History",
            "message": "Cephable encrypts your AI history, including workflow history, on this Mac.",
            "detail": "macOS will next ask to allow access to “Cephable Safe Storage.” It contains only the encryption key, not your workflow or task content. Choose “Always Allow” to keep your encrypted history available without being asked again. Choosing “Allow” lets Cephable access it this time, but macOS may ask again on a future launch."
        },
        "rename": {
            "title": "Rename",
            "label": "Conversation title"
        }
    },
    "aiWorkflows": {
        "settings": {
            "title": "Automate Settings",
            "description": "Configure the AI models and devices used for AI Workflows. AI Workflows allow you to automate desktop and browser tasks using on-device AI.",
            "configType": {
                "title": "Model Configuration Type",
                "description": "Select the type of model configuration to use for AI Workflows. Different configurations are optimized for different models.",
                "label": "Configuration Type"
            },
            "reasoningModel": {
                "title": "Reasoning Model",
                "description": "Select the AI model to use for reasoning and planning tasks. The reasoning model analyzes your requests and creates action plans.",
                "label": "Reasoning Model"
            },
            "reasoningDevice": {
                "label": "Reasoning Device"
            },
            "generationModel": {
                "title": "Generation Model",
                "description": "Select the AI model to use for text generation tasks. The generation model creates text content when needed by workflows.",
                "label": "Generation Model"
            },
            "generationDevice": {
                "label": "Generation Device"
            },
            "noModelsFound": "No models found",
            "autoWarm": {
                "title": "Auto-Start AI Workflows",
                "description": "Automatically initialize AI Workflow models when the app starts. Models will be pre-loaded so workflows can start immediately.",
                "option": "Auto-start AI Workflow models on app launch"
            },
            "remoteWorkflows": {
                "title": "Run AI Workflows Across Your Devices",
                "option": "Let my other devices start and follow automations on this device",
                "description": "On by default. While on, you can start, monitor, and answer this device's automations from your other signed-in devices: the automation's progress (step titles and the AI's thinking) and any questions it asks you are sent in real time to those devices so you can respond from anywhere. This is shared only between your own devices and is never stored on Cephable's servers. Turn it off to keep Automations entirely on this device — automations still run here, but nothing is sent to your other devices and they cannot start an automation on this device."
            },
            "dynamicTools": {
                "option": "Smart Connector Tools Loading",
                "description": "Start faster by loading only the tools you're using. When off, all tools load at once — useful if you want the model to decide what actions to take but it can be much slower and cause degraded results."
            },
            "prompt": {
                "title": "Additional Information for AI Workflows",
                "description": "Enter additional details to be used with Cephable's AI when running workflows. Use this field to enter preferences for your tone, behavior, or any other details.",
                "field": "Additional prompt",
                "placeholder": "e.g. Always confirm before sending emails. Prefer concise responses. Use formal language in documents."
            },
            "thinkingLevel": {
                "field": "Reasoning effort",
                "description": "How much the AI thinks through each step before acting. Higher levels help it choose and order actions more reliably on complex tasks, but make each step a little slower. Medium is recommended for most people.",
                "low": "Low (fastest)",
                "medium": "Medium (recommended)",
                "high": "High",
                "max": "Max (most thorough)"
            },
            "longTasks": {
                "field": "Long tasks",
                "description": "How AI Workflows handle tasks that need to keep a lot in mind, like reading long documents. Automatic gives a task more room only when it needs it. Prioritize speed keeps every step quick, but very long tasks may forget their earliest steps. Always allow long tasks gives every task the most room, but steps that write text take a little longer. Only applies to computers with a separate graphics card.",
                "auto": "Automatic (recommended)",
                "speed": "Prioritize speed",
                "long": "Always allow long tasks"
            },
            "terminate": {
                "title": "Clear Workflow Resources",
                "description": "Click to terminate the workflow worker and free up resources. This will stop any running workflow and release memory used by the AI models.",
                "button": "Terminate Workflow Worker",
                "success": "Workflow worker terminated.",
                "confirm": {
                    "title": "Terminate Workflow Worker",
                    "description": "Are you sure you want to terminate the workflow worker? This will stop any running workflow and free up resources.",
                    "confirm": "Yes, terminate"
                }
            },
            "disableButtonNames": {
                "edit": "Block Button Interactions",
                "description": "Control which buttons AI Workflows are allowed to interact with. By default, Cephable can click any button on your screen. Use this setting to prevent accidental actions (for example, \"buy\", \"delete\").",
                "input": {
                    "label": "Button Name",
                    "question": "Which buttons would you like to block? You can enter full or partial button names.",
                    "remove": "Remove Button Name"
                },
                "button": "Block Buttons"
            }
        }
    },
    "intelligentTasks": {
        "loading": {
            "loadingModels": "Loading AI Models...",
            "extractingModels": "Extracting AI Models..."
        }
    },
    "camera": {
        "windowTitle": "Cephable Camera Controls",
        "title": "Camera",
        "extension": {
            "title": "Extension: Camera",
            "enabledTitle": "Enable Camera Controls",
            "enabledDescription": "With this setting turned on, Cephable will use your camera to detect your face and head movements to allow you to control your device with expressions and gestures including using your head movements as a mouse."
        },
        "titlePlural": "Cameras",
        "settings": "Camera Settings",
        "start": "Start Camera",
        "stop": "Stop Camera",
        "restart": "Restart Camera",
        "show": "Show Camera",
        "hide": "Hide Camera",
        "descriptionShort": "Enables face expression and head movement.",
        "description": "Use your camera to detect face expressions and body gestures as different controls.",
        "select": "Select a camera you want to pair with for enhanced controls using your face and body.",
        "empty": "No cameras found.",
        "search": "Search by camera name",
        "loading": "Loading Camera Controls...",
        "live": "LIVE",
        "paused": "Camera paused",
        "error": "Unexpected error loading camera controls. Please check your camera and try again.",
        "manage": {
            "title": "Click to view and manage details for your cameras.",
            "description": ""
        },
        "warn": "Camera controls have not been started, start your camera to allow face and body controls.",
        "detected": {
            "face": "Face Detected.",
            "noFace": "No Face Detected. Please adjust your camera or position and try again.",
            "command": "Detected: {{command}}"
        },
        "permission": {
            "title": "Camera Permissions Required",
            "description": "You need to give Cephable permission to use your camera to use face and body controls.",
            "button": "Open Permission Settings",
            "no": "No camera access",
            "help": "Cephable needs access to your camera to use expression and head controls. Navigate to <strong>System Settings</strong> > <strong>Privacy & Security</strong> > <strong>{{pane}}</strong> and enable Cephable to access your camera."
        },
        "controls": {
            "startData": "Started recording face data. Press the shortcut again while in camera window to stop recording and download.",
            "downloadData": "Stopped recording, downloading data",
            "paused": "Paused camera controls.",
            "pause": "Pause Camera Controls",
            "resume": "Resume Camera Controls",
            "resumed": "Resumed camera controls.",
            "linesOn": "Turn face lines on",
            "linesOff": "Turn face lines off",
            "lines": "Face Lines",
            "linesToggle": "Toggle draw face lines",
            "noDeviceTitle": "No camera detected that can be used with Cephable.",
            "noDeviceDescription": "You need to connect a camera that is compatible mobile apps.",
            "noDeviceConnectedDescription": "The camera control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands."
        },
        "draw": {
            "error": "Error loading camera feed. Please check your camera and try again."
        },
        "switch": {
            "title": "Switch Camera",
            "description": "Select a different camera to use for face and body controls.",
            "select": "Select Camera",
            "next": "Next Camera",
            "nextLong": "Switch to the next camera",
            "empty": "No other cameras found.",
            "search": "Search by camera name"
        },
        "baseline": {
            "title": "Baseline",
            "description": "The baseline is the default position of your face and body that Cephable uses to determine your movements. You can update and reset the baseline here.",
            "update": "Update Baseline",
            "reset": "Reset Baseline",
            "updated": "Baseline Updated",
            "tooltip": "Click to update your baseline to your current resting position."
        },
        "edit": {
            "title": "Edit Camera Settings",
            "description": "You can refine the settings for your inputs that require a camera to better suit your needs.",
            "autoStart": {
                "title": "Automatically Start Camera",
                "description": "With this setting turned on, your controller will start your camera enabling you to use face expressions and head movement controls right when the app starts. If this is off, you need to tap the \"Start Camera\" button in your connection page.",
                "option": "Autostart Camera and Head/Expression Controls?"
            },
            "head": {
                "title": "Head Movement Sensitivity",
                "description": "Sensitivity tells Cephable how far you need to move in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.",
                "tilt": {
                    "title": "Head Tilt Sensitivity",
                    "description": "These values determine how far you need to tilt your head up, down, left, and right to trigger controls",
                    "up": "Tilt Up Sensitivity",
                    "down": "Tilt Down Sensitivity",
                    "left": "Tilt Left Sensitivity",
                    "right": "Tilt Right Sensitivity",
                    "scaleHigh": "Slight Tilt",
                    "scaleLow": "Large Tilt"
                },
                "turn": {
                    "title": "Head Turn Sensitivity",
                    "description": "These values determine how far you need to turn your head left and right to trigger controls",
                    "left": "Turn Left Sensitivity",
                    "right": "Turn Right Sensitivity",
                    "scaleHigh": "Slight Turn",
                    "scaleLow": "Large Turn"
                },
                "lean": {
                    "title": "Head Lean Sensitivity",
                    "description": "These values determine how far you need to lean your head forward and back to trigger controls",
                    "forward": "Lean Forward Sensitivity",
                    "back": "Lean Back Sensitivity",
                    "right": "Lean Right Sensitivity",
                    "left": "Lean Left Sensitivity",
                    "scaleHigh": "Slight Lean",
                    "scaleLow": "Large Lean"
                },
                "duck": {
                    "title": "Head Duck/Rise Sensitivity",
                    "description": "These values determine how far you need to duck or rise your head to trigger controls",
                    "down": "Duck Down Sensitivity",
                    "up": "Rise Up Sensitivity",
                    "scaleHigh": "Slight Shift",
                    "scaleLow": "Large Shift"
                }
            },
            "face": {
                "title": "Face Expression Sensitivity",
                "description": "Sensitivity tells Cephable how exaggerated of an expression you need to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.",
                "eyebrow": {
                    "title": "Eyebrow Sensitivity",
                    "description": "These values determine how far you need to raise or lower your eyebrows to trigger controls",
                    "up": "Raise Eyebrow Sensitivity",
                    "scaleHigh": "Slight Raise",
                    "scaleLow": "Large Raise"
                },
                "mouth": {
                    "title": "Mouth Sensitivity",
                    "description": "These values determine how far you need to open or close your mouth to trigger controls",
                    "open": "Open Mouth Sensitivity",
                    "close": "Close Mouth Sensitivity",
                    "smile": "Smile Sensitivity",
                    "scaleHigh": "Slight Open",
                    "scaleLow": "Large Open",
                    "closeScaleHigh": "Slight Closed",
                    "closeScaleLow": "Tightly Closed",
                    "smileScaleHigh": "Slight Smile",
                    "smileScaleLow": "Large Smile"
                }
            },
            "mouse": {
                "title": "Head Movement for Mouse Controls",
                "disabled": "This feature is disabled for remote connections and extensions.",
                "description": "Determine if and how you want to use head movements controls to move your mouse instead of triggering other outputs.",
                "enable": {
                    "title": "Enable Head Movement for Mouse Controls",
                    "description": "If this is turned on, then some of your head movement controls will be used to move your mouse instead of trigger controls.",
                    "option": "Use Head Controls for Mouse Movement?"
                },
                "input": {
                    "title": "Mouse Input Type",
                    "description": "Select which type of head gestures you want to assign to mouse controls. For example, Head Tilting means you can tilt your head left and right to move your mouse left and right, Head Turning means you can turn your head left and right to move your mouse, and Head Leaning means you can lean left and right to move your mouse.",
                    "option": "Select Input Type",
                    "optionLong": "Select the type of head movement you want to use to control your mouse."
                },
                "invert": {
                    "title": "Invert Mouse Movement",
                    "description": "If this is turned on, then the direction you move your head will be inverted from the direction your mouse moves. For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.",
                    "x": "Invert X-axis Mouse Movement?",
                    "y": "Invert Y-axis Mouse Movement?"
                },
                "mode": {
                    "title": "Mouse Move Mode",
                    "description": "Select how you want the cursor to react to your head movements."
                },
                "speed": {
                    "title": "Mouse Speed",
                    "description": "Determine the constant speed you want the cursor move.",
                    "fast": "Fast",
                    "slow": "Slow"
                },
                "linear": {
                    "title": "Linear Mouse Movement",
                    "description": "If this is turned on, the cursor only moves in straight horizontal or vertical lines, making it easier to navigate in those specific directions without any diagonal drift.",
                    "option": "Use Linear Mouse Movement?"
                },
                "accelerationRate": {
                    "title": "Mouse Acceleration Response Delay",
                    "description": "The number of milliseconds it takes for the mouse speed to increase."
                },
                "accelerationCurve": {
                    "title": "Mouse Acceleration Curve",
                    "description": "Adjust the rate at which the cursor speed increases relative to head movement. ",
                    "linear": "Linear",
                    "exponential": "Exponential",
                    "sublinear": "Sub-linear"
                },
                "maximumSpeed": {
                    "title": "Maximum Mouse Speed",
                    "description": "Determine maximum number of pixels the cursor can move per second."
                },
                "off": {
                    "title": "Off",
                    "description": "Mouse movement is disabled."
                },
                "steadyGlide": {
                    "title": "Steady Glide",
                    "description": "When you move your head past a certain point, the cursor glides continuously in that direction at a steady speed."
                },
                "speedBoost": {
                    "title": "Speed Boost",
                    "description": "The cursor starts to move faster the longer you keep your head in one position. The longer you hold your head still, the quicker the cursor accelerates."
                },
                "dynamicGlide": {
                    "title": "Dynamic Glide",
                    "description": "The cursor's speed increases based on how far you move your head. The further you move your head, the faster the cursor glides."
                },
                "proportionalSpeed": {
                    "title": "Proportional Speed",
                    "description": "The cursor follows your nose tip proportional to your screen dimensions."
                }
            }
        }
    },
    "microphone": {
        "windowTitle": "Cephable Voice Controls",
        "title": "Microphone",
        "titlePlural": "Microphones",
        "settings": "Microphone Settings",
        "start": "Start Microphone",
        "startDescription": "Turn on the microphone to start listening to commands.",
        "stop": "Stop Microphone",
        "descriptionShort": "Enables voice commands and dictation.",
        "description": "Use your built in microphone to enable voice controls and dictation.",
        "select": "Select a microphone you want to pair with for enhanced controls using your voice.",
        "empty": "No microphones found.",
        "search": "Search by microphone name",
        "manage": {
            "title": "Click to view and manage details for your microphones.",
            "description": ""
        },
        "warn": "You microphone has not been started. Start the microphone to allow voice commands and dictation.",
        "permission": {
            "title": "Microphone Permissions Required",
            "description": "You need to give Cephable permission to use your microphone to use voice controls.",
            "button": "Open Permission Settings",
            "no": "No microphone access",
            "help": "Cephable needs access to your microphone to use voice controls. Navigate to <strong>System Settings</strong> > <strong>Privacy & Security</strong> > <strong>{{pane}}</strong> and enable Cephable to access your microphone."
        },
        "controls": {
            "loadingDetail": "This may take a few minutes.",
            "generatingTextDetail": "Stop generation by changing apps or saying 'stop generating'",
            "pause": "Pause Voice Controls",
            "paused": "Paused controls.",
            "resume": "Resume Voice Controls",
            "dictationPlay": "Start Dictation Mode",
            "dictationPause": "Stop Dictation Mode",
            "prompt": "Start speaking to see your voice controls here...",
            "dictationPrompt": "Start speaking to type what you say...",
            "command": "Command",
            "contextual": "Contextual",
            "send": "Send",
            "typedInputLabel": "Type a command or text to send",
            "listeningPlaceholder": "Listening...",
            "dictationListeningPlaceholder": "Listening...",
            "pausedPlaceholder": "Voice paused...",
            "latency": "High latency detected. Consider closing some applications that might be consuming too many resources.",
            "noDeviceConnectedDescription": "The microphone control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands.",
            "status": {
                "loadingModel": "Loading Voice Model...",
                "loadingPhiModel": "Loading Text Generation Model...",
                "preparingPhiModel": "Preparing Text Generation Model...",
                "generatingText": "Generating...",
                "thinking": "Thinking...",
                "paused": "Paused.",
                "dictating": "Dictating.",
                "optimistic": "Optimistic:",
                "listening": "Listening:",
                "permission": "Checking microphone permissions...",
                "typing": "Typing..."
            }
        },
        "edit": {
            "title": "Edit Microphone Settings",
            "description": "Manage your voice commands and dictation settings for this connection.",
            "input": {
                "title": "Microphone",
                "description": "The microphone voice control and dictation listen to. Cephable remembers your choice and switches back to it whenever it is connected.",
                "notConnected": "{{name}} (not connected)",
                "systemDefault": "System default"
            },
            "autoStart": {
                "title": "Auto Start Microphone",
                "description": "Automatically begins listening for voice controls when the device powers on. If disabled, tap `Start Listening` to begin.",
                "option": "Auto Start Microphone"
            },
            "optimistic": {
                "title": "Optimistic Faster Voice Controls",
                "description": "Makes voice controls faster and more responsive, but less forgiving. Use Standard mode if you want dictation support or more flexibility. Note: Optimistic mode may trigger accidentally if you don't say commands exactly.",
                "option": "Optimistic Faster Voice Controls"
            },
            "aiCommands": {
                "title": "Intelligent Voice Commands",
                "description": "Say commands naturally — Cephable AI figures out what you mean without needing an exact match.",
                "option": "Intelligent Voice Commands"
            },
            "aiDictation": {
                "title": "Intelligent Dictation and Quick Type",
                "description": "Enhanced voice-to-text with automatic punctuation, proper nouns, and sentence structure. Say `type [anything]` to use Quick Type for smarter, more natural dictation.",
                "option": "Intelligent Dictation and Quick Type"
            },
            "confirm": {
                "title": "You have unsaved changes.",
                "description": "Detected unsaved changes. Would you like to save before exiting?"
            }
        },
        "devices": {
            "error": "Microphone Input Device Not Found."
        },
        "context": {
            "add": "Add context",
            "title": "Add context",
            "highlighted": "Highlighted text",
            "clipboard": "Clipboard",
            "other": "Other…",
            "files": "Files…",
            "folders": "Folders…",
            "otherTitle": "Add custom context",
            "otherLabel": "Custom context",
            "otherPlaceholder": "Type or paste the context to use",
            "otherConfirm": "Add",
            "otherCancel": "Cancel",
            "remove": "Remove context",
            "removeAttachment": "Remove attachment",
            "dropToAttach": "Drop files or folders to attach them as context",
            "required": "Context is required for {{mode}}"
        }
    },
    "localization": {
        "title": "Language Settings",
        "titleShort": "Language",
        "select": "Select Language",
        "description": "Choose your preferred language from a list of supported languages.",
        "newUserDescription": "Please select a preferred language before continuing.",
        "edit": "Update Language",
        "profile": {
            "view": "Variants",
            "title": "App Control Language",
            "question": "What app control language would you like to edit?",
            "description": "Some app controls have variants for different languages. Swap to another language to edit and personalize.",
            "change": "Change Language"
        },
        "display": {
            "title": "Display Language",
            "description": "Language that is displayed when using Cephable. This includes things like menus, notifications, and app controls being displayed in the language of your choice.."
        },
        "voice": {
            "title": "Voice Control Language",
            "description": "This is the language that is used when recognizing dictation and voice commands. Specifying the language enhances the accuracy of your voice inputs.",
            "settings": {
                "title": "Voice Recognition and Display Language",
                "description": "Adjust your language settings for both display and voice controls. This option allows you to select your preferred languages for on-screen text and microphone interactions like voice controls and dictation."
            }
        },
        "unsupported": {
            "title": "Unsupported Language {{locale}}",
            "description": "The selected language is not supported. Please choose a different language."
        },
        "locales": {
            "en": "English",
            "en-us": "English (US)",
            "en-gb": "English (UK)",
            "en-in": "English (India)",
            "es": "Español — Spanish",
            "fr": "Français — French",
            "it": "Italiano — Italian",
            "de": "Deutsch — German",
            "ja": "日本語 — Japanese"
        },
        "localesShort": {
            "en": "English",
            "en-us": "English (US)",
            "en-gb": "English (UK)",
            "en-in": "English (India)",
            "es": "Spanish",
            "fr": "French",
            "it": "Italian",
            "de": "German",
            "ja": "Japanese"
        },
        "save": {
            "success": "User locale preferences saved!",
            "error": "Error saving user locale preferences"
        }
    },
    "editor": {
        "title": "Markdown Editor",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "strikethrough": "Strikethrough",
        "hr": "Horizontal Rule",
        "link": "Link",
        "quote": "Quote",
        "code": "Code",
        "codeBlock": "Code Block",
        "comment": "Comment",
        "image": "Image",
        "table": "Table",
        "unordered-list": "Unordered List",
        "ordered-list": "Ordered List",
        "checked-list": "Checked List",
        "help": "Help",
        "edit": "Edit",
        "live": "Live",
        "preview": "Preview",
        "fullscreen": "Fullscreen",
        "placeholder": "Please enter Markdown text here..."
    },
    "panel": {
        "title": "Cephable Panel",
        "titleShort": "Panel",
        "description": "This is the panel which is the main control center. It is always visible and allows you to control your apps using your voice, and more.",
        "question": "Autostart Panel?",
        "reconnecting": "Reconnecting…",
        "reconnectRetry": "Retry",
        "position": {
            "top": "Top",
            "right": "Right",
            "left": "Left",
            "bottom": "Bottom ",
            "description": "Select where you want the Cephable Panel to appear on your screen.",
            "label": "Position"
        },
        "sections": {
            "description": "Choose what sections in the panel are visible. You can hide sections based on your preferences to make the most of the panel space.",
            "microphone": "Microphone and Voice Controls",
            "camera": "Camera and Face/Head Controls",
            "buttons": "Quick Action Buttons",
            "tasks": "Intelligent Tasks",
            "profile": "App Controls and Previews",
            "globalControls": "Global and Device Controls"
        },
        "modes": {
            "title": "Mode",
            "generate": {
                "label": "Generate",
                "placeholder": "Describe what you want to generate"
            },
            "rewrite": {
                "label": "Rewrite",
                "placeholder": "How should I rewrite the text?"
            },
            "translate": {
                "label": "Translate",
                "placeholder": "Translate to which language?"
            },
            "automate": {
                "label": "Automate",
                "placeholder": "Describe the steps you want to automate"
            },
            "auto": {
                "label": "Auto",
                "placeholder": "Type anything — Cephable picks the best mode",
                "upgrade": "Cephable needs {{tier}} to run that action."
            },
            "control": {
                "label": "Control",
                "placeholder": "Type a command or text to send"
            },
            "summarize": {
                "label": "Summarize",
                "placeholder": "How would you like to summarize or condense the text?"
            }
        }
    },
    "smartTasks": {
        "title": "Intelligent Tasks",
        "show": "Show Intelligent Tasks",
        "description": "Intelligent tasks are the different tasks that Cephable's AI can perform for you. These tasks are powered by on-device AI and can be used to create text, summarize, rewrite, translate and more.",
        "clearCache": "Sorry, your request failed due to an unexpected issue. Please try again.",
        "networkError": "Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.",
        "genericError": "An unexpected error occurred. Please try again.",
        "generatedByAI": "Powered by on-device AI, please review for accuracy.",
        "runningInBackground": {
            "generate": "Generating in background...",
            "rewrite": "Rewriting in background...",
            "translate": "Translating in background...",
            "summarize": "Summarizing in background...",
            "generic": "Running in background..."
        },
        "processing": "Processing...",
        "highlightText": {
            "title": "Use highlighted text",
            "description": "Cephable can automatically use the text you have highlighted in any app to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.",
            "label": "Enter text to use",
            "placeholder": "You can also highlight text in another app and come back here to use it.",
            "noTextFound": "No text found. Highlight text in another app or paste text into the field and try again."
        },
        "pasteText": {
            "title": "Paste text",
            "description": "Cephable can automatically use the text you have copied to your clipboard to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.",
            "label": "Enter text to use",
            "placeholder": "You can also highlight text in another app and come back here to use it."
        },
        "generateText": {
            "title": "Generate Text",
            "description": "Create text content based on your input or prompts.",
            "label": "Describe what you want to generate"
        },
        "summarizeText": {
            "title": "Summarize Text",
            "write": "Write Summary",
            "description": "Gather insights from long text and create short summaries or key takeaways.",
            "directions": "Enter the text to summarize, or Cephable will automatically use whatever text you have highlighted.",
            "inputLabel": "Enter text to condense",
            "outputLabel": "Your summary will appear here."
        },
        "rewriteText": {
            "title": "Rewrite Text",
            "description": "Highlight text in another app where you are writing and then come back here and describe how you want it to be re-written.",
            "label": "Describe how you want to rewrite the text",
            "inputLabel": "Enter text to rewrite"
        },
        "translateText": {
            "title": "Translate Text",
            "description": "Enter the text to translate, or Cephable will automatically use whatever text you have highlighted.",
            "label": "Enter text to translate",
            "languageLabel": "Language to translate to"
        },
        "transcribeAudio": {
            "title": "Transcribe Audio",
            "description": "Convert audio or video files to text using AI transcription.",
            "inputMethod": "Choose input method",
            "localFile": "Local File",
            "url": "URL",
            "selectFile": "Select Audio/Video File",
            "urlLabel": "Audio/Video URL",
            "transcribe": "Transcribe",
            "result": "Transcription Result",
            "invalidFileType": "Please select a valid audio or video file (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Transcription error",
            "history": {
                "title": "Transcription History",
                "description": "View and manage your saved transcriptions.",
                "viewHistory": "View History",
                "empty": "No transcriptions yet. Start transcribing to build your history!",
                "titleLabel": "Title (optional)",
                "titlePlaceholder": "Enter a title for this transcription",
                "textLabel": "Transcription Text",
                "confirmDelete": "Are you sure you want to delete this transcription?"
            }
        },
        "noteTaker": {
            "title": "Note Taker",
            "description": "Let Cephable locally record and transcribe your meetings or conversations"
        },
        "documentChat": {
            "title": "Document Chat",
            "description": "Interact with and query documents for quick insights."
        },
        "download": {
            "title": "Download AI Models to Unlock More Capabilities",
            "description": "To use Intelligent tasks, a local model needs to be downloaded to your device. This ensures your data stays private and is never sent to the cloud.",
            "confirm": "Download",
            "cancel": "Not now"
        },
        "aiWorkflows": {
            "title": "AI Workflows",
            "description": "Automate your desktop and browser tasks with AI. Simply describe what you want to accomplish, and watch Cephable execute the actions for you.",
            "prefix": "Workflow: ",
            "label": "What can I help you do?",
            "start": "Start",
            "progress": "Working...",
            "continue": {
                "label": "Continue",
                "placeholder": "Ask Cephable to do more with this result…"
            },
            "resume": {
                "title": "Continue a past chat",
                "description": "Search your automation history and pick up where you left off.",
                "searchPlaceholder": "Search past chats…",
                "noMatches": "No past chats match \"{{query}}\"",
                "empty": "No past automations yet.",
                "continuing": "Continuing chat",
                "indicator": "Continuing \"{{title}}\" conversation",
                "stopContinuing": "Start a new chat instead",
                "clear": "Clear selected chat"
            },
            "context": {
                "approaching": "This conversation is getting long ({{percent}}% of the AI's memory used). Older messages may soon be dropped.",
                "trimmed": "This conversation has reached the AI's memory limit, so it may start forgetting earlier messages. Start a new workflow to reset.",
                "indicator": "{{percent}}% of working memory used",
                "indicatorPending": "Working memory used for this workflow",
                "indicatorTokens": "{{used}}/{{budget}} used"
            },
            "retry": {
                "label": "Retry"
            },
            "steps": {
                "error": "Error",
                "thinking": "Thinking",
                "tool": "Tool",
                "details": "Details",
                "output": "Output",
                "showMore": "Show more",
                "showLess": "Show less",
                "chunkProgress": "part {{current}} of {{total}}",
                "contentUsed": "Content used",
                "contentSource": "Source content",
                "contentTruncated": "Showing the first {{shown}} of {{total}} characters"
            },
            "files": {
                "sectionTitle": "Files",
                "open": "Open",
                "openFile": "Open file",
                "openFolder": "Open folder",
                "openError": "Couldn't open \"{{name}}\". It may have been moved or deleted."
            },
            "browser": {
                "sectionTitle": "Browser",
                "view": "View browser",
                "open": "Open",
                "openError": "Couldn't open the browser."
            },
            "ready": {
                "waiting": "AI Workflows is ready. Waiting for your instructions.",
                "execute": "AI Workflows is ready. Starting on your request..."
            },
            "input": {
                "other": "Other…",
                "otherPlaceholder": "Type your answer",
                "submit": "Send"
            },
            "approval": {
                "title": "Confirm action",
                "approve": "Approve",
                "reject": "Reject",
                "edit": "Edit",
                "confirmDelete": "Delete",
                "confirmRun": "Run command",
                "confirmMove": "Move",
                "badgeDestructive": "Destructive",
                "badgeCaution": "Caution",
                "deletePath": "Delete this file/folder? This is permanent.",
                "runCommand": "Run this shell command?",
                "movePath": "Move/rename this path? It may overwrite the destination."
            },
            "status": {
                "idle": "Waiting for your instructions...",
                "initializing": "Getting things ready...",
                "loadNotice": {
                    "firstRunSetup": "Setting up on-device AI for the first time. This can take a few minutes, but it will be faster next time.",
                    "largeModel": "Loading {{model}} ({{size}} GB). Larger models can take a few minutes to load. For faster results, switch to a smaller model in Settings.",
                    "driverIssue": "Your graphics driver may be out of date, so on-device AI is using a slower mode. Updating your graphics driver can make it faster and more reliable.",
                    "longTask": "This task is getting long, so I’m giving it more room to work. This can take up to a minute."
                },
                "planning": [
                    "Making a plan...",
                    "Breaking down your request...",
                    "Mapping out the steps...",
                    "Organizing the workflow...",
                    "Preparing the strategy...",
                    "Creating a plan of action...",
                    "Figuring out the best way to help you...",
                    "Determining how to approach this...",
                    "Analyzing your request...",
                    "Planning the execution..."
                ],
                "thinking": ["Thinking..."],
                "thinkingInteractive": [
                    "Considering the next step...",
                    "Reviewing what we've done so far...",
                    "Deciding what to do next...",
                    "Analyzing the results...",
                    "Planning the continuation...",
                    "Evaluating the options...",
                    "Figuring out the best next step...",
                    "Working on the next part of your request...",
                    "Working on the next steps...",
                    "Processing the previous step's results..."
                ],
                "waitingForUser": "Your input is needed to continue.",
                "completed": "Success!",
                "failed": "Your request failed.",
                "networkError": "Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.",
                "unsupportedOSVersion": "You have an outdated MacOS System, please update and try again.",
                "canceled": "Your request was canceled.",
                "terminated": "Completed your request.",
                "stopped": "Stopped.",
                "executing-org-block": "Cannot {{params.toolName}} because interacting with {{params.appOrDomain}} is blocked by the organization.",
                "executing-destructive-block": "Interacting with {{params.elementName}} is blocked. Please review and perform this action manually.",
                "executing-type-focus-block": "I had an issue writing the content. It is copied to your clipboard, please paste it manually.",
                "executing-permission-block": "I had an issue accessing the file.",
                "tools": {
                    "analyze_table": {
                        "executing-start": "Analyzing the table...",
                        "executing-complete": "I analyzed the table."
                    },
                    "click_element_by_index": {
                        "executing-start": "Clicking the relevant button...",
                        "executing-complete": "I clicked {{params.index}}."
                    },
                    "click_element": {
                        "executing-start": "Clicking the highlighted number...",
                        "executing-complete": "I clicked {{params.elementName}}."
                    },
                    "copy_selection": {
                        "executing-start": "Gathering context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "append_to_file": {
                        "executing-start": "Adding to the file...",
                        "executing-complete": "I added content to the file."
                    },
                    "copy_path": {
                        "executing-start": "Copying...",
                        "executing-complete": "I copied it."
                    },
                    "create_directory": {
                        "executing-start": "Creating the folder...",
                        "executing-complete": "I created the folder."
                    },
                    "delete_path": {
                        "executing-start": "Deleting...",
                        "executing-complete": "I deleted it."
                    },
                    "draft_email": {
                        "executing-start": "Drafting an email...",
                        "executing-complete": "I drafted an email about {{params.subject}}."
                    },
                    "execute_app_action": {
                        "executing-start": "Running {{params.actionName}}...",
                        "executing-complete": "{{params.actionName}} completed."
                    },
                    "edit_user_file": {
                        "executing-start": "Editing the file...",
                        "executing-complete": "I edited the file."
                    },
                    "find_all_text": {
                        "executing-start": "Searching for all relevant context about {{params.searchText}}...",
                        "executing-complete": "I found all relevant context about {{params.searchText}}."
                    },
                    "find_and_select_text": {
                        "executing-start": "Searching and selecting relevant context about {{params.searchText}}...",
                        "executing-complete": "I found and selected relevant context about {{params.searchText}}."
                    },
                    "generate_text": {
                        "executing-start": "Creating content...",
                        "executing-progress": "Creating content...{{progress}}%",
                        "executing-complete": "I created the requested content."
                    },
                    "get_all_interactive_elements": {
                        "executing-start": "Scanning to get more context...",
                        "executing-complete": "I understand what I can interact with."
                    },
                    "get_all_text_elements_content": {
                        "executing-start": "Reading to get more context...",
                        "executing-complete": "I understand what text content is available."
                    },
                    "get_all_text_elements_names": {
                        "executing-start": "Reading to get more context...",
                        "executing-complete": "I understand what text content is available."
                    },
                    "get_available_profile_actions": {
                        "executing-start": "Checking what controls are available in this app...",
                        "executing-complete": "I understand what I can do in this app."
                    },
                    "get_document_content": {
                        "executing-start": "Reading to get more context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "get_file_info": {
                        "executing-start": "Checking the file...",
                        "executing-complete": "I checked the file."
                    },
                    "get_installed_apps": {
                        "executing-start": "Deciding which app is relevant to your request...",
                        "executing-complete": "I know which apps I can use."
                    },
                    "get_running_app_names": {
                        "executing-start": "Deciding which app is relevant to your request...",
                        "executing-complete": "I know which apps I can use."
                    },
                    "get_selected_text": {
                        "executing-start": "Reading the selected content...",
                        "executing-complete": "I have context on the selected content."
                    },
                    "get_stored_content": {
                        "executing-start": "Gathering context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "keyboard_shortcut": {
                        "executing-start": "Gathering context...",
                        "executing-complete": "I have context, ready for the next part of your request."
                    },
                    "list_directory": {
                        "executing-start": "Listing the folder...",
                        "executing-complete": "I listed the folder."
                    },
                    "move_path": {
                        "executing-start": "Moving...",
                        "executing-complete": "I moved it."
                    },
                    "open_app": {
                        "executing-start": "Opening {{params.appName}}...",
                        "executing-complete": "I opened {{params.appName}}."
                    },
                    "open_path": {
                        "executing-start": "Opening...",
                        "executing-complete": "I opened it."
                    },
                    "open_webpage": {
                        "executing-start": "Opening {{params.url}}...",
                        "executing-complete": "I opened {{params.url}}."
                    },
                    "paste_content": {
                        "executing-start": "Writing...",
                        "executing-complete": "I finished writing."
                    },
                    "read_user_file": {
                        "executing-start": "Reading the file...",
                        "executing-complete": "I read the file."
                    },
                    "respond_to_user": {
                        "executing-start": "Completing your request...",
                        "executing-complete:": "I completed your request."
                    },
                    "run_command": {
                        "executing-start": "Running a command...",
                        "executing-complete": "I ran the command."
                    },
                    "search_browser": {
                        "executing-start": "Searching the web for {{params.query}}...",
                        "executing-complete": "I searched the web for {{params.query}}."
                    },
                    "search_files": {
                        "executing-start": "Searching for files...",
                        "executing-complete": "I found matching files."
                    },
                    "search_in_files": {
                        "executing-start": "Searching inside files...",
                        "executing-complete": "I searched inside the files."
                    },
                    "select_all_text": {
                        "executing-start": "Selecting all the text...",
                        "executing-complete": "I selected all the text."
                    },
                    "summarize_text": {
                        "executing-start": "Summarizing the text...",
                        "executing-progress": "Summarizing...{{progress}}%",
                        "executing-complete": "I summarized the text."
                    },
                    "translate_text": {
                        "executing-start": "Translating the text to {{params.targetLanguage}}...",
                        "executing-progress": "Translating...{{progress}}%",
                        "executing-complete": "I translated the text to {{params.targetLanguage}}."
                    },
                    "rewrite_text": {
                        "executing-progress": "Rewriting...{{progress}}%"
                    },
                    "type_stored_content": {
                        "executing-start": "Writing...",
                        "executing-complete": "I finished writing."
                    },
                    "type_text": {
                        "executing-start": "Writing...",
                        "executing-complete": "I finished writing."
                    },
                    "write_user_file": {
                        "executing-start": "Writing the file...",
                        "executing-complete": "I wrote the file."
                    },
                    "unknown": {
                        "executing-start": "Ran into a problem, trying a different strategy...",
                        "executing-complete": "I tried a different strategy."
                    }
                }
            }
        }
    },
    "tray": {
        "panel": "Toggle Panel",
        "dashboard": "Show Workspace",
        "quit": "Quit Cephable"
    },
    "metrics": {
        "download": {
            "success": "Metrics file successfully accessed.",
            "manualPath": "Metrics file available at: {{path}}",
            "error": "Error downloading metrics file.",
            "noFile": "No metrics file found."
        },
        "clear": {
            "success": "Metrics file cleared successfully.",
            "error": "Error clearing metrics file.",
            "noFile": "No metrics file found to clear.",
            "confirm": "Are you sure you want to clear all metrics data? This cannot be undone."
        }
    },
    "gamepad": {
        "title": "Gamepad Support",
        "description": "Configure gamepad and joystick output for PC gaming",
        "driver": {
            "title": "Game Controller Driver",
            "description": "To support game controller outputs, Cephable needs to download and install an external driver called ViGEm. This driver enables virtual Xbox 360 controller functionality that games recognize natively.",
            "installed": "Game controller driver installed - You're ready to use gamepad outputs! If you're still facing issues, you can try reinstalling the driver.",
            "notInstalled": "Game controller driver not installed",
            "install": "Install Game Controller Driver",
            "reinstall": "Reinstall Game Controller Driver",
            "installing": "Installing ViGEm game controller driver...",
            "installSuccess": "ViGEm game controller driver installed successfully! You can now use gamepad outputs in your controls.",
            "installFailed": "Failed to install ViGEm driver. Please try again or install manually from the ViGEm website.",
            "disclosure": {
                "title": "Install third-party gamepad driver?",
                "description": "Gamepad support requires installing ViGEm, a third-party unofficial driver that lets Cephable emulate a virtual Xbox controller. Continue only if you want Cephable to install this driver.",
                "confirm": "Install ViGEm driver"
            }
        },
        "platform": {
            "unsupported": "Platform not supported for gamepad features",
            "unsupportedDescription": "Gamepad output functionality is currently only supported on Windows x64 systems. Mac and Windows ARM64 support is not yet available."
        },
        "usage": "Once the Game Controller driver is installed, you can use joystick movements and gamepad button presses in your macros and voice commands to control games."
    },
    "youtube": {
        "unavailable": {
            "title": "Video Unavailable",
            "description": "This video is currently unavailable. Please check again later.",
            "retry": "Retry"
        },
        "watch": {
            "title": "Oops.",
            "description": "Looks like there was an issue loading the video. You can watch it directly on YouTube.",
            "button": "Watch on YouTube"
        },
        "offline": {
            "title": "Video Unavailable",
            "description": "This YouTube video requires an internet connection to load. Please check your connection and try again."
        }
    },
    "accessibilityService": {
        "error": {
            "generic": "Internal Error. Please try again later.",
            "elementNotFound": "No result found. Please ensure the search exists and try again.",
            "highlightOnConflict": "Multiple elements found. Please refine your command to specify which one you want to select.",
            "clickNotInitialized": "Tapping by Name is not available at the moment. Please contact support if the issue persists.",
            "platformUnsupported": "Tapping by Name is not supported on this platform.",
            "permission": "Cephable does not have permission to read this app. Grant it under System Settings > Privacy & Security > {{pane}} — on a work-managed device this may be blocked by your administrator."
        },
        "clickWait": "Still initializing. Please wait a moment and try again."
    },
    "tos": {
        "title": "Terms of Service Update",
        "description": "Our Terms of Service have been updated. Please review and accept the updated terms to continue using Cephable.",
        "effectiveDate": "Effective date: {{date}}",
        "accept": "Accept Terms of Service",
        "loadError": "Unable to load Terms of Service. Please try again.",
        "viewInBrowser": "View Terms of Service In Browser",
        "acceptCheckbox": "I have read and accept the Terms of Service"
    },
    "sensitivityValues": {
        "verySensitive": "Very Sensitive",
        "high": "High",
        "medium": "Medium",
        "low": "Low",
        "notSensitive": "Not Sensitive"
    },
    "appearance": {
        "title": "Appearance"
    },
    "troubleshooting": {
        "title": "Troubleshooting"
    },
    "extensions": {
        "title": "Extensions",
        "titleShort": "Extensions",
        "description": "Enable features, connect companion apps, and extend what Cephable can do.",
        "searchPlaceholder": "Search extensions",
        "noResults": "No extensions match your search.",
        "comingSoon": "Coming soon",
        "stats": {
            "rating": "Rating",
            "installs": "Installs",
            "yourRating": "Your rating",
            "rated": "Thanks for rating!",
            "rateError": "Could not save your rating."
        },
        "nav": {
            "label": "Browse extensions",
            "discover": "Discover",
            "skills": "Skills",
            "connectors": "Connectors",
            "features": "Cephable features",
            "installed": "Installed"
        },
        "type": {
            "skill": "Skill",
            "tool": "Connector",
            "input": "Input",
            "build": "Build",
            "app": "Companion App",
            "feature": "Feature"
        },
        "done": "Done",
        "getStarted": "Get started",
        "viewDetails": "View details & settings",
        "enable": "Enable",
        "publisher": {
            "official": "Cephable",
            "officialTitle": "Official — built and maintained by Cephable",
            "byline": "By {{publisher}}",
            "thirdPartyTitle": "Third-party integration by {{publisher}}"
        },
        "category": {
            "inputControls": {
                "title": "Input & Control",
                "description": "Turn on the ways you control your device with Cephable."
            },
            "companionApps": {
                "title": "Companion Apps & Tools",
                "description": "Extend Cephable with our mobile app and web-based creators."
            },
            "buildExtend": {
                "title": "Build & Extend",
                "description": "Create your own extensions with the Cephable API and SDKs."
            },
            "previews": {
                "title": "Previews",
                "description": "Try features that are on the way. Previews may change before they are released."
            },
            "marketplace": {
                "title": "Marketplace",
                "description": "New skills, tools, and connections are on the way."
            }
        },
        "camera": {
            "title": "Camera Controls",
            "description": "Control your device with face and head movements using your camera.",
            "detail": "Camera controls let you use facial expressions and head movements — including head-as-mouse — to control your device. Enable them with the switch on the card, then fine-tune the behavior here.",
            "settings": {
                "title": "Expressions & gestures",
                "description": "Adjust which facial expressions and head movements map to actions in Settings."
            },
            "advancedSettings": "Open camera settings"
        },
        "gamepad": {
            "title": "Gamepad Support",
            "description": "Emulate an Xbox controller so games recognize your Cephable inputs.",
            "detail": "Gamepad support requires installing ViGEm, a third-party unofficial driver, to emulate a virtual Xbox controller that games recognize natively. Install or update the driver below. Available on Windows x64."
        },
        "mobile": {
            "title": "Cephable Mobile App",
            "description": "Use your phone as a companion controller with the Cephable mobile app.",
            "detail": "Get the Cephable mobile app to use your phone as a companion controller. Scan a code or use the links to download it on iOS or Android, then preview the app below.",
            "screenshotsTitle": "Preview",
            "screenshotPlaceholder": "Screenshot",
            "screenshotAlt": "Cephable mobile app screenshot {{number}}",
            "scanTitle": "Scan to download",
            "ios": "iOS — App Store",
            "android": "Android — Google Play",
            "iosAction": "Get it on the App Store",
            "androidAction": "Get it on Google Play"
        },
        "controllerCreator": {
            "title": "Custom Controller Creator",
            "description": "Design your own on-screen controllers at controller.cephable.com.",
            "detail": "The Custom Controller Creator lets you design and share your own on-screen controllers in the browser.",
            "qrCaption": "controller.cephable.com",
            "action": "Open Controller Creator",
            "screenshotsTitle": "Preview",
            "screenshotPlaceholder": "Controller creator screenshot",
            "screenshotAlt": "Custom Controller Creator screenshot {{number}}"
        },
        "developer": {
            "title": "Build Your Own Extension",
            "description": "Use the Cephable API and SDKs to build and share your own extensions.",
            "detail": "Build your own extensions and integrations with Cephable. Explore the API and SDKs, then publish and share what you create at developers.cephable.com.",
            "api": {
                "title": "Cephable API",
                "description": "Programmatically manage profiles, devices, controls, and real-time events."
            },
            "sdk": {
                "title": "SDKs & samples",
                "description": "Get started fast with our SDKs, samples, and integration guides."
            },
            "action": "Go to developers.cephable.com"
        },
        "automateHttpServer": {
            "title": "Automate HTTP Server",
            "description": "Connect local services to Cephable's on-device Automate assistant over HTTP.",
            "detail": "The Automate HTTP server lets local services, development tools, and evaluation runners use Cephable's shipping assistant. It accepts connections only from this device, requires the generated key on every request, and confines file operations to an isolated Automate workspace.",
            "proRequired": "The Automate HTTP server is available with Cephable Professional.",
            "running": "Running",
            "stopped": "Stopped",
            "port": "Port",
            "endpoint": "Endpoint",
            "portMoved": "Port {{preferredPort}} was already in use on this device, so the server started on port {{port}} instead. Use the endpoint above in your tools, not the default.",
            "portMovedTitle": "Different port in use",
            "api": {
                "title": "How to connect",
                "description": "Use the server from a local script, desktop app, or automation tool running on this computer.",
                "routes": {
                    "chat": "Chat",
                    "run": "Automate run",
                    "health": "Health",
                    "models": "Models",
                    "modelMode": "Model mode (your own agent loop)",
                    "tools": "Built-in tools",
                    "speech": "Speech results",
                    "settings": "Settings"
                },
                "steps": {
                    "enable": "Enable this extension from its card, leave Cephable open, and confirm that the status above says Running.",
                    "copyKey": "Copy the access key below. Send it on every request in the Authorization header as Bearer <access key>.",
                    "sendRequest": "Use the endpoint shown above and POST a JSON request to /v1/chat/completions. Existing OpenAI-compatible clients can use cephable-agent as the model name to run the full assistant, or cephable-model to use Cephable as the model inside their own agent.",
                    "readResponse": "Read the assistant reply from choices[0].message.content. If a client cannot connect, send GET /health with the same authorization header."
                }
            },
            "key": "Access key",
            "keyDescription": "Use this key as the bearer token for local clients. It is encrypted with your operating system's secure storage and never synced to Cephable.",
            "copyKey": "Copy access key",
            "copyError": "Could not copy the Automate server access key.",
            "regenerateKey": "Regenerate access key",
            "keyRegenerated": "Automate server access key regenerated.",
            "example": {
                "title": "Node.js request example",
                "description": "This example already includes the endpoint and current access key. Copy it into a trusted local Node.js script and replace the sample prompt with your task.",
                "copy": "Copy request example",
                "copyError": "Could not copy the request example."
            },
            "useCases": {
                "title": "Ideas for using the server",
                "description": "Anything that can make a local HTTP request can ask Cephable's on-device Automate assistant to help.",
                "localAutomation": "Connect local scripts, shortcut tools, desktop utilities, or automation platforms to an Automate workflow.",
                "privateText": "Rewrite, summarize, classify, or translate text inside an internal tool while keeping inference on this device.",
                "accessibleInputs": "Let custom switches, sensors, or companion software turn an accessible input into a richer Automate task.",
                "testing": "Run prompt and workflow regression suites against the same assistant, skills, tools, and local model used by the Cephable app."
            },
            "security": {
                "title": "Keep access local and secure",
                "description": "The server listens only on 127.0.0.1, so remote and cloud services cannot connect directly. Treat the access key like a password and share it only with software you trust. Regenerating it immediately disconnects clients using the previous key."
            },
            "secureStorageUnavailable": "This server cannot be enabled because secure operating-system storage is unavailable.",
            "error": "Could not update the Automate HTTP server."
        },
        "portal": {
            "title": "Projects & Teams",
            "description": "Manage your projects and teams in the Cephable Portal.",
            "detail": "Use the Cephable Portal to manage your projects, teams, and organization settings in one place.",
            "projects": {
                "title": "Projects",
                "description": "Create and manage projects, API keys, and integrations."
            },
            "teams": {
                "title": "Teams",
                "description": "Invite members, assign roles, and manage access across your organization."
            },
            "action": "Open the Cephable Portal"
        },
        "mcpTools": {
            "title": "MCP Tools",
            "description": "Connect Model Context Protocol tools to extend Cephable's capabilities."
        },
        "aiSkills": {
            "title": "AI Skills",
            "description": "Add reusable AI skills that Cephable can trigger on demand."
        },
        "workflows": {
            "title": "Reusable Workflows",
            "description": "Share and install prebuilt automation workflows."
        },
        "controlBundles": {
            "title": "Control Bundles",
            "description": "Install curated bundles of app and game controls in one tap."
        },
        "connections": {
            "title": "Game & App Connections",
            "description": "Discover games and apps you can control with Cephable, like Call of Duty: Black Ops 7."
        },
        "aiSkillsMarketplace": {
            "title": "AI Skills Marketplace",
            "description": "Browse and install skills shared by the community."
        },
        "copyLink": "Copy link",
        "detail": {
            "access": {
                "developer": "Developer",
                "employee": "Employee",
                "plus": "Plus",
                "student": "Student"
            },
            "by": "by",
            "categories": "Categories",
            "featured": "Featured",
            "installing": "Installing…",
            "size": "Download size",
            "transport": "Transport",
            "version": "Version"
        },
        "discover": {
            "connectors": "Connectors",
            "coreDescription": "Cameras, gamepads, companion apps, and developer tools built into Cephable.",
            "coreTitle": "Cephable features",
            "description": "Official and community skills and connectors to extend the Cephable assistant.",
            "empty": "Nothing to show yet. Browse Skills or Connectors to add your own.",
            "exploreFeatures": "Explore features",
            "featured": "Featured",
            "newest": "New & noteworthy",
            "skills": "Skills",
            "title": "Discover",
            "viewAll": "View all"
        },
        "features": {
            "description": "Built-in ways to control Cephable — cameras, controllers, companion apps, and developer tools.",
            "title": "Cephable features",
            "searchPlaceholder": "Search features…"
        },
        "install": "Install",
        "installError": "Could not install.",
        "installed": "Installed",
        "linkCopied": "Link copied",
        "provenance": {
            "cephable": "Cephable",
            "mine": "Mine",
            "organization": "Your Organization",
            "thirdParty": "Third Party"
        },
        "managedBy": "Managed by {{provenance}}",
        "integrationType": {
            "cephable": "official integration",
            "mine": "personal integration",
            "organization": "organization integration",
            "thirdParty": "third-party integration"
        },
        "installedPage": {
            "connectors": "Connectors",
            "description": "Skills and connectors you’ve added. Open one to manage or remove it.",
            "empty": "You haven’t added any skills or connectors yet.",
            "manage": "Manage",
            "skills": "Skills",
            "title": "Installed",
            "searchPlaceholder": "Search installed extensions…"
        },
        "publish": {
            "title": {
                "mcp": "Share this MCP connector",
                "skill": "Share this skill"
            },
            "shareWith": "Who can access this",
            "target": {
                "organization": "People in my organization",
                "public": "Everyone (public marketplace)"
            },
            "chooseOrganization": "Choose an organization",
            "yourOrganization": "your organization",
            "publicRestricted": "Publishing to Cephable marketplace for public use denied. Please share within your organization.",
            "audience": {
                "public": "Once the Cephable team approves it, anyone using Cephable will be able to find, view, and install this. Choose your words and icons accordingly.",
                "organization": "Everyone in {{org}} will be able to find and install this."
            },
            "displayName": "Display name",
            "shortDescription": "Short description",
            "shortDescriptionHelp": "A one-line summary shown in listings.",
            "description": "Description",
            "iconUrl": "Icon URL",
            "darkModeIconUrl": "Dark mode icon URL",
            "categories": "Categories",
            "categoriesHelp": "Comma-separated (e.g. productivity, writing).",
            "version": "Version",
            "versionHelp": "Leave blank to bump automatically.",
            "secretNote": {
                "mcp": "Only the non-secret connection details are shared. Your API keys, tokens, and other credentials stay on this device — people who install it enter their own.",
                "skill": "The skill’s files and instructions are shared as-is. Remove anything private before publishing."
            },
            "confirm": "Publish",
            "submitConfirm": "Submit for review",
            "reviewNote": "Public submissions are reviewed by the Cephable team before they appear in the marketplace. You’ll see the status on your item, and we’ll email you once it’s been reviewed.",
            "notes": "Notes for the reviewer (optional)",
            "notesHelp": "Anything that helps us review — what it does, and what changed since last time.",
            "inReview": "This is already awaiting review. Withdraw the current submission to make changes and submit it again.",
            "withdraw": "Withdraw submission",
            "resubmitConfirm": "Resubmit for review",
            "resubmitNote": "This wasn’t approved for public listing. Address the feedback below, then resubmit for review.",
            "previousFeedback": "Reviewer feedback"
        },
        "reviewStatus": {
            "section": "Public marketplace review",
            "reasonLabel": "Reviewer note",
            "pending": "In review",
            "published": "Published",
            "rejected": "Changes requested",
            "removed": "Removed",
            "pendingTitle": "Awaiting Cephable review before it appears in the public marketplace.",
            "publishedTitle": "Approved and listed in the public marketplace.",
            "rejectedTitle": "Not approved for public listing — see the reviewer’s note, then submit again.",
            "removedTitle": "Removed from the public marketplace by a moderator.",
            "notify": {
                "published": "“{{name}}” was approved and is now live in the marketplace.",
                "rejected": "“{{name}}” needs changes before it can be published. Open it to see the reviewer’s feedback.",
                "removed": "“{{name}}” was removed from the public marketplace."
            }
        },
        "workflowRecording": {
            "title": "Record a Workflow",
            "description": "Show Cephable how you do a task once, and it turns the recording into a skill it can run for you.",
            "previewBadge": "Preview",
            "detail": "Record a Workflow watches while you do a task yourself — the apps you switch to, the buttons and fields you click, what you type, and what you say out loud as you go. When you stop, Cephable turns the recording into an AI Skill you can review, edit, and save. The next time you ask Automate to do that kind of task, it uses the skill as a guide, taking the most direct route instead of repeating every click.",
            "howItWorks": {
                "title": "How it works",
                "record": "Start a recording from the Workspace, the Automate tab, or AI Skills, then do the task start to finish.",
                "narrate": "Talk through what you are doing and why. Your narration becomes the reasoning behind each step.",
                "review": "Stop the recording to get a draft skill. Review the steps and the description before you save it.",
                "run": "Ask Automate to do the task again. It reads the recording for reference and adapts it to what you ask for."
            },
            "captured": {
                "title": "What gets recorded",
                "description": "Your clicks, key presses, app switches, and the names and ids of the controls you use, plus your narration if a microphone is available. Everything is processed on this device. Steps that only get you somewhere, like opening a new browser tab and typing an address, are condensed into a single step. Avoid entering passwords or payment details while recording."
            },
            "whereToFind": {
                "title": "Where to find it",
                "workspace": "Workspace: the Record a Workflow band under the Create and Automate suggestions.",
                "automate": "Automate tab in the Cephable Panel: the \"Teach Cephable a workflow\" suggestion and composer menu.",
                "skills": "Extensions → AI Skills: Create skill → Record what I do."
            },
            "previewNotice": "This is a preview feature. It may change before release, and your feedback helps shape it.",
            "proRequired": "Record a Workflow is available with Cephable Professional.",
            "startAction": "Record a workflow"
        }
    },
    "skills": {
        "intro": "Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.",
        "teach": {
            "action": "Teach as skill",
            "generating": "Teaching…",
            "title": "Teach a skill",
            "heading": "Teach Cephable a new skill",
            "subheading": "Cephable turned what you just did into a reusable skill. Review and tweak it below, then save so the assistant can do this again for you — and for anyone you share it with.",
            "fromRun": "Based on: {{title}}",
            "filesTitle": "Files to include",
            "filesHelp": "These are files from your run that could make the skill repeatable. Keep the ones that should travel with the skill; turn off anything that was just this run’s data.",
            "detailsTitle": "Skill details",
            "addFile": "Add another file…",
            "include": {
                "add": "Include",
                "on": "Included — click to remove",
                "off": "Excluded — click to include"
            },
            "included": "Included",
            "origin": {
                "attached": "You provided",
                "template": "Template",
                "generated": "Run produced",
                "observed": "Gathered",
                "added": "Added by you"
            },
            "saved": "Skill saved. You can enable and share it below.",
            "error": "Could not create a skill from this run.",
            "filesError": "Some reference files could not be added: {{files}}",
            "notFound": "This draft is no longer available.",
            "backToSkills": "Back to skills"
        },
        "create": "Create skill",
        "importFolder": "Import folder",
        "importZip": "Import .zip",
        "importError": "Could not import the skill.",
        "enable": "Enable",
        "openFolder": "Open folder",
        "deleteConfirm": "Delete?",
        "emptyTitle": "No skills yet",
        "emptyBody": "Create your first skill or import one to get started.",
        "sharingComingSoon": "Sharing skills with your organization and a skills marketplace are coming soon.",
        "source": {
            "user": "Created by you",
            "imported": "Imported",
            "organization": "Organization",
            "marketplace": "Marketplace"
        },
        "bestPractices": {
            "title": "Tips for great skills",
            "description": "Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.",
            "focused": "Keep instructions short and focused on one job. Use numbered steps in the order they should happen.",
            "examples": "Add a short example of a request the skill handles and the ideal result.",
            "keywords": "Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.",
            "trust": "Only import skills from people you trust — a skill can tell the assistant to run tasks on your computer.",
            "activation": "Choose “Automatically” for skills the assistant should reach for on its own, or “Only when I choose it” for ones you want to trigger deliberately with / or @."
        },
        "editor": {
            "nameLabel": "Name",
            "namePlaceholder": "e.g. release-notes",
            "nameHelp": "Lowercase letters, numbers, and hyphens only.",
            "descriptionLabel": "Description",
            "descriptionPlaceholder": "What the skill does and when the assistant should use it.",
            "descriptionHelp": "This is how the assistant decides when to use the skill. Be specific.",
            "keywordsLabel": "Keywords (optional)",
            "keywordsPlaceholder": "comma, separated, words",
            "keywordsHelp": "Extra words that should trigger this skill (brand names, aliases, file types).",
            "instructionsLabel": "Instructions (SKILL.md)",
            "instructionsPlaceholder": "Step-by-step instructions for the assistant. Leave blank to start from a template.",
            "save": "Save changes",
            "create": "Create skill",
            "saveError": "Could not save the skill.",
            "activationLabel": "When should the assistant use this?"
        },
        "picker": {
            "title": "Skills",
            "empty": "No matching skills",
            "hint": "Type to filter skills"
        },
        "contextMenuItem": "Skill…",
        "chipRemove": "Remove skill",
        "attached": "Attached skills",
        "inUse": "Using skills:",
        "section": {
            "title": "AI Skills",
            "description": "Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."
        },
        "createDescription": "Build a reusable skill from scratch or a template.",
        "import": "Import a skill",
        "importDescription": "Add a skill from a folder or a .zip file.",
        "copy": "Copy an existing skill",
        "copyDescription": "Start from a copy of one of your skills.",
        "copyShort": "Copy",
        "editTitle": "Edit skill",
        "newTitle": "New skill",
        "templates": {
            "title": "Start from a template",
            "start": "Start from a template…",
            "applied": "Template applied — edit the details below.",
            "blank": {
                "title": "Blank",
                "summary": "Start from an empty template."
            },
            "navigateApp": {
                "title": "Navigate an app (click in steps)",
                "summary": "Tell Cephable where to click, step by step, to get through an app."
            },
            "writeText": {
                "title": "Write or insert text",
                "summary": "Draft text a certain way and type it where I am working."
            },
            "fillForm": {
                "title": "Fill out a form",
                "summary": "Fill a form field by field from details I give you."
            },
            "summarizeDoc": {
                "title": "Summarize a document",
                "summary": "Read a file and give a short, structured summary."
            }
        },
        "activation": {
            "label": "Activation",
            "auto": "Automatically when it fits",
            "autoShort": "Auto",
            "autoDescription": "The assistant picks this skill on its own when your request matches — and you can still choose it with / or @.",
            "manual": "Only when I choose it",
            "manualShort": "Manual",
            "manualDescription": "The assistant never picks this on its own — it runs only when you attach it with / or @."
        },
        "mode": {
            "label": "How this skill is used",
            "off": "Off",
            "offTooltip": "Off — this skill is never used or shown in the picker."
        },
        "viewDetails": "View details",
        "files": {
            "label": "Reference files & scripts",
            "help": "Add files your skill uses — the assistant reads references and can run scripts. Mention them in your instructions above.",
            "empty": "No files added yet.",
            "add": "Add file…",
            "remove": "Remove file",
            "addError": "Could not add the file.",
            "kind": {
                "reference": "Reference file",
                "script": "Script",
                "asset": "Asset",
                "referenceShort": "Reference",
                "scriptShort": "Script",
                "assetShort": "Asset"
            },
            "open": "Open file"
        },
        "scriptsSetting": {
            "label": "Let skills run scripts",
            "help": "When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."
        },
        "capability": {
            "script": {
                "label": "Runs scripts",
                "tooltip": "This skill can run programs on your computer — you approve each one before it runs. Only use skills you trust."
            },
            "reference": {
                "label": "Uses reference files",
                "tooltip": "This skill includes reference files the assistant can read for detail. It does not run programs on your computer."
            },
            "basic": {
                "label": "Instructions only",
                "tooltip": "This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."
            },
            "alsoReferences": "It also includes reference files it reads.",
            "scriptsOff": "Script running is currently turned off in settings."
        },
        "actions": "Skill actions",
        "body": {
            "empty": "No instructions added yet.",
            "label": "Instructions (SKILL.md)"
        },
        "importTooltip": "Import a skill from a folder or .zip file",
        "install": "Install",
        "keywords": {
            "label": "Keywords"
        },
        "marketplace": {
            "description": "Public skills shared by the community that match your search.",
            "title": "From the public marketplace"
        },
        "share": "Share",
        "shareError": "Something went wrong.",
        "sync": "Sync",
        "updateAvailable": "A newer version is available.",
        "searchPlaceholder": "Search skills…",
        "createTooltip": "Record yourself doing a task, or write the skill yourself",
        "createRecord": "Record what I do",
        "createScratch": "Start from scratch"
    },
    "mcp": {
        "section": {
            "title": "Tools",
            "description": "Connect MCP servers to give the Cephable assistant extra tools. Use them in the panel by typing / or @."
        },
        "addServer": "Add a server",
        "addServerDescription": "Connect an MCP server (command, HTTP, or SSE) to add its tools.",
        "editTitle": "Edit server",
        "newTitle": "Add server",
        "deleteConfirm": "Delete?",
        "contextMenuItem": "Tools…",
        "chipRemove": "Remove tools",
        "inUse": "Using tools:",
        "picker": {
            "title": "Skills & tools"
        },
        "mode": {
            "label": "How this server is used",
            "off": "Off",
            "offTooltip": "Off — this server is never used or shown in the picker."
        },
        "activation": {
            "auto": "Automatically when it fits",
            "autoShort": "Auto",
            "autoDescription": "The assistant loads this server's tools on its own when your request matches — and you can still choose it with / or @.",
            "manual": "Only when I choose it",
            "manualShort": "Manual",
            "manualDescription": "The assistant never loads it on its own — only when you attach it with / or @."
        },
        "transport": {
            "stdio": "Command (stdio)",
            "http": "HTTP",
            "sse": "SSE"
        },
        "auth": {
            "none": "None",
            "apiKey": "API key",
            "headers": "Custom headers",
            "oauth": "OAuth"
        },
        "requireApproval": {
            "short": "Approve calls",
            "tooltip": "When on, you approve every tool call from this server before it runs."
        },
        "oauth": {
            "connect": "Connect",
            "reconnect": "Reconnect",
            "disconnect": "Disconnect",
            "connecting": "Waiting for browser…",
            "connected": "Connected",
            "notConnected": "Not connected",
            "error": "Authorization failed."
        },
        "status": {
            "error": "Failed",
            "label": "Connection",
            "ok": "Connected",
            "testing": "Connecting…",
            "toolsEnabledOf": "{{enabled}} of {{count}} tools",
            "toolsFound": "{{count}} tools found",
            "unknown": "Not tested"
        },
        "editor": {
            "nameLabel": "Name",
            "namePlaceholder": "e.g. filesystem",
            "nameHelp": "Lowercase letters, numbers, and hyphens only.",
            "descriptionLabel": "Description",
            "descriptionPlaceholder": "What this server provides and when the assistant should use it.",
            "descriptionHelp": "This is how the assistant decides when to use it. Be specific.",
            "transportLabel": "Connection type",
            "commandLabel": "Command",
            "argsLabel": "Arguments",
            "argsHelp": "Space-separated arguments passed to the command.",
            "envLabel": "Environment variables",
            "envHelp": "One KEY=value per line.",
            "urlLabel": "Server URL",
            "authLabel": "Authentication",
            "apiKeyHeaderLabel": "Header name",
            "apiKeyPrefixLabel": "Value prefix",
            "apiKeyLabel": "API key",
            "secretSet": "•••••••• (stored — type to replace)",
            "oauthClientIdLabel": "Client ID",
            "oauthClientIdHelp": "Leave blank to auto-register if supported.",
            "oauthClientSecretLabel": "Client secret",
            "oauthScopesLabel": "Scopes",
            "oauthScopesHelp": "Space-separated scopes to request.",
            "oauthDiscoveryLabel": "Discovery URL (optional)",
            "oauthAuthUrlLabel": "Authorization URL",
            "oauthTokenUrlLabel": "Token URL",
            "redirectLabel": "Redirect URI",
            "redirectHelp": "Most servers register automatically — just leave Client ID blank and click Connect. If the provider asks for a redirect URI, pick the callback type it accepts and register the URI below.",
            "redirectTypeLabel": "Callback type",
            "redirectType": {
                "appCallback": "Web (https)",
                "localhost": "Localhost"
            },
            "redirectPortLabel": "Port",
            "redirectNotes": {
                "appCallback": "Signing in opens your browser, then hands control back to the Cephable app automatically.",
                "localhost": "Signing in opens your browser and returns to Cephable through this port. It is open only while you sign in, and only on this device."
            },
            "headersHelp": "Custom header auth isn't editable here yet; use API key or OAuth for authenticated servers.",
            "activationLabel": "When should the assistant use this?",
            "requireApprovalLabel": "Require approval for each tool call",
            "requireApprovalHelp": "When on, you approve every tool call from this server before it runs. Recommended for servers that can change data or spend money.",
            "testConnection": "Test connection",
            "save": "Save changes",
            "create": "Add server",
            "saveError": "Could not save the server.",
            "oauthDiscoveryHelp": "Optional — leave blank to use the server’s own discovery document.",
            "oauthDiscoveryLabelShort": "Discovery URL",
            "oauthOnDevice": "Each member completes OAuth sign-in on their own device when they enable this connector.",
            "secretsOnDevice": "Each member enters their own API key on their device when they enable this connector — keys are never stored here.",
            "noPermissions": "This server uses {{provenance}}'s registered app. Click the button to customize, or Connect to start using.",
            "altOptions": {
                "copy": "Use my own credentials",
                "organization": "Cephable Portal"
            },
            "copyName": "{{name}}-copy"
        },
        "actions": "Server actions",
        "marketplace": {
            "description": "Public connectors shared by the community that match your search.",
            "title": "From the public marketplace"
        },
        "share": "Share",
        "shareError": "Something went wrong.",
        "sync": "Sync",
        "tools": {
            "allToolsLabel": "for all tools",
            "contextLabel": "of context",
            "disableAll": "Disable all",
            "disableSelected": "Disable selected",
            "empty": "No tools yet — test the connection to discover them.",
            "enableAll": "Enable all",
            "enableSelected": "Enable selected",
            "help": "Turn off tools you don’t need. Fewer tools use less of the assistant’s context window, which keeps it fast and focused.",
            "label": "Tools",
            "searchPlaceholder": "Search tools…",
            "tokens": "~{{tokens}} tok",
            "tokensLabel": "tokens"
        },
        "updateAvailable": "An updated version is available.",
        "searchPlaceholder": "Search connectors…"
    },
    "menu": {
        "expand": "Expand menu"
    },
    "no": "No",
    "rating": {
        "review": {
            "comment": "Comment",
            "commentPlaceholder": "What did you like or dislike? How did you use it?",
            "optional": "(optional)",
            "submit": "Submit review",
            "subtitle": "Share your experience with <strong>{{subject}}</strong>.",
            "title": "Rate & review",
            "write": "Write a review",
            "yourRating": "Your rating"
        },
        "summary": {
            "comments": "comments",
            "installs": "installs",
            "noRatings": "No ratings yet",
            "openReview": "Rate & review",
            "ratingCount": "{{count}} ratings"
        }
    },
    "workflow": {
        "feedback": {
            "includeDetails": "Share my prompt and tool names to help diagnose this run",
            "negative": "Thumbs down",
            "placeholder": "Tell us more (optional)",
            "positive": "Thumbs up",
            "question": "How did this workflow go?",
            "report": "Report an issue",
            "send": "Send feedback",
            "thanks": "Thanks for your feedback."
        }
    },
    "yes": "Yes",
    "keyboardService": {
        "unavailable": {
            "title": "Keyboard and mouse control stopped",
            "recovering": "Cephable is restarting it. Your commands will work again in a moment.",
            "stalled": "Cephable could not restart it. Try your command again, or restart Cephable if it keeps failing.",
            "permissionTitle": "Cephable cannot control this app",
            "permission": "Grant Cephable access under System Settings > Privacy & Security > {{pane}}, then try your command again.",
            "permissionWindows": "Windows blocks apps from controlling programs that run as an administrator. Close and reopen Cephable as an administrator, or reopen the other app without administrator rights. Windows security prompts and the lock screen can never be controlled. On a work device, your IT administrator may be blocking this."
        },
        "restored": "Keyboard and mouse control is working again."
    },
    "macPermissions": {
        "openSettings": "Open Settings",
        "pane": {
            "accessibility": "Accessibility",
            "deviceControl": "Device Control and Data Access",
            "inputMonitoring": "Input Monitoring",
            "filesAndFolders": "Files & Folders",
            "fullDiskAccess": "Full Disk Access",
            "camera": "Camera",
            "microphone": "Microphone",
            "screenRecording": "Screen Recording"
        }
    },
    "backgroundCapture": {
        "title": "Background Content",
        "capturing": "Storing content in the background...",
        "tooltip": "Content that couldn't be typed and is stored for the current session. It will disappear when you quit Cephable.",
        "nothingToPaste": "There is no background content to paste.",
        "pasteNotPermitted": "Unable to paste. Action not permitted due to the current focus.",
        "pasteFailed": "Unable to paste background content."
    }
}
